const testSched_9Day_num1 = [
  {
    "rId": "2882",
    "class": "Resource",
    "name": "Kishner Warren",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248197",
        "title": "Regular Work Day",
        "myDayComment": "TEST MY DAY COMMENT",
        "dayOff": null,
        "tour": {
          "tourId": "10861184",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "PLEASE COVER AL HECK FOR ELECTION REHEARSALS TILL HE GETS HERE SOMEWHERE AROUND AROUND 5 530?",
          "tourComment": "conf kp",
          "myTourComment": "TEST MY TOUR COMMENT",
          "tourIndicator": "TEST INDICATORS",
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852078",
            "mealTime": 1563588000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136392",
              "startTime": 1563573600,
              "endTime": 1563588000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248198",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861185",
          "startTime": 1563649200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563649200,
            "endTime": 1563681600
          },
          "assignments": [
            {
              "jeId": "12135811",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137157",
              "startTime": 1563649200,
              "endTime": 1563663600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137184",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248199",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861186",
          "startTime": 1563742800,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "pedcam/ 4E FLASHCAM",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563742800,
            "endTime": 1563778800
          }
        }
      }
    ]
  },
  {
    "rId": "2907",
    "class": "Resource",
    "name": "CARROLL THOMAS",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "4685",
    "class": "Resource",
    "name": "Jambeck Steven",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "5583",
    "class": "Resource",
    "name": "Wallace Edward",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248273",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861259",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852150",
            "mealTime": 1563300000,
            "red": false
          },
          "overtime": {
            "startTime": 1563282000,
            "endTime": 1563310800
          },
          "assignments": [
            {
              "jeId": "12136722",
              "startTime": 1563282000,
              "endTime": 1563310800,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786347",
              "jobId": "5083558",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248274",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861260",
          "startTime": 1563368400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135682",
              "startTime": 1563368400,
              "endTime": 1563386400,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12137477",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248275",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861261",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563487200
          },
          "assignments": [
            {
              "jeId": "12136680",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "Camera Ped",
              "activityType": "1291A5",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248276",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861262",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "6a prep, 7am live ped",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135714",
              "startTime": 1563530400,
              "endTime": 1563537600,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12136370",
              "startTime": 1563541200,
              "endTime": 1563559200,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16248277",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861263",
          "startTime": 1563642000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "PEDCAM/ ",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137170",
              "startTime": 1563656400,
              "endTime": 1563667200,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137405",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137489",
              "startTime": 1563667200,
              "endTime": 1563670800,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786433",
              "jobId": "5083644",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "3A STUDIO Ped/ Jib"
            }
          ]
        }
      },
      {
        "rdtId": "16248278",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861264",
          "startTime": 1563757200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "  PED 3A STUDIO",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563757200,
            "endTime": 1563793200
          },
          "assignments": [
            {
              "jeId": "12137512",
              "startTime": 1563757200,
              "endTime": 1563775200,
              "service": "Camera Ped",
              "activityType": "1291A5",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "6494",
    "class": "Resource",
    "name": "Cangialosi Paul",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248626",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861585",
          "startTime": 1563199200,
          "duration": 10.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852471",
            "mealTime": 1563234300,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563237900
          },
          "assignments": [
            {
              "jeId": "12136730",
              "startTime": 1563224400,
              "endTime": 1563234300,
              "service": "Camera Robo Nightly News",
              "activityType": "1291A5",
              "requestNumber": "3786352",
              "jobId": "5083563",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136998",
              "startTime": 1563199200,
              "endTime": 1563211800,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            },
            {
              "jeId": "12137736",
              "startTime": 1563216300,
              "endTime": 1563224400,
              "service": "PD",
              "activityType": "1291A5",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248627",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861586",
          "startTime": 1563270300,
          "duration": 15.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563270300,
            "endTime": 1563326100
          },
          "assignments": [
            {
              "jeId": "12137766",
              "startTime": 1563270300,
              "endTime": 1563296400,
              "service": "Camera Ped Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786472",
              "jobId": "5083683",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248628",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861587",
          "startTime": 1563382800,
          "duration": 10.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563382800,
            "endTime": 1563420600
          }
        }
      },
      {
        "rdtId": "16248629",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861588",
          "startTime": 1563462900,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563462900,
            "endTime": 1563513300
          }
        }
      },
      {
        "rdtId": "16248630",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861589",
          "startTime": 1563541200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248631",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861590",
          "startTime": 1563631200,
          "duration": 9.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136024",
              "startTime": 1563660000,
              "endTime": 1563666300,
              "service": "Camera Ped",
              "activityType": "1291A5",
              "requestNumber": "3786264",
              "jobId": "5083475",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248632",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861591",
          "startTime": 1563724800,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563724800,
            "endTime": 1563775200
          }
        }
      }
    ]
  },
  {
    "rId": "7362",
    "class": "Resource",
    "name": "LEE KENON",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248781",
        "title": "ILL Day {= 11 STAFF ONLY",
        "myDayComment": "TEST MY DAY COMMENT",
        "dayOff": {
          "dorId": "0",
          "title": "ILL Day {= 11 STAFF ONLY",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": "TEST COMMENT"
        }
      },
      {
        "rdtId": "16248782",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861717",
          "startTime": 1563255000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9852601",
            "mealTime": 1563255000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136473",
              "startTime": 1563278400,
              "endTime": 1563283800,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12137980",
              "startTime": 1563255000,
              "endTime": 1563278400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786495",
              "jobId": "5083706",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248783",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861718",
          "startTime": 1563341400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563341400,
            "endTime": 1563370200
          },
          "assignments": [
            {
              "jeId": "12135937",
              "startTime": 1563341400,
              "endTime": 1563364800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786244",
              "jobId": "5083455",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248784",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861719",
          "startTime": 1563600600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137850",
              "startTime": 1563600600,
              "endTime": 1563625800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786480",
              "jobId": "5083691",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248785",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861720",
          "startTime": 1563687000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563687000,
            "endTime": 1563715800
          },
          "assignments": [
            {
              "jeId": "12137189",
              "startTime": 1563687000,
              "endTime": 1563710400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786399",
              "jobId": "5083610",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137200",
              "startTime": 1563710400,
              "endTime": 1563714000,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7388",
    "class": "Resource",
    "name": "TAYLOR JEFF",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248127",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861119",
          "startTime": 1563195600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852015",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136966",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786376",
              "jobId": "5083587",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136967",
              "startTime": 1563195600,
              "endTime": 1563199200,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786376",
              "jobId": "5083587",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136968",
              "startTime": 1563202800,
              "endTime": 1563209100,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786376",
              "jobId": "5083587",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136991",
              "startTime": 1563199200,
              "endTime": 1563202800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            },
            {
              "jeId": "12137703",
              "startTime": 1563209100,
              "endTime": 1563213600,
              "service": "Video & LD 1 PM",
              "activityType": "148C",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248128",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861120",
          "startTime": 1563296400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136655",
              "startTime": 1563310800,
              "endTime": 1563325200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786335",
              "jobId": "5083546",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": "lighting test- 3A sdo",
              "comment": null
            },
            {
              "jeId": "12137958",
              "startTime": 1563305400,
              "endTime": 1563310800,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248129",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861121",
          "startTime": 1563368400,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563368400,
            "endTime": 1563411600
          },
          "assignments": [
            {
              "jeId": "12135944",
              "startTime": 1563368400,
              "endTime": 1563372000,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786245",
              "jobId": "5083456",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248130",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861122",
          "startTime": 1563472800,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 10/30 - KC",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136662",
              "startTime": 1563472800,
              "endTime": 1563487200,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12136681",
              "startTime": 1563487200,
              "endTime": 1563503400,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786337",
              "jobId": "5083548",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Lighting Testing / Scenic Install and Completion - STUDIO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248131",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861123",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "TBD HOURS",
          "tourComment": "BKD 10/30 - KC",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137466",
              "startTime": 1563562800,
              "endTime": 1563591600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786428",
              "jobId": "5083639",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248132",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861124",
          "startTime": 1563642000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/30 - KC",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137554",
              "startTime": 1563652800,
              "endTime": 1563663600,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786439",
              "jobId": "5083650",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELEX BLOCKING 3A STUDIO / 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16248133",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861125",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/30 - KC",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137504",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7390",
    "class": "Resource",
    "name": "GONZALEZ JOHN",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248047",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861051",
          "startTime": 1563170400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9851947",
            "mealTime": 1563196500,
            "red": false
          },
          "overtime": {
            "startTime": 1563170400,
            "endTime": 1563199200
          },
          "assignments": [
            {
              "jeId": "12136906",
              "startTime": 1563170400,
              "endTime": 1563196500,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            }
          ]
        }
      },
      {
        "rdtId": "16248048",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861052",
          "startTime": 1563256800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563256800,
            "endTime": 1563285600
          },
          "assignments": [
            {
              "jeId": "12136467",
              "startTime": 1563256800,
              "endTime": 1563283800,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248049",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861053",
          "startTime": 1563343200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248050",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861054",
          "startTime": 1563602400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137111",
              "startTime": 1563602400,
              "endTime": 1563629400,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248051",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861055",
          "startTime": 1563688800,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563688800,
            "endTime": 1563724800
          },
          "assignments": [
            {
              "jeId": "12136611",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137195",
              "startTime": 1563688800,
              "endTime": 1563714000,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7407",
    "class": "Resource",
    "name": "ZEITCHICK BRIAN",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247774",
        "title": "Remote Asn (ST)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860817",
          "startTime": 1563202800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "REMOTE ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851718",
            "mealTime": 1563202800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135985",
              "startTime": 1563206400,
              "endTime": 1563231600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786255",
              "jobId": "5083466",
              "costObject": "MSNBC Hardball Houston 2018",
              "costObjectNumber": "NM-S18.032",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247775",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860818",
          "startTime": 1563300000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135896",
              "startTime": 1563321600,
              "endTime": 1563328800,
              "service": "TD MADDOW",
              "activityType": "149N",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136513",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "TD 3 PM",
              "activityType": "149N",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12136533",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "TD HARDBALL",
              "activityType": "149N",
              "requestNumber": "3786318",
              "jobId": "5083529",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            }
          ]
        }
      },
      {
        "rdtId": "16247776",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860819",
          "startTime": 1563382800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/1 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135919",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "TD 2 PM",
              "activityType": "149N",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136575",
              "startTime": 1563400800,
              "endTime": 1563408000,
              "service": "TD HARDBALL",
              "activityType": "149N",
              "requestNumber": "3786323",
              "jobId": "5083534",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            }
          ]
        }
      },
      {
        "rdtId": "16247777",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860820",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16247778",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860821",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137413",
              "startTime": 1563638400,
              "endTime": 1563652800,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137546",
              "startTime": 1563624000,
              "endTime": 1563638400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786438",
              "jobId": "5083649",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal CR 8H / 3E Flash"
            }
          ]
        }
      },
      {
        "rdtId": "16247779",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860822",
          "startTime": 1563739200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563739200,
            "endTime": 1563778800
          },
          "assignments": [
            {
              "jeId": "12136597",
              "startTime": 1563739200,
              "endTime": 1563768000,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7408",
    "class": "Resource",
    "name": "COLON IVELISSE",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248637",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861596",
          "startTime": 1563168600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852480",
            "mealTime": 1563195600,
            "red": false
          },
          "overtime": {
            "startTime": 1563168600,
            "endTime": 1563197400
          },
          "assignments": [
            {
              "jeId": "12135665",
              "startTime": 1563192000,
              "endTime": 1563195600,
              "service": "6E Op",
              "activityType": "148E",
              "requestNumber": "3786213",
              "jobId": "5083424",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": "COVER JOHN SULLIVAN'S MEAL 8A-9A",
              "comment": null
            },
            {
              "jeId": "12136247",
              "startTime": 1563168600,
              "endTime": 1563192000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786285",
              "jobId": "5083496",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248638",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861597",
          "startTime": 1563255000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563255000,
            "endTime": 1563283800
          },
          "assignments": [
            {
              "jeId": "12136282",
              "startTime": 1563278400,
              "endTime": 1563282000,
              "service": "6E Op",
              "activityType": "148E",
              "requestNumber": "3786290",
              "jobId": "5083501",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": "COVER JOHN SULLIVAN'S MEAL 8A-9A",
              "comment": null
            },
            {
              "jeId": "12137978",
              "startTime": 1563255000,
              "endTime": 1563278400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786495",
              "jobId": "5083706",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248639",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861598",
          "startTime": 1563341400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563341400,
            "endTime": 1563370200
          },
          "assignments": [
            {
              "jeId": "12135667",
              "startTime": 1563364800,
              "endTime": 1563368400,
              "service": "6E Op",
              "activityType": "148E",
              "requestNumber": "3786214",
              "jobId": "5083425",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": "COVER JOHN SULLIVAN'S MEAL 8A-9A",
              "comment": null
            },
            {
              "jeId": "12135935",
              "startTime": 1563341400,
              "endTime": 1563364800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786244",
              "jobId": "5083455",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248640",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861599",
          "startTime": 1563600600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137848",
              "startTime": 1563600600,
              "endTime": 1563625800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786480",
              "jobId": "5083691",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248641",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861600",
          "startTime": 1563687000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137187",
              "startTime": 1563687000,
              "endTime": 1563710400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786399",
              "jobId": "5083610",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7410",
    "class": "Resource",
    "name": "REICHLE JOHN",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248095",
        "title": "Comp Day Used",
        "myDayComment": "spending vaca days",
        "dayOff": {
          "dorId": "0",
          "title": "Comp Day Used",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": "spending vaca days"
        },
        "tour": null
      },
      {
        "rdtId": "16248096",
        "title": "Comp Day Used",
        "myDayComment": "spending vaca days",
        "dayOff": {
          "dorId": "0",
          "title": "Comp Day Used",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": "spending vaca days"
        },
        "tour": null
      },
      {
        "rdtId": "16248097",
        "title": "Comp Day Used",
        "myDayComment": "spending vaca days",
        "dayOff": {
          "dorId": "0",
          "title": "Comp Day Used",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": "spending vaca days"
        },
        "tour": null
      },
      {
        "rdtId": "16248098",
        "title": "ILL Day {= 11 STAFF ONLY",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "ILL Day {= 11 STAFF ONLY",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248099",
        "title": "ILL Day {= 11 STAFF ONLY",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "ILL Day {= 11 STAFF ONLY",
          "startTime": 1563681600,
          "endTime": 1563767940,
          "comment": null
        },
        "tour": null
      }
    ]
  },
  {
    "rId": "7411",
    "class": "Resource",
    "name": "BIELLO JOE",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248589",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861553",
          "startTime": 1563177600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9852442",
            "mealTime": 1563202800,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136907",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136908",
              "startTime": 1563177600,
              "endTime": 1563192000,
              "service": "ST 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12137700",
              "startTime": 1563199200,
              "endTime": 1563202800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            }
          ]
        }
      },
      {
        "rdtId": "16248590",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861554",
          "startTime": 1563264000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135891",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136468",
              "startTime": 1563264000,
              "endTime": 1563278400,
              "service": "ST 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136499",
              "startTime": 1563285600,
              "endTime": 1563289200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            }
          ]
        }
      },
      {
        "rdtId": "16248591",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861555",
          "startTime": 1563350400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136550",
              "startTime": 1563372000,
              "endTime": 1563375600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12137364",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248592",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861556",
          "startTime": 1563606000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135758",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137112",
              "startTime": 1563606000,
              "endTime": 1563624000,
              "service": "ST 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248593",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861557",
          "startTime": 1563696000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136620",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": "SET U P 8H",
              "comment": null
            },
            {
              "jeId": "12137196",
              "startTime": 1563696000,
              "endTime": 1563710400,
              "service": "ST 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7412",
    "class": "Resource",
    "name": "LIPMAN JENNIFER",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248788",
        "title": "Jury Duty",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Jury Duty",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248789",
        "title": "Jury Duty",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Jury Duty",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        }
      },
      {
        "rdtId": "16248790",
        "title": "Jury Duty",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Jury Duty",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248791",
        "title": "Jury Duty",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Jury Duty",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        }
      },
      {
        "rdtId": "16248792",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861722",
          "startTime": 1563701400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9852606",
            "mealTime": 1563726600,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136616",
              "startTime": 1563714000,
              "endTime": 1563726600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137201",
              "startTime": 1563701400,
              "endTime": 1563714000,
              "service": "SM 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7416",
    "class": "Resource",
    "name": "WIUFF ROBERT",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247964",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860983",
          "startTime": 1563177600,
          "duration": 10.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9851879",
            "mealTime": 1563210900,
            "red": false
          },
          "overtime": {
            "startTime": 1563177600,
            "endTime": 1563214500
          },
          "assignments": [
            {
              "jeId": "12136912",
              "startTime": 1563177600,
              "endTime": 1563195600,
              "service": "JB 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            }
          ]
        }
      },
      {
        "rdtId": "16247965",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860984",
          "startTime": 1563264000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "texted",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136477",
              "startTime": 1563264000,
              "endTime": 1563282900,
              "service": "JB 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136495",
              "startTime": 1563282900,
              "endTime": 1563289200,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            }
          ]
        }
      },
      {
        "rdtId": "16247966",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860985",
          "startTime": 1563350400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136546",
              "startTime": 1563371100,
              "endTime": 1563375600,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            }
          ]
        }
      },
      {
        "rdtId": "16247967",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860986",
          "startTime": 1563606000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137121",
              "startTime": 1563606000,
              "endTime": 1563631200,
              "service": "JB 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16247968",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860987",
          "startTime": 1563696000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136613",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137204",
              "startTime": 1563696000,
              "endTime": 1563714000,
              "service": "JB 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7418",
    "class": "Resource",
    "name": "FEDERICO MICHAEL",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248675",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248676",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861633",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852517",
            "mealTime": 1563303600,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135873",
              "startTime": 1563299100,
              "endTime": 1563303600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136471",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136502",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137944",
              "startTime": 1563292800,
              "endTime": 1563299100,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786491",
              "jobId": "5083702",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "SHARPTON RADIO - 7th FLOOR RADIO ROOM #764S-3",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248677",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861634",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135926",
              "startTime": 1563384600,
              "endTime": 1563390000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136595",
              "startTime": 1563379200,
              "endTime": 1563384600,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786325",
              "jobId": "5083536",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "SHARPTON RADIO - 7th FLOOR RADIO ROOM #764S-3",
              "comment": null
            },
            {
              "jeId": "12137366",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248678",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861635",
          "startTime": 1563537600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137452",
              "startTime": 1563537600,
              "endTime": 1563555600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137847",
              "startTime": 1563555600,
              "endTime": 1563562800,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248679",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861636",
          "startTime": 1563624000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563624000,
            "endTime": 1563660000
          },
          "assignments": [
            {
              "jeId": "12135789",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136399",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137085",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137115",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137155",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248680",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861637",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135824",
              "startTime": 1563728400,
              "endTime": 1563735600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12135856",
              "startTime": 1563724800,
              "endTime": 1563729300,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786233",
              "jobId": "5083444",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "SHARPTON RADIO - 7th FLOOR RADIO ROOM #764S-3",
              "comment": null
            },
            {
              "jeId": "12137198",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137918",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248881",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861789",
          "startTime": 1563771600,
          "duration": 7,
          "remainDuration": null,
          "notificationComment": "A2 3A STUDIO",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      }
    ]
  },
  {
    "rId": "7419",
    "class": "Resource",
    "name": "WORMLEY DONALD",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247971",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860990",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851886",
            "mealTime": 1563199200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136215",
              "startTime": 1563202800,
              "endTime": 1563210000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136262",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136957",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137707",
              "startTime": 1563210000,
              "endTime": 1563213600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247972",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860991",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136624",
              "startTime": 1563292800,
              "endTime": 1563303600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786328",
              "jobId": "5083539",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            },
            {
              "jeId": "12137303",
              "startTime": 1563303600,
              "endTime": 1563307200,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137304",
              "startTime": 1563282000,
              "endTime": 1563292800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247973",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16247974",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860992",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "PEDCAM DAYSIDE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135759",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135766",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136401",
              "startTime": 1563642000,
              "endTime": 1563645600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137084",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137863",
              "startTime": 1563631200,
              "endTime": 1563634800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16247975",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860993",
          "startTime": 1563710400,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563710400,
            "endTime": 1563746400
          },
          "assignments": [
            {
              "jeId": "12135839",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12135850",
              "startTime": 1563732000,
              "endTime": 1563739200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137223",
              "startTime": 1563717600,
              "endTime": 1563721200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137902",
              "startTime": 1563724800,
              "endTime": 1563732000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137938",
              "startTime": 1563739200,
              "endTime": 1563746400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7426",
    "class": "Resource",
    "name": "YOUNG MICHAEL",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247978",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860996",
          "startTime": 1563220800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851892",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135991",
              "startTime": 1563242400,
              "endTime": 1563244200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786256",
              "jobId": "5083467",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11th Hour Looksee - CR 2K / Plaza Prod Nook #4"
            },
            {
              "jeId": "12136267",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "RB 3A MD",
              "activityType": "148E",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136930",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12136962",
              "startTime": 1563231600,
              "endTime": 1563235200,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786375",
              "jobId": "5083586",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137758",
              "startTime": 1563244200,
              "endTime": 1563249600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247979",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860997",
          "startTime": 1563307200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563307200,
            "endTime": 1563343200
          },
          "assignments": [
            {
              "jeId": "12135901",
              "startTime": 1563321600,
              "endTime": 1563328800,
              "service": "RB 3A MD",
              "activityType": "148E",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136536",
              "startTime": 1563318000,
              "endTime": 1563321600,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786318",
              "jobId": "5083529",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137271",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137444",
              "startTime": 1563336000,
              "endTime": 1563343200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786425",
              "jobId": "5083636",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            },
            {
              "jeId": "12137995",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247980",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860998",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136578",
              "startTime": 1563404400,
              "endTime": 1563408000,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786323",
              "jobId": "5083534",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12136591",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247981",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860999",
          "startTime": 1563458400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136664",
              "startTime": 1563458400,
              "endTime": 1563487200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247982",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861000",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "check with TM about meal 3pm in time confirmed CM",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135998",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247983",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861001",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135810",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137087",
              "startTime": 1563656400,
              "endTime": 1563660000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137162",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137177",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "RB 3A MD",
              "activityType": "148E",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16247984",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861002",
          "startTime": 1563732000,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": "ROBO 3A STUDIO",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563778800
          },
          "assignments": [
            {
              "jeId": "12137514",
              "startTime": 1563732000,
              "endTime": 1563778800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7429",
    "class": "Resource",
    "name": "NEUGENT ALLEN",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248832",
        "title": "Remote Asn (ST)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861748",
          "startTime": 1563199200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "REMOTE ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852632",
            "mealTime": 1563210000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135984",
              "startTime": 1563199200,
              "endTime": 1563228000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786255",
              "jobId": "5083466",
              "costObject": "MSNBC Hardball Houston 2018",
              "costObjectNumber": "NM-S18.032",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248833",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861749",
          "startTime": 1563262200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135892",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136474",
              "startTime": 1563269400,
              "endTime": 1563278400,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136475",
              "startTime": 1563262200,
              "endTime": 1563269400,
              "service": "SM 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "SM/UTIL",
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248834",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861750",
          "startTime": 1563348600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "COVER ALL MJ ROBO",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137365",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248835",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861751",
          "startTime": 1563606000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137118",
              "startTime": 1563615000,
              "endTime": 1563629400,
              "service": "SM 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137119",
              "startTime": 1563606000,
              "endTime": 1563615000,
              "service": "SM 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "SM/ UTIL",
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248836",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861752",
          "startTime": 1563694200,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": "COVERS JEN",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563694200,
            "endTime": 1563724800
          },
          "assignments": [
            {
              "jeId": "12136617",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137202",
              "startTime": 1563701400,
              "endTime": 1563710400,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137203",
              "startTime": 1563694200,
              "endTime": 1563701400,
              "service": "SM 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "SM/UTIL",
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7430",
    "class": "Resource",
    "name": "Zeidman Anna",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247987",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16247988",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        }
      },
      {
        "rdtId": "16247989",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16247990",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861005",
          "startTime": 1563447600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851901",
            "mealTime": 1563465600,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135692",
              "startTime": 1563469200,
              "endTime": 1563476400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786218",
              "jobId": "5083429",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136338",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137790",
              "startTime": 1563447600,
              "endTime": 1563459300,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            },
            {
              "jeId": "12137796",
              "startTime": 1563459300,
              "endTime": 1563465600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16247991",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861006",
          "startTime": 1563530400,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135705",
              "startTime": 1563530400,
              "endTime": 1563535800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12135721",
              "startTime": 1563535800,
              "endTime": 1563541200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136356",
              "startTime": 1563541200,
              "endTime": 1563544800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136361",
              "startTime": 1563544800,
              "endTime": 1563552000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137062",
              "startTime": 1563555600,
              "endTime": 1563562800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137071",
              "startTime": 1563562800,
              "endTime": 1563566400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16247992",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        }
      },
      {
        "rdtId": "16247993",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861007",
          "startTime": 1563714000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136459",
              "startTime": 1563735600,
              "endTime": 1563750000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12136614",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137900",
              "startTime": 1563724800,
              "endTime": 1563732000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7476",
    "class": "Resource",
    "name": "KAHLE JAMES",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247725",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860770",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851672",
            "mealTime": 1563217200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135658",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "TD 11 AM",
              "activityType": "149N",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136203",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6212",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136232",
              "startTime": 1563206400,
              "endTime": 1563210000,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12136945",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "TD 9 AM",
              "activityType": "149N",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247726",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860771",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135866",
              "startTime": 1563299100,
              "endTime": 1563303600,
              "service": "TD 2 PM",
              "activityType": "149N",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12135882",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "TD 9 AM",
              "activityType": "149N",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136506",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "TD 11 AM",
              "activityType": "149N",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137968",
              "startTime": 1563292800,
              "endTime": 1563299100,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247727",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860772",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135908",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "TD 1 PM",
              "activityType": "149N",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12135950",
              "startTime": 1563379200,
              "endTime": 1563382800,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786245",
              "jobId": "5083456",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 2K Standby",
              "comment": null
            },
            {
              "jeId": "12137354",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "TD 9 AM",
              "activityType": "149N",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137372",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "TD 11 AM",
              "activityType": "149N",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247728",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860773",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135750",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "TD 9 AM",
              "activityType": "149N",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135793",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "TD 11 AM",
              "activityType": "149N",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136406",
              "startTime": 1563644700,
              "endTime": 1563649200,
              "service": "TD 2 PM",
              "activityType": "149N",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12136427",
              "startTime": 1563642000,
              "endTime": 1563644700,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12137077",
              "startTime": 1563638400,
              "endTime": 1563642000,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6212",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247729",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860774",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135818",
              "startTime": 1563731100,
              "endTime": 1563735600,
              "service": "TD 2 PM",
              "activityType": "149N",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12135830",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "TD 9 AM",
              "activityType": "149N",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12137911",
              "startTime": 1563724800,
              "endTime": 1563728400,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12137912",
              "startTime": 1563728400,
              "endTime": 1563731100,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12137922",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "TD 11 AM",
              "activityType": "149N",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248893",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861801",
          "startTime": 1563782400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563782400,
            "endTime": 1563811200
          }
        }
      }
    ]
  },
  {
    "rId": "7478",
    "class": "Resource",
    "name": "LAWYER PRESTON",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247732",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860777",
          "startTime": 1563181200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9851679",
            "mealTime": 1563206400,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136228",
              "startTime": 1563202800,
              "endTime": 1563206400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "PROJECT WORK - DO NOT PULL",
              "comment": null
            },
            {
              "jeId": "12136911",
              "startTime": 1563181200,
              "endTime": 1563196500,
              "service": "TD MJ",
              "activityType": "149N",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "MJ LIVE 6A-9A / NO PREP",
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12137690",
              "startTime": 1563196500,
              "endTime": 1563202800,
              "service": "TD 10 AM",
              "activityType": "149N",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            }
          ]
        }
      },
      {
        "rdtId": "16247733",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860778",
          "startTime": 1563267600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136472",
              "startTime": 1563267600,
              "endTime": 1563283800,
              "service": "TD MJ",
              "activityType": "149N",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "MJ LIVE 6A-9A / NO PREP",
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136490",
              "startTime": 1563283800,
              "endTime": 1563289200,
              "service": "TD 10 AM",
              "activityType": "149N",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12137963",
              "startTime": 1563289200,
              "endTime": 1563292800,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "PROJECT WORK - DO NOT PULL",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247734",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860779",
          "startTime": 1563354000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135948",
              "startTime": 1563375600,
              "endTime": 1563379200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786245",
              "jobId": "5083456",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "PROJECT WORK - DO NOT PULL",
              "comment": null
            },
            {
              "jeId": "12136541",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "TD 10 AM",
              "activityType": "149N",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            }
          ]
        }
      },
      {
        "rdtId": "16247735",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860780",
          "startTime": 1563613200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136424",
              "startTime": 1563634800,
              "endTime": 1563638400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "PROJECT WORK - DO NOT PULL",
              "comment": null
            },
            {
              "jeId": "12137116",
              "startTime": 1563613200,
              "endTime": 1563629400,
              "service": "TD MJ",
              "activityType": "149N",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "MJ LIVE 6A-9A / NO PREP",
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137856",
              "startTime": 1563629400,
              "endTime": 1563634800,
              "service": "TD 10 AM",
              "activityType": "149N",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16247736",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860781",
          "startTime": 1563699600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136609",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "TD MJ",
              "activityType": "149N",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137199",
              "startTime": 1563699600,
              "endTime": 1563714000,
              "service": "TD MJ",
              "activityType": "149N",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "MJ LIVE 6A-9A / NO PREP",
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "7482",
    "class": "Resource",
    "name": "DILORENZO CARL",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248661",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861620",
          "startTime": 1563175800,
          "duration": 10.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852504",
            "mealTime": 1563175800,
            "red": false
          },
          "overtime": {
            "startTime": 1563175800,
            "endTime": 1563213600
          },
          "assignments": [
            {
              "jeId": "12136910",
              "startTime": 1563175800,
              "endTime": 1563200100,
              "service": "A2 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136997",
              "startTime": 1563199200,
              "endTime": 1563213600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248662",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861621",
          "startTime": 1563262200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136470",
              "startTime": 1563262200,
              "endTime": 1563287400,
              "service": "A2 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248663",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861622",
          "startTime": 1563348600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248664",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861623",
          "startTime": 1563606000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137114",
              "startTime": 1563606000,
              "endTime": 1563631200,
              "service": "A2 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248665",
        "title": "ILL Day {= 11 STAFF ONLY",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "ILL Day {= 11 STAFF ONLY",
          "startTime": 1563681600,
          "endTime": 1563767940,
          "comment": null
        }
      }
    ]
  },
  {
    "rId": "7487",
    "class": "Resource",
    "name": "Guess SONJA",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247819",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860856",
          "startTime": 1563163200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9851757",
            "mealTime": 1563163200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136248",
              "startTime": 1563172200,
              "endTime": 1563192000,
              "service": "Audio A1 ET",
              "activityType": "149M",
              "requestNumber": "3786285",
              "jobId": "5083496",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137737",
              "startTime": 1563166800,
              "endTime": 1563172200,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786467",
              "jobId": "5083678",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16247820",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860857",
          "startTime": 1563249600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135878",
              "startTime": 1563253200,
              "endTime": 1563258600,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786236",
              "jobId": "5083447",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12137979",
              "startTime": 1563258600,
              "endTime": 1563278400,
              "service": "Audio A1 ET",
              "activityType": "149M",
              "requestNumber": "3786495",
              "jobId": "5083706",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16247821",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860858",
          "startTime": 1563336000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135931",
              "startTime": 1563339600,
              "endTime": 1563345000,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786243",
              "jobId": "5083454",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12135936",
              "startTime": 1563345000,
              "endTime": 1563364800,
              "service": "Audio A1 ET",
              "activityType": "149M",
              "requestNumber": "3786244",
              "jobId": "5083455",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16247822",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860859",
          "startTime": 1563595200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137849",
              "startTime": 1563604200,
              "endTime": 1563624000,
              "service": "Audio A1 ET",
              "activityType": "149M",
              "requestNumber": "3786480",
              "jobId": "5083691",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137888",
              "startTime": 1563598800,
              "endTime": 1563604200,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786484",
              "jobId": "5083695",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16247823",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860860",
          "startTime": 1563681600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135814",
              "startTime": 1563685200,
              "endTime": 1563690600,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786229",
              "jobId": "5083440",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12137188",
              "startTime": 1563690600,
              "endTime": 1563710400,
              "service": "Audio A1 ET",
              "activityType": "149M",
              "requestNumber": "3786399",
              "jobId": "5083610",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "8067",
    "class": "Resource",
    "name": "SANTILLO DINA",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248110",
        "title": "Floating Hol (non-represented)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Floating Hol (non-represented)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248111",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861104",
          "startTime": 1563307200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852000",
            "mealTime": 1563307200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12137274",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "Video & LD 6 PM",
              "activityType": "148C",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137279",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "Video & LD HAYES",
              "activityType": "148C",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137293",
              "startTime": 1563325200,
              "endTime": 1563334200,
              "service": "Video & LD LAST WORD",
              "activityType": "148C",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12137971",
              "startTime": 1563334200,
              "endTime": 1563336000,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786494",
              "jobId": "5083705",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248112",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861105",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136565",
              "startTime": 1563411600,
              "endTime": 1563419700,
              "service": "Video & LD LAST WORD",
              "activityType": "148C",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136572",
              "startTime": 1563419700,
              "endTime": 1563422400,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786322",
              "jobId": "5083533",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248113",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861106",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/1 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136001",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248114",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861107",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135781",
              "startTime": 1563670800,
              "endTime": 1563679800,
              "service": "Video & LD LAST WORD",
              "activityType": "148C",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12136451",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "Video & LD 6 PM",
              "activityType": "148C",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137870",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "Video & LD HAYES",
              "activityType": "148C",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            },
            {
              "jeId": "12137880",
              "startTime": 1563679800,
              "endTime": 1563681600,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786483",
              "jobId": "5083694",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248115",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861108",
          "startTime": 1563732000,
          "duration": 12.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563777900
          },
          "assignments": [
            {
              "jeId": "12137500",
              "startTime": 1563732000,
              "endTime": 1563777900,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "8070",
    "class": "Resource",
    "name": "DEROSE FRANCO",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "8098",
    "class": "Resource",
    "name": "Pardo Victor",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247859",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860894",
          "startTime": 1563224400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "COVER KALVIN",
          "tourComment": "CNF 10/4 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9851795",
            "mealTime": 1563224400,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135644",
              "startTime": 1563238800,
              "endTime": 1563246000,
              "service": "Audio A1 Last Word",
              "activityType": "149M",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136204",
              "startTime": 1563228000,
              "endTime": 1563231600,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136236",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "Audio A1 HAYES",
              "activityType": "149M",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12136939",
              "startTime": 1563246000,
              "endTime": 1563253200,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786373",
              "jobId": "5083584",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247860",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860895",
          "startTime": 1563310800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563310800,
            "endTime": 1563343200
          },
          "assignments": [
            {
              "jeId": "12137267",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "Audio A1 6 PM",
              "activityType": "149M",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137445",
              "startTime": 1563321600,
              "endTime": 1563343200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786425",
              "jobId": "5083636",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            }
          ]
        }
      },
      {
        "rdtId": "16247861",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860896",
          "startTime": 1563379200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563379200,
            "endTime": 1563411600
          },
          "assignments": [
            {
              "jeId": "12137344",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "Audio A1 4 PM",
              "activityType": "149M",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247862",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860897",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136659",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247863",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860898",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136000",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247864",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860899",
          "startTime": 1563642000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136441",
              "startTime": 1563649200,
              "endTime": 1563656400,
              "service": "Audio A1 4 PM",
              "activityType": "149M",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136442",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "Audio A1 6 PM",
              "activityType": "149M",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137078",
              "startTime": 1563667200,
              "endTime": 1563670800,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137079",
              "startTime": 1563663600,
              "endTime": 1563667200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137080",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247865",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860900",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137498",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "9061",
    "class": "Resource",
    "name": "Hollander-Loos Felece",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248366",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861340",
          "startTime": 1563199200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852229",
            "mealTime": 1563210000,
            "red": false
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248367",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861341",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELECTION STAR AND STRIPE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248368",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861342",
          "startTime": 1563458400,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "ELECTION STAR AND STRIPE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563458400,
            "endTime": 1563501600
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248369",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861343",
          "startTime": 1563552000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "ELECTION STAR AND STRIPE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563552000,
            "endTime": 1563584400
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248370",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861344",
          "startTime": 1563609600,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "ELECTION STAR AND STRIPE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563609600,
            "endTime": 1563652800
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248371",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861345",
          "startTime": 1563696000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "ELECTION STAR AND STRIPE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563696000,
            "endTime": 1563739200
          },
          "assignments": null
        }
      }
    ]
  },
  {
    "rId": "9147",
    "class": "Resource",
    "name": "APRUZZESE JOSEPH",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248543",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861510",
          "startTime": 1563195600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852399",
            "mealTime": 1563220800,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136216",
              "startTime": 1563202800,
              "endTime": 1563210000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136261",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136928",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137696",
              "startTime": 1563195600,
              "endTime": 1563202800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            },
            {
              "jeId": "12137708",
              "startTime": 1563210000,
              "endTime": 1563213600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248544",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861511",
          "startTime": 1563282000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136523",
              "startTime": 1563302700,
              "endTime": 1563307200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137268",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137945",
              "startTime": 1563307200,
              "endTime": 1563310800,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786491",
              "jobId": "5083702",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "SHARPTON RADIO - 7th FLOOR RADIO ROOM #764S-3",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248545",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861512",
          "startTime": 1563444000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135693",
              "startTime": 1563469200,
              "endTime": 1563476400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786218",
              "jobId": "5083429",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12135701",
              "startTime": 1563476400,
              "endTime": 1563480000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136323",
              "startTime": 1563444000,
              "endTime": 1563451200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            },
            {
              "jeId": "12137020",
              "startTime": 1563468300,
              "endTime": 1563469200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137794",
              "startTime": 1563454800,
              "endTime": 1563457500,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": "ASSIST A2 WITH MHP SETUP",
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137795",
              "startTime": 1563457500,
              "endTime": 1563468300,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16248546",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861513",
          "startTime": 1563534000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135724",
              "startTime": 1563534000,
              "endTime": 1563543000,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": "SHARPTON RADIO SETUP - 8A-9:30A",
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136360",
              "startTime": 1563543000,
              "endTime": 1563552000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137063",
              "startTime": 1563555600,
              "endTime": 1563562800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248547",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861514",
          "startTime": 1563721200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136464",
              "startTime": 1563735600,
              "endTime": 1563742800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12136607",
              "startTime": 1563742800,
              "endTime": 1563760800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137230",
              "startTime": 1563721200,
              "endTime": 1563732000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "9154",
    "class": "Resource",
    "name": "Palefsky JACLYN",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248865",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248866",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861779",
          "startTime": 1563307200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "SM/A2 for 7pm assignment",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852663",
            "mealTime": 1563307200,
            "red": false
          },
          "overtime": {
            "startTime": 1563307200,
            "endTime": 1563343200
          },
          "assignments": [
            {
              "jeId": "12135900",
              "startTime": 1563321600,
              "endTime": 1563328800,
              "service": "SM 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12135904",
              "startTime": 1563318000,
              "endTime": 1563321600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786239",
              "jobId": "5083450",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": "3E HB Standby Anchor/7:30p Cutin",
              "comment": null
            },
            {
              "jeId": "12137270",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137443",
              "startTime": 1563336000,
              "endTime": 1563343200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786425",
              "jobId": "5083636",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            },
            {
              "jeId": "12137992",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248867",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861780",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "SM/A2 for 7pm assignment",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135946",
              "startTime": 1563404400,
              "endTime": 1563408000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786245",
              "jobId": "5083456",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3E HB Standby Anchor/7:30p Cutin",
              "comment": null
            },
            {
              "jeId": "12136588",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248868",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861781",
          "startTime": 1563454800,
          "duration": 11.5,
          "remainDuration": null,
          "notificationComment": "stage rehearsal",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136678",
              "startTime": 1563454800,
              "endTime": 1563496200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248869",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861782",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "3pm in time confirmed CM",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135994",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248870",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861783",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "SM/A2 for 7pm assignment",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135807",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12136444",
              "startTime": 1563656400,
              "endTime": 1563667200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137176",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "SM 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248871",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861784",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "STAGE ELEX 3A STUDIO",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137510",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "9312",
    "class": "Resource",
    "name": "Horton Monique",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248722",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861665",
          "startTime": 1563192900,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELEX TESTING..8A-4P",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852549",
            "mealTime": 1563218100,
            "red": false
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248723",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861666",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELEX TESTING",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": null
        }
      },
      {
        "rdtId": "16248724",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861667",
          "startTime": 1563364800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "ELEX TESTING",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563364800,
            "endTime": 1563408000
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248725",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861668",
          "startTime": 1563454800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "elex rehearsal",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": null
        }
      },
      {
        "rdtId": "16248726",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861669",
          "startTime": 1563541200,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248727",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861670",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "elex testing?",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": null
        }
      },
      {
        "rdtId": "16248728",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861671",
          "startTime": 1563739200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563739200,
            "endTime": 1563778800
          },
          "assignments": null
        }
      }
    ]
  },
  {
    "rId": "9314",
    "class": "Resource",
    "name": "Schmidt Mark",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247881",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860916",
          "startTime": 1563177600,
          "duration": 9.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9851816",
            "mealTime": 1563177600,
            "red": false
          },
          "overtime": {
            "startTime": 1563177600,
            "endTime": 1563210900
          },
          "assignments": [
            {
              "jeId": "12135652",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136923",
              "startTime": 1563183000,
              "endTime": 1563192000,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136924",
              "startTime": 1563177600,
              "endTime": 1563183000,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136925",
              "startTime": 1563192000,
              "endTime": 1563195600,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136953",
              "startTime": 1563195600,
              "endTime": 1563199200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137761",
              "startTime": 1563206400,
              "endTime": 1563210900,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786470",
              "jobId": "5083681",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "SHARPTON RADIO - 7th FLOOR RADIO ROOM #764S-3",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247882",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860917",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135960",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786249",
              "jobId": "5083460",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12136628",
              "startTime": 1563292800,
              "endTime": 1563303600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786328",
              "jobId": "5083539",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            },
            {
              "jeId": "12137312",
              "startTime": 1563307200,
              "endTime": 1563310800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247883",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860918",
          "startTime": 1563372000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563372000,
            "endTime": 1563408000
          },
          "assignments": [
            {
              "jeId": "12136010",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786258",
              "jobId": "5083469",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2E / 3A SDO"
            },
            {
              "jeId": "12136635",
              "startTime": 1563372000,
              "endTime": 1563386400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16247884",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860919",
          "startTime": 1563444000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563444000,
            "endTime": 1563487200
          },
          "assignments": [
            {
              "jeId": "12136325",
              "startTime": 1563444000,
              "endTime": 1563451200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            },
            {
              "jeId": "12136347",
              "startTime": 1563476400,
              "endTime": 1563487200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137022",
              "startTime": 1563464700,
              "endTime": 1563476400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137784",
              "startTime": 1563451200,
              "endTime": 1563458400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            },
            {
              "jeId": "12137799",
              "startTime": 1563462000,
              "endTime": 1563464700,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": "A2 ASSIST IF NECESSARY",
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16247885",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860920",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135708",
              "startTime": 1563530400,
              "endTime": 1563535800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12135722",
              "startTime": 1563535800,
              "endTime": 1563541200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136358",
              "startTime": 1563541200,
              "endTime": 1563544800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137829",
              "startTime": 1563548400,
              "endTime": 1563555600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            },
            {
              "jeId": "12137839",
              "startTime": 1563555600,
              "endTime": 1563559200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16247886",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860921",
          "startTime": 1563613200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONFKP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563613200,
            "endTime": 1563652800
          },
          "assignments": [
            {
              "jeId": "12137131",
              "startTime": 1563613200,
              "endTime": 1563627600,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137407",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137781",
              "startTime": 1563631200,
              "endTime": 1563642000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16247887",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860922",
          "startTime": 1563739200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "STAGE/ 4E FLASH",
          "tourComment": "cnfkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      }
    ]
  },
  {
    "rId": "9320",
    "class": "Resource",
    "name": "ZEIDMAN Matthew",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247996",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16247997",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861010",
          "startTime": 1563274800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "MANNY TRAINING WITH YOU ON THE 2P SHOW PLEASE DO NOT PULL THIS ASSIGNMENT",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851906",
            "mealTime": 1563292800,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135875",
              "startTime": 1563296400,
              "endTime": 1563303600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136476",
              "startTime": 1563274800,
              "endTime": 1563283800,
              "service": "ST 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16247998",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861011",
          "startTime": 1563361200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "needs last meal",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135917",
              "startTime": 1563379200,
              "endTime": 1563386400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137368",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247999",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861012",
          "startTime": 1563620400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135790",
              "startTime": 1563633900,
              "endTime": 1563638400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136416",
              "startTime": 1563643800,
              "endTime": 1563649200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137120",
              "startTime": 1563622200,
              "endTime": 1563629400,
              "service": "ST 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248000",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861013",
          "startTime": 1563706800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "last  hour meal...in for mj tomorrow",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135838",
              "startTime": 1563712200,
              "endTime": 1563717600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12137903",
              "startTime": 1563724800,
              "endTime": 1563732000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137919",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "10038",
    "class": "Resource",
    "name": "Rostkowski Valerie",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247868",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860903",
          "startTime": 1563220800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135993",
              "startTime": 1563238800,
              "endTime": 1563244200,
              "service": "Camera & A2 6E",
              "activityType": "148E",
              "requestNumber": "3786256",
              "jobId": "5083467",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11th Hour Looksee - CR 2K / Plaza Prod Nook #4"
            },
            {
              "jeId": "12136240",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137746",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            }
          ]
        }
      },
      {
        "rdtId": "16247869",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860904",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851804",
            "mealTime": 1563303600,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135889",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136503",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137317",
              "startTime": 1563300000,
              "endTime": 1563303600,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137953",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247870",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860905",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135680",
              "startTime": 1563372000,
              "endTime": 1563386400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12135930",
              "startTime": 1563386400,
              "endTime": 1563390000,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12137363",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247871",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860906",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf AA",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136400",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136413",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137545",
              "startTime": 1563624000,
              "endTime": 1563638400,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786438",
              "jobId": "5083649",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal CR 8H / 3E Flash"
            }
          ]
        }
      },
      {
        "rdtId": "16247872",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860907",
          "startTime": 1563710400,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563710400,
            "endTime": 1563746400
          },
          "assignments": [
            {
              "jeId": "12135841",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12135851",
              "startTime": 1563728400,
              "endTime": 1563739200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137920",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            },
            {
              "jeId": "12137934",
              "startTime": 1563739200,
              "endTime": 1563746400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "11847",
    "class": "Resource",
    "name": "Rubel Craig",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248476",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861447",
          "startTime": 1563202800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852336",
            "mealTime": 1563228000,
            "red": false
          }
        }
      },
      {
        "rdtId": "16248477",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861448",
          "startTime": 1563303600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248478",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861449",
          "startTime": 1563390000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248479",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861450",
          "startTime": 1563429600,
          "duration": 17,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563429600,
            "endTime": 1563490800
          },
          "assignments": [
            {
              "jeId": "12137564",
              "startTime": 1563429600,
              "endTime": 1563458400,
              "service": "Graphics PB Op FS/L3 WE Today",
              "activityType": "149P",
              "requestNumber": "3786444",
              "jobId": "5083655",
              "costObject": "WKD TODAY SHOW O&TS",
              "costObjectNumber": "J0A206210",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248480",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861451",
          "startTime": 1563516000,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563516000,
            "endTime": 1563566400
          },
          "assignments": [
            {
              "jeId": "12135559",
              "startTime": 1563516000,
              "endTime": 1563544800,
              "service": "Graphics PB Op FS/L3 WE Today",
              "activityType": "149P",
              "requestNumber": "3786198",
              "jobId": "5083409",
              "costObject": "WKD TODAY SHOW O&TS",
              "costObjectNumber": "J0A206210",
              "description": null,
              "comment": "CR 71/Studio 6A"
            }
          ]
        }
      },
      {
        "rdtId": "16248481",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861452",
          "startTime": 1563615900,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137004",
              "startTime": 1563615900,
              "endTime": 1563644700,
              "service": "Graphics PB Op FS/L3 Today 9am",
              "activityType": "149P",
              "requestNumber": "3786381",
              "jobId": "5083592",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248482",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861453",
          "startTime": 1563702300,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137008",
              "startTime": 1563702300,
              "endTime": 1563731100,
              "service": "Graphics PB Op FS/L3 Today 9am",
              "activityType": "149P",
              "requestNumber": "3786382",
              "jobId": "5083593",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "12143",
    "class": "Resource",
    "name": "Calderon Lisa",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248260",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861246",
          "startTime": 1563195600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852137",
            "mealTime": 1563210000,
            "red": false
          }
        }
      },
      {
        "rdtId": "16248261",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861247",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELECTION STAR AND STRIPE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248262",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861248",
          "startTime": 1563424200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563424200,
            "endTime": 1563453000
          },
          "assignments": [
            {
              "jeId": "12136320",
              "startTime": 1563424200,
              "endTime": 1563446700,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786299",
              "jobId": "5083510",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SATURDAY STANDBY COVERAGE -4E FLASH / 2K CR"
            },
            {
              "jeId": "12136330",
              "startTime": 1563446700,
              "endTime": 1563451200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            }
          ]
        }
      },
      {
        "rdtId": "16248263",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861249",
          "startTime": 1563512400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563512400,
            "endTime": 1563544800
          },
          "assignments": [
            {
              "jeId": "12135713",
              "startTime": 1563530400,
              "endTime": 1563541200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12137057",
              "startTime": 1563512400,
              "endTime": 1563530400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16248264",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861250",
          "startTime": 1563609600,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "ELECTION STAR AND STRIPE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563609600,
            "endTime": 1563652800
          }
        }
      },
      {
        "rdtId": "16248265",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861251",
          "startTime": 1563710400,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "ELECTION STAR AND STRIPE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563710400,
            "endTime": 1563746400
          }
        }
      }
    ]
  },
  {
    "rId": "12145",
    "class": "Resource",
    "name": "Rosano Grace",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248467",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861438",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852327",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135660",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136224",
              "startTime": 1563206400,
              "endTime": 1563210000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136947",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137715",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248468",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861439",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135869",
              "startTime": 1563296400,
              "endTime": 1563303600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12135885",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136510",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137957",
              "startTime": 1563292800,
              "endTime": 1563296400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248469",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861440",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135922",
              "startTime": 1563385500,
              "endTime": 1563390000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12135943",
              "startTime": 1563379200,
              "endTime": 1563382800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786245",
              "jobId": "5083456",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 2K Standby",
              "comment": null
            },
            {
              "jeId": "12136685",
              "startTime": 1563382800,
              "endTime": 1563385500,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786338",
              "jobId": "5083549",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "Deadline WH Looksee- 3A WEST / CR 2K after Kornacki Digital wraps"
            },
            {
              "jeId": "12137356",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137374",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248470",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861441",
          "startTime": 1563447600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137019",
              "startTime": 1563462000,
              "endTime": 1563469200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137030",
              "startTime": 1563469200,
              "endTime": 1563476400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137789",
              "startTime": 1563447600,
              "endTime": 1563458400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            }
          ]
        }
      },
      {
        "rdtId": "16248471",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861442",
          "startTime": 1563534000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135718",
              "startTime": 1563534000,
              "endTime": 1563541200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136355",
              "startTime": 1563541200,
              "endTime": 1563544800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137827",
              "startTime": 1563548400,
              "endTime": 1563555600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            },
            {
              "jeId": "12137846",
              "startTime": 1563555600,
              "endTime": 1563562800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248472",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861443",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135754",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135796",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136410",
              "startTime": 1563642000,
              "endTime": 1563649200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12136420",
              "startTime": 1563638400,
              "endTime": 1563642000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "Standby",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248473",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861444",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135821",
              "startTime": 1563728400,
              "endTime": 1563735600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12135834",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12137906",
              "startTime": 1563724800,
              "endTime": 1563728400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137926",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "12146",
    "class": "Resource",
    "name": "DiBartolo Gina",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248318",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861301",
          "startTime": 1563206400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "seth myers graphics",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852190",
            "mealTime": 1563206400,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136738",
              "startTime": 1563206400,
              "endTime": 1563235200,
              "service": "Graphics PB Op FS/L3 Late Night",
              "activityType": "149P",
              "requestNumber": "3786356",
              "jobId": "5083567",
              "costObject": "Late Night w Seth Meyers S6 Week 4",
              "costObjectNumber": "WT-00600.4",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248319",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861302",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137018",
              "startTime": 1563292800,
              "endTime": 1563310800,
              "service": "TD",
              "activityType": "149P",
              "requestNumber": "3786386",
              "jobId": "5083597",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT NETWORK - LAUNCH/PRE-PRO - CONTROL 74"
            },
            {
              "jeId": "12137246",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "TD",
              "activityType": "149P",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            }
          ]
        }
      },
      {
        "rdtId": "16248320",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861303",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136315",
              "startTime": 1563372000,
              "endTime": 1563400800,
              "service": "TD",
              "activityType": "149P",
              "requestNumber": "3786298",
              "jobId": "5083509",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT NETWORK - LAUNCH/PRE-PRO - CONTROL 74"
            }
          ]
        }
      },
      {
        "rdtId": "16248321",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861304",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137415",
              "startTime": 1563638400,
              "endTime": 1563652800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137549",
              "startTime": 1563624000,
              "endTime": 1563638400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786438",
              "jobId": "5083649",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal CR 8H / 3E Flash"
            }
          ]
        }
      },
      {
        "rdtId": "16248322",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861305",
          "startTime": 1563732000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136598",
              "startTime": 1563741900,
              "endTime": 1563760800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137015",
              "startTime": 1563735600,
              "endTime": 1563741900,
              "service": "TD",
              "activityType": "149P",
              "requestNumber": "3786385",
              "jobId": "5083596",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT NETWORK - LAUNCH/PRE-PRO - CONTROL 74"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "12899",
    "class": "Resource",
    "name": "Dottin Michael",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247797",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860839",
          "startTime": 1563465600,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9851740",
            "mealTime": 1563487200,
            "red": false
          },
          "overtime": {
            "startTime": 1563465600,
            "endTime": 1563498000
          },
          "assignments": [
            {
              "jeId": "12135697",
              "startTime": 1563472800,
              "endTime": 1563480000,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136343",
              "startTime": 1563480000,
              "endTime": 1563487200,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137037",
              "startTime": 1563465600,
              "endTime": 1563472800,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137040",
              "startTime": 1563490800,
              "endTime": 1563498000,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247798",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860840",
          "startTime": 1563541200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136368",
              "startTime": 1563541200,
              "endTime": 1563552000,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137069",
              "startTime": 1563559200,
              "endTime": 1563566400,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137842",
              "startTime": 1563552000,
              "endTime": 1563559200,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "12958",
    "class": "Resource",
    "name": "NATOLI THEODORE",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248070",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861071",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851967",
            "mealTime": 1563217200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136205",
              "startTime": 1563192000,
              "endTime": 1563195600,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148C",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136646",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            }
          ]
        }
      },
      {
        "rdtId": "16248071",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861072",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135884",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "Video & LD 9 AM",
              "activityType": "148C",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136509",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "Video & LD 11 AM",
              "activityType": "148C",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137302",
              "startTime": 1563300000,
              "endTime": 1563303600,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148C",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137461",
              "startTime": 1563296400,
              "endTime": 1563300000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786427",
              "jobId": "5083638",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Elx Looksee CR 2K / SDO 3AWEST"
            },
            {
              "jeId": "12137960",
              "startTime": 1563292800,
              "endTime": 1563296400,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248072",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861073",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136687",
              "startTime": 1563370200,
              "endTime": 1563375600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786339",
              "jobId": "5083550",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Looksee - 3A west / CR 2K"
            },
            {
              "jeId": "12137483",
              "startTime": 1563375600,
              "endTime": 1563390000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786431",
              "jobId": "5083642",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137484",
              "startTime": 1563364800,
              "endTime": 1563370200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786431",
              "jobId": "5083642",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248073",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861074",
          "startTime": 1563454800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136661",
              "startTime": 1563454800,
              "endTime": 1563498000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248074",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861075",
          "startTime": 1563555600,
          "duration": 10.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137465",
              "startTime": 1563555600,
              "endTime": 1563594300,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786428",
              "jobId": "5083639",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248075",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861076",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135752",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "Video & LD 9 AM",
              "activityType": "148C",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137412",
              "startTime": 1563638400,
              "endTime": 1563652800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137773",
              "startTime": 1563631200,
              "endTime": 1563634800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248076",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861077",
          "startTime": 1563717600,
          "duration": 12.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563717600,
            "endTime": 1563762600
          },
          "assignments": [
            {
              "jeId": "12136596",
              "startTime": 1563735600,
              "endTime": 1563741900,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137502",
              "startTime": 1563717600,
              "endTime": 1563735600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": "ELECTION NIGHT SETUP",
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137503",
              "startTime": 1563741900,
              "endTime": 1563762600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "12965",
    "class": "Resource",
    "name": "Drago Brian",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247807",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860845",
          "startTime": 1563422400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9851746",
            "mealTime": 1563447600,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136322",
              "startTime": 1563422400,
              "endTime": 1563447600,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786299",
              "jobId": "5083510",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SATURDAY STANDBY COVERAGE -4E FLASH / 2K CR"
            }
          ]
        }
      },
      {
        "rdtId": "16247808",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860846",
          "startTime": 1563570000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136372",
              "startTime": 1563573600,
              "endTime": 1563577200,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12136382",
              "startTime": 1563577200,
              "endTime": 1563584400,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137048",
              "startTime": 1563584400,
              "endTime": 1563598800,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "12976",
    "class": "Resource",
    "name": "FRUGONI ROBERT",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247711",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860756",
          "startTime": 1563202800,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851659",
            "mealTime": 1563202800,
            "red": false
          },
          "overtime": null
        }
      },
      {
        "rdtId": "16247712",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860757",
          "startTime": 1563289200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "10 HOUR - 4 day a week ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137017",
              "startTime": 1563292800,
              "endTime": 1563310800,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786386",
              "jobId": "5083597",
              "costObject": "DIRECTORS",
              "costObjectNumber": "J07705046",
              "description": null,
              "comment": "OTT NETWORK - LAUNCH/PRE-PRO - CONTROL 74"
            },
            {
              "jeId": "12137245",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "DIRECTORS",
              "costObjectNumber": "J07705046",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137966",
              "startTime": 1563289200,
              "endTime": 1563292800,
              "service": "Training MSNBC",
              "activityType": "TR6212",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "DIRECTORS",
              "costObjectNumber": "J07705046",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247713",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860758",
          "startTime": 1563372000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "10 HOUR - 4 day a week ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136314",
              "startTime": 1563372000,
              "endTime": 1563408000,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786298",
              "jobId": "5083509",
              "costObject": "DIRECTORS",
              "costObjectNumber": "J07705046",
              "description": null,
              "comment": "OTT NETWORK - LAUNCH/PRE-PRO - CONTROL 74"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "12980",
    "class": "Resource",
    "name": "Quanvie David",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248021",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861029",
          "startTime": 1563170400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9851925",
            "mealTime": 1563196500,
            "red": false
          },
          "overtime": {
            "startTime": 1563170400,
            "endTime": 1563199200
          },
          "assignments": [
            {
              "jeId": "12136909",
              "startTime": 1563170400,
              "endTime": 1563196500,
              "service": "Audio A1 MJ",
              "activityType": "149M",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            }
          ]
        }
      },
      {
        "rdtId": "16248022",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861030",
          "startTime": 1563256800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563256800,
            "endTime": 1563285600
          },
          "assignments": [
            {
              "jeId": "12136469",
              "startTime": 1563256800,
              "endTime": 1563283800,
              "service": "Audio A1 MJ",
              "activityType": "149M",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248023",
        "title": "ILL Day {= 11 STAFF ONLY",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "ILL Day {= 11 STAFF ONLY",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248024",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861031",
          "startTime": 1563602400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137113",
              "startTime": 1563602400,
              "endTime": 1563629400,
              "service": "Audio A1 MJ",
              "activityType": "149M",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248025",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861032",
          "startTime": 1563688800,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563688800,
            "endTime": 1563724800
          },
          "assignments": [
            {
              "jeId": "12136610",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "Audio A1 MJ",
              "activityType": "149M",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137197",
              "startTime": 1563688800,
              "endTime": 1563714000,
              "service": "Audio A1 MJ",
              "activityType": "149M",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "12997",
    "class": "Resource",
    "name": "Finn Rachel",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248038",
        "title": "Floating Hol (non-represented)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Floating Hol (non-represented)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248039",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861045",
          "startTime": 1563307200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851941",
            "mealTime": 1563307200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135895",
              "startTime": 1563321600,
              "endTime": 1563328800,
              "service": "Video & LD MADDOW",
              "activityType": "148C",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12135967",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786249",
              "jobId": "5083460",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137988",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "Video & LD BW",
              "activityType": "148C",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248040",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861046",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136584",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "Video & LD BW",
              "activityType": "148C",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            },
            {
              "jeId": "12137471",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248041",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861047",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136660",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248042",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        }
      },
      {
        "rdtId": "16248043",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861048",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135803",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "Video & LD BW",
              "activityType": "148C",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137081",
              "startTime": 1563660000,
              "endTime": 1563663600,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6208",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137150",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "Video & LD 5 PM",
              "activityType": "148C",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137178",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "Video & LD MADDOW",
              "activityType": "148C",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248044",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861049",
          "startTime": 1563739200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137539",
              "startTime": 1563746400,
              "endTime": 1563768000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786436",
              "jobId": "5083647",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC ELECTION NIGHT - 2K SUBSWITCH  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137933",
              "startTime": 1563739200,
              "endTime": 1563746400,
              "service": "Video & LD 5 PM",
              "activityType": "148C",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "14307",
    "class": "Resource",
    "name": "Morrisey-Marquez Barbara",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248823",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248824",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861741",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "NEEDS LAST MEAL",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852625",
            "mealTime": 1563307200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136519",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137314",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248825",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861742",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "Needs LHL",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135916",
              "startTime": 1563375600,
              "endTime": 1563386400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12135927",
              "startTime": 1563386400,
              "endTime": 1563390000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136689",
              "startTime": 1563364800,
              "endTime": 1563375600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786339",
              "jobId": "5083550",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Looksee - 3A west / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248826",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861743",
          "startTime": 1563465600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "FOR KNOLLE SO HE CAN BE A JIB BREAKER",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136346",
              "startTime": 1563480000,
              "endTime": 1563487200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137032",
              "startTime": 1563465600,
              "endTime": 1563472800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137046",
              "startTime": 1563490800,
              "endTime": 1563498000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137429",
              "startTime": 1563498000,
              "endTime": 1563501600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137813",
              "startTime": 1563487200,
              "endTime": 1563490800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248827",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        }
      },
      {
        "rdtId": "16248828",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861744",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135756",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136405",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137143",
              "startTime": 1563645600,
              "endTime": 1563652800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137862",
              "startTime": 1563631200,
              "endTime": 1563634800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248829",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861745",
          "startTime": 1563710400,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": "barb can be used for any extra help needed from 5-10",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563710400,
            "endTime": 1563760800
          },
          "assignments": [
            {
              "jeId": "12135843",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12136461",
              "startTime": 1563735600,
              "endTime": 1563742800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137901",
              "startTime": 1563724800,
              "endTime": 1563732000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137921",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "14880",
    "class": "Resource",
    "name": "SANTIAGO SARA",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247874",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860909",
          "startTime": 1563195600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9851809",
            "mealTime": 1563206400,
            "red": false
          },
          "overtime": {
            "startTime": 1563195600,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12135662",
              "startTime": 1563202800,
              "endTime": 1563206400,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136961",
              "startTime": 1563228000,
              "endTime": 1563235200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786375",
              "jobId": "5083586",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137695",
              "startTime": 1563195600,
              "endTime": 1563202800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            },
            {
              "jeId": "12137721",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137728",
              "startTime": 1563217200,
              "endTime": 1563228000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16247875",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860910",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "lhl",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135877",
              "startTime": 1563302700,
              "endTime": 1563307200,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136501",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12137378",
              "startTime": 1563289200,
              "endTime": 1563302700,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786415",
              "jobId": "5083626",
              "costObject": "2017 THE UNIVERSAL KIDS",
              "costObjectNumber": "T-NIQPD050.J0A2",
              "description": null,
              "comment": "Universal Kids News - Nook #4"
            }
          ]
        }
      },
      {
        "rdtId": "16247876",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860911",
          "startTime": 1563440400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137565",
              "startTime": 1563440400,
              "endTime": 1563469200,
              "service": "Prompter Weekend Today Show",
              "activityType": "1291A5",
              "requestNumber": "3786444",
              "jobId": "5083655",
              "costObject": "WKD TODAY SHOW O&TS",
              "costObjectNumber": "J0A206210",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247877",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860912",
          "startTime": 1563638400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf ap",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136447",
              "startTime": 1563656400,
              "endTime": 1563660000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137093",
              "startTime": 1563652800,
              "endTime": 1563656400,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137169",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137406",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            }
          ]
        }
      },
      {
        "rdtId": "16247878",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860913",
          "startTime": 1563715800,
          "duration": 12.5,
          "remainDuration": null,
          "notificationComment": "sara checking to stay until 10p  ",
          "tourComment": "con fkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563715800,
            "endTime": 1563760800
          },
          "assignments": [
            {
              "jeId": "12136608",
              "startTime": 1563735600,
              "endTime": 1563760800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137224",
              "startTime": 1563715800,
              "endTime": 1563721200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137231",
              "startTime": 1563721200,
              "endTime": 1563732000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "16024",
    "class": "Resource",
    "name": "Kassof Sean",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248192",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861179",
          "startTime": 1563200100,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852073",
            "mealTime": 1563209100,
            "red": false
          }
        }
      },
      {
        "rdtId": "16248193",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861180",
          "startTime": 1563286500,
          "duration": 11.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563286500,
            "endTime": 1563327000
          }
        }
      },
      {
        "rdtId": "16248194",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861181",
          "startTime": 1563429600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563429600,
            "endTime": 1563458400
          },
          "assignments": [
            {
              "jeId": "12137566",
              "startTime": 1563429600,
              "endTime": 1563458400,
              "service": "Camera Utility WE Today Show",
              "activityType": "1291A5",
              "requestNumber": "3786444",
              "jobId": "5083655",
              "costObject": "WKD TODAY SHOW O&TS",
              "costObjectNumber": "J0A206210",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248195",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861182",
          "startTime": 1563632100,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563632100,
            "endTime": 1563666300
          }
        }
      },
      {
        "rdtId": "16248196",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861183",
          "startTime": 1563746400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      }
    ]
  },
  {
    "rId": "16590",
    "class": "Resource",
    "name": "Torres Manny",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248281",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248282",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861267",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "TRAINING STEADI 9AM AND 2PM",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852158",
            "mealTime": 1563292800,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135554",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "Training MSNBC",
              "activityType": "148E",
              "requestNumber": "3786196",
              "jobId": "5083407",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "train prep 8a, 9a hour thanks",
              "comment": null
            },
            {
              "jeId": "12135555",
              "startTime": 1563296400,
              "endTime": 1563307200,
              "service": "Training MSNBC",
              "activityType": "148E",
              "requestNumber": "3786196",
              "jobId": "5083407",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "train 2p show...be ready at 1:45 thanks",
              "comment": null
            },
            {
              "jeId": "12135556",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "Training MSNBC",
              "activityType": "148E",
              "requestNumber": "3786196",
              "jobId": "5083407",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248283",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861268",
          "startTime": 1563368400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "use for 3AStudio Blocking",
          "tourComment": "CM Conf",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136630",
              "startTime": 1563368400,
              "endTime": 1563393600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248284",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        }
      },
      {
        "rdtId": "16248285",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861269",
          "startTime": 1563537600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confk p",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137455",
              "startTime": 1563537600,
              "endTime": 1563566400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248884",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861792",
          "startTime": 1563768000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "STEADI 3A STUDIO",
          "tourComment": "conf cm",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136710",
              "startTime": 1563768000,
              "endTime": 1563775200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786344",
              "jobId": "5083555",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17158",
    "class": "Resource",
    "name": "Albee Roy",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248153",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861145",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852041",
            "mealTime": 1563217200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136223",
              "startTime": 1563202800,
              "endTime": 1563210000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136229",
              "startTime": 1563210000,
              "endTime": 1563212700,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "Standby",
              "comment": null
            },
            {
              "jeId": "12136949",
              "startTime": 1563192000,
              "endTime": 1563195600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137694",
              "startTime": 1563195600,
              "endTime": 1563202800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            },
            {
              "jeId": "12137716",
              "startTime": 1563212700,
              "endTime": 1563217200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248154",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861146",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135865",
              "startTime": 1563289200,
              "endTime": 1563296400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12135870",
              "startTime": 1563299100,
              "endTime": 1563303600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12135887",
              "startTime": 1563278400,
              "endTime": 1563282000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136494",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12137462",
              "startTime": 1563296400,
              "endTime": 1563299100,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786427",
              "jobId": "5083638",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Elx Looksee CR 2K / SDO 3AWEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248155",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861147",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135923",
              "startTime": 1563385500,
              "endTime": 1563390000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136545",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136560",
              "startTime": 1563375600,
              "endTime": 1563382800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12137340",
              "startTime": 1563382800,
              "endTime": 1563385500,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786410",
              "jobId": "5083621",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K Standby",
              "comment": null
            },
            {
              "jeId": "12137358",
              "startTime": 1563364800,
              "endTime": 1563368400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248156",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861148",
          "startTime": 1563444000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136324",
              "startTime": 1563444000,
              "endTime": 1563451200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            },
            {
              "jeId": "12137021",
              "startTime": 1563464700,
              "endTime": 1563469200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137031",
              "startTime": 1563469200,
              "endTime": 1563472800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137791",
              "startTime": 1563451200,
              "endTime": 1563458400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            }
          ]
        }
      },
      {
        "rdtId": "16248157",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861149",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135706",
              "startTime": 1563530400,
              "endTime": 1563535800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12135719",
              "startTime": 1563535800,
              "endTime": 1563541200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136354",
              "startTime": 1563541200,
              "endTime": 1563544800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137828",
              "startTime": 1563548400,
              "endTime": 1563555600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            },
            {
              "jeId": "12137838",
              "startTime": 1563555600,
              "endTime": 1563559200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248158",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861150",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135772",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "Graphics PB Op FS - MITCHELL - GPO",
              "activityType": "149P",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136409",
              "startTime": 1563644700,
              "endTime": 1563649200,
              "service": "Graphics PB Op FS - 2 PM - GPO",
              "activityType": "149P",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12136430",
              "startTime": 1563642000,
              "endTime": 1563644700,
              "service": "Graphics PB Op FS - Standby - GPO",
              "activityType": "149P",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "Standby",
              "comment": null
            },
            {
              "jeId": "12137860",
              "startTime": 1563624000,
              "endTime": 1563634800,
              "service": "Graphics PB Op FS - 10 AM - GPO",
              "activityType": "149P",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248159",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861151",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135822",
              "startTime": 1563731100,
              "endTime": 1563735600,
              "service": "Graphics PB Op FS - 2 PM - GPO",
              "activityType": "149P",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12135832",
              "startTime": 1563710400,
              "endTime": 1563714000,
              "service": "Graphics PB Op FS - 9 AM - GPO",
              "activityType": "149P",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12137221",
              "startTime": 1563714000,
              "endTime": 1563721200,
              "service": "Graphics PB Op FS - 10 AM - GPO",
              "activityType": "149P",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137238",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "Graphics PB Op FS - MITCHELL - GPO",
              "activityType": "149P",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            },
            {
              "jeId": "12137916",
              "startTime": 1563728400,
              "endTime": 1563731100,
              "service": "Graphics PB Op FS - Standby - GPO",
              "activityType": "149P",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "Standby",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248894",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861802",
          "startTime": 1563771600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563771600,
            "endTime": 1563811200
          },
          "assignments": [
            {
              "jeId": "12137516",
              "startTime": 1563771600,
              "endTime": 1563796800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17181",
    "class": "Resource",
    "name": "DeLeon Robert",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247704",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860749",
          "startTime": 1563163200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9851652",
            "mealTime": 1563163200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136250",
              "startTime": 1563172200,
              "endTime": 1563192000,
              "service": "TD ET",
              "activityType": "149N",
              "requestNumber": "3786285",
              "jobId": "5083496",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137738",
              "startTime": 1563166800,
              "endTime": 1563172200,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786467",
              "jobId": "5083678",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16247705",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860750",
          "startTime": 1563249600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135879",
              "startTime": 1563253200,
              "endTime": 1563258600,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786236",
              "jobId": "5083447",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12137981",
              "startTime": 1563258600,
              "endTime": 1563278400,
              "service": "TD ET",
              "activityType": "149N",
              "requestNumber": "3786495",
              "jobId": "5083706",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16247706",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860751",
          "startTime": 1563336000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135932",
              "startTime": 1563339600,
              "endTime": 1563345000,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786243",
              "jobId": "5083454",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12135938",
              "startTime": 1563345000,
              "endTime": 1563364800,
              "service": "TD ET",
              "activityType": "149N",
              "requestNumber": "3786244",
              "jobId": "5083455",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16247707",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860752",
          "startTime": 1563595200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137852",
              "startTime": 1563604200,
              "endTime": 1563624000,
              "service": "TD ET",
              "activityType": "149N",
              "requestNumber": "3786480",
              "jobId": "5083691",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137890",
              "startTime": 1563598800,
              "endTime": 1563604200,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786484",
              "jobId": "5083695",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16247708",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860753",
          "startTime": 1563681600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135815",
              "startTime": 1563685200,
              "endTime": 1563690600,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786229",
              "jobId": "5083440",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12137191",
              "startTime": 1563690600,
              "endTime": 1563710400,
              "service": "TD ET",
              "activityType": "149N",
              "requestNumber": "3786399",
              "jobId": "5083610",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17215",
    "class": "Resource",
    "name": "Barnes Brigette",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248565",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861532",
          "startTime": 1563168600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9852421",
            "mealTime": 1563175800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136251",
              "startTime": 1563168600,
              "endTime": 1563192000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786285",
              "jobId": "5083496",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12136917",
              "startTime": 1563192000,
              "endTime": 1563196500,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            }
          ]
        }
      },
      {
        "rdtId": "16248566",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861533",
          "startTime": 1563336000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135557",
              "startTime": 1563336000,
              "endTime": 1563343200,
              "service": "Newsforce-Playback 10",
              "activityType": "148B",
              "requestNumber": "3786197",
              "jobId": "5083408",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136020",
              "startTime": 1563343200,
              "endTime": 1563361200,
              "service": "Early Today-Playback 10",
              "activityType": "148B",
              "requestNumber": "3786263",
              "jobId": "5083474",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248567",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861534",
          "startTime": 1563444000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563444000,
            "endTime": 1563476400
          },
          "assignments": [
            {
              "jeId": "12135959",
              "startTime": 1563449400,
              "endTime": 1563458400,
              "service": "Newsforce-Playback 9",
              "activityType": "148B",
              "requestNumber": "3786248",
              "jobId": "5083459",
              "costObject": "MSNBC David Gura 8A",
              "costObjectNumber": "T-DGXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136723",
              "startTime": 1563458400,
              "endTime": 1563462000,
              "service": "Politics playback 10",
              "activityType": "148B",
              "requestNumber": "3786348",
              "jobId": "5083559",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136731",
              "startTime": 1563462000,
              "endTime": 1563465600,
              "service": "Newsforce-Playback 9",
              "activityType": "148B",
              "requestNumber": "3786353",
              "jobId": "5083564",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137569",
              "startTime": 1563444000,
              "endTime": 1563449400,
              "service": "Newsforce-Playback 9",
              "activityType": "148B",
              "requestNumber": "3786446",
              "jobId": "5083657",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137570",
              "startTime": 1563465600,
              "endTime": 1563472800,
              "service": "Newsforce-Playback 9",
              "activityType": "148B",
              "requestNumber": "3786447",
              "jobId": "5083658",
              "costObject": "WEEKENDS WITH ALEX WITT END OPS INTERNAL",
              "costObjectNumber": "T-WIXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248568",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861535",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136027",
              "startTime": 1563530400,
              "endTime": 1563535800,
              "service": "Newsforce-Playback 9",
              "activityType": "148B",
              "requestNumber": "3786266",
              "jobId": "5083477",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136028",
              "startTime": 1563552000,
              "endTime": 1563559200,
              "service": "Newsforce-Playback 9",
              "activityType": "148B",
              "requestNumber": "3786267",
              "jobId": "5083478",
              "costObject": "WEEKENDS WITH ALEX WITT END OPS INTERNAL",
              "costObjectNumber": "T-WIXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137571",
              "startTime": 1563548400,
              "endTime": 1563552000,
              "service": "Newsforce-Playback 9",
              "activityType": "148B",
              "requestNumber": "3786448",
              "jobId": "5083659",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248569",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861536",
          "startTime": 1563605100,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "PROMPT TINY",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563605100,
            "endTime": 1563639300
          },
          "assignments": [
            {
              "jeId": "12136973",
              "startTime": 1563605100,
              "endTime": 1563639300,
              "service": "7E PROMPT",
              "activityType": "T13881",
              "requestNumber": "3786377",
              "jobId": "5083588",
              "costObject": "Studio Engineers",
              "costObjectNumber": "T0T103881",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248570",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861537",
          "startTime": 1563738300,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "PROMPT 5/6/11",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563738300,
            "endTime": 1563767100
          },
          "assignments": [
            {
              "jeId": "12136974",
              "startTime": 1563738300,
              "endTime": 1563767100,
              "service": "7E PROMPT",
              "activityType": "T13881",
              "requestNumber": "3786378",
              "jobId": "5083589",
              "costObject": "Studio Engineers",
              "costObjectNumber": "T0T103881",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17606",
    "class": "Resource",
    "name": "ABREU LOUISA",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248528",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861496",
          "startTime": 1563206400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "NEEDS THIS SHIFT TODAY",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852385",
            "mealTime": 1563206400,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136304",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786296",
              "jobId": "5083507",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137718",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137735",
              "startTime": 1563217200,
              "endTime": 1563224400,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248529",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861497",
          "startTime": 1563289200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563289200,
            "endTime": 1563321600
          },
          "assignments": [
            {
              "jeId": "12135859",
              "startTime": 1563289200,
              "endTime": 1563296400,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12135965",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786249",
              "jobId": "5083460",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137265",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137459",
              "startTime": 1563296400,
              "endTime": 1563300000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786427",
              "jobId": "5083638",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Elx Looksee CR 2K / SDO 3AWEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248530",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861498",
          "startTime": 1563368400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136554",
              "startTime": 1563375600,
              "endTime": 1563382800,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136683",
              "startTime": 1563382800,
              "endTime": 1563386400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786338",
              "jobId": "5083549",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "Deadline WH Looksee- 3A WEST / CR 2K after Kornacki Digital wraps"
            },
            {
              "jeId": "12136691",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786339",
              "jobId": "5083550",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Looksee - 3A west / CR 2K"
            },
            {
              "jeId": "12137482",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248531",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        }
      },
      {
        "rdtId": "16248532",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861499",
          "startTime": 1563541200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "robo then JIB BREAKER DEMOCRACY PLAZA AND INSIDE",
          "tourComment": "CONFKP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136362",
              "startTime": 1563541200,
              "endTime": 1563552000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12136699",
              "startTime": 1563552000,
              "endTime": 1563580800,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786342",
              "jobId": "5083553",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248533",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861500",
          "startTime": 1563634800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563634800,
            "endTime": 1563667200
          },
          "assignments": [
            {
              "jeId": "12135774",
              "startTime": 1563638400,
              "endTime": 1563642000,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135800",
              "startTime": 1563634800,
              "endTime": 1563638400,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136412",
              "startTime": 1563642000,
              "endTime": 1563649200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12136438",
              "startTime": 1563649200,
              "endTime": 1563656400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137161",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            }
          ]
        }
      },
      {
        "rdtId": "16248534",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861501",
          "startTime": 1563721200,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": "breaker robo/jib/A2..",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563721200,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12136465",
              "startTime": 1563732000,
              "endTime": 1563742800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137232",
              "startTime": 1563721200,
              "endTime": 1563732000,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            },
            {
              "jeId": "12137515",
              "startTime": 1563746400,
              "endTime": 1563775200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17610",
    "class": "Resource",
    "name": "Burghelea Nicolae",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248610",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248611",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861572",
          "startTime": 1563256800,
          "duration": 6,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137982",
              "startTime": 1563257700,
              "endTime": 1563278400,
              "service": "PR 2K ET",
              "activityType": "148E",
              "requestNumber": "3786495",
              "jobId": "5083706",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248612",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861573",
          "startTime": 1563343200,
          "duration": 6,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135939",
              "startTime": 1563343200,
              "endTime": 1563364800,
              "service": "PR 2K ET",
              "activityType": "148E",
              "requestNumber": "3786244",
              "jobId": "5083455",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248613",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861574",
          "startTime": 1563444000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852461",
            "mealTime": 1563469200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136327",
              "startTime": 1563444000,
              "endTime": 1563451200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            },
            {
              "jeId": "12137025",
              "startTime": 1563462000,
              "endTime": 1563469200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137786",
              "startTime": 1563451200,
              "endTime": 1563462000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            }
          ]
        }
      },
      {
        "rdtId": "16248614",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861575",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "Tolud covers AM Joy A2 during prepro ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136365",
              "startTime": 1563544800,
              "endTime": 1563552000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137837",
              "startTime": 1563552000,
              "endTime": 1563555600,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248615",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861576",
          "startTime": 1563757200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "3a West ped ",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563757200,
            "endTime": 1563793200
          },
          "assignments": [
            {
              "jeId": "12136719",
              "startTime": 1563757200,
              "endTime": 1563768000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786345",
              "jobId": "5083556",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A WEST (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137532",
              "startTime": 1563768000,
              "endTime": 1563775200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17618",
    "class": "Resource",
    "name": "Franco Thomas",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248690",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248691",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861646",
          "startTime": 1563307200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852530",
            "mealTime": 1563307200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135902",
              "startTime": 1563321600,
              "endTime": 1563328800,
              "service": "A2 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12137276",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137305",
              "startTime": 1563318000,
              "endTime": 1563321600,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137993",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248692",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861647",
          "startTime": 1563393600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563393600,
            "endTime": 1563429600
          },
          "assignments": [
            {
              "jeId": "12136589",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": "PD/A2",
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            },
            {
              "jeId": "12136698",
              "startTime": 1563422400,
              "endTime": 1563429600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786341",
              "jobId": "5083552",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            }
          ]
        }
      },
      {
        "rdtId": "16248693",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861648",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "3pm in time confirmed CM",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135995",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248694",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861649",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135808",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12136445",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137086",
              "startTime": 1563663600,
              "endTime": 1563667200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137175",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "A2 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248695",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861650",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "A2 ELEX 3A STUDIO",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137509",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17621",
    "class": "Resource",
    "name": "Hasiotis Stephanie",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248359",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861335",
          "startTime": 1563177600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852224",
            "mealTime": 1563177600,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135670",
              "startTime": 1563177600,
              "endTime": 1563213600,
              "service": "Graphics PB Op FS/L3 Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786215",
              "jobId": "5083426",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248360",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861336",
          "startTime": 1563270300,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137765",
              "startTime": 1563270300,
              "endTime": 1563306300,
              "service": "Graphics PB Op FS/L3 Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786472",
              "jobId": "5083683",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248361",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861337",
          "startTime": 1563356700,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136640",
              "startTime": 1563356700,
              "endTime": 1563385500,
              "service": "Graphics PB Op FS/L3 Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786331",
              "jobId": "5083542",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248362",
        "title": "Death In Family",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Death In Family",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        }
      },
      {
        "rdtId": "16248363",
        "title": "Death In Family",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Death In Family",
          "startTime": 1563681600,
          "endTime": 1563767940,
          "comment": null
        }
      }
    ]
  },
  {
    "rId": "17625",
    "class": "Resource",
    "name": "KALVIN JEFFREY",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247826",
        "title": "Floating Hol (non-represented)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Floating Hol (non-represented)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16247827",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860863",
          "startTime": 1563310800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9851764",
            "mealTime": 1563310800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12137286",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "Audio A1 HAYES",
              "activityType": "149M",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137289",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "Audio A1 Last Word",
              "activityType": "149M",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12137327",
              "startTime": 1563314400,
              "endTime": 1563318000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA149M",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137974",
              "startTime": 1563332400,
              "endTime": 1563339600,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786494",
              "jobId": "5083705",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247828",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860864",
          "startTime": 1563397200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136561",
              "startTime": 1563411600,
              "endTime": 1563418800,
              "service": "Audio A1 Last Word",
              "activityType": "149M",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136573",
              "startTime": 1563418800,
              "endTime": 1563426000,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786322",
              "jobId": "5083533",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247829",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860865",
          "startTime": 1563656400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135780",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "Audio A1 Last Word",
              "activityType": "149M",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12137099",
              "startTime": 1563660000,
              "endTime": 1563663600,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA149M",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137878",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "Audio A1 HAYES",
              "activityType": "149M",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            },
            {
              "jeId": "12137884",
              "startTime": 1563678000,
              "endTime": 1563685200,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786483",
              "jobId": "5083694",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247830",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860866",
          "startTime": 1563735600,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563782400
          },
          "assignments": [
            {
              "jeId": "12137499",
              "startTime": 1563735600,
              "endTime": 1563782400,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17626",
    "class": "Resource",
    "name": "Kane Deirdre",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248374",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861348",
          "startTime": 1563199200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852237",
            "mealTime": 1563210000,
            "red": false
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248375",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861349",
          "startTime": 1563314400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELEX TESTING",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248376",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861350",
          "startTime": 1563364800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "ELEX TESTING",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563364800,
            "endTime": 1563408000
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248377",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861351",
          "startTime": 1563454800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "elex rehearsal",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563494400
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248378",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861352",
          "startTime": 1563541200,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": "ELEX",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563541200,
            "endTime": 1563598800
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248379",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861353",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "elex testing?",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248380",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861354",
          "startTime": 1563739200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563739200,
            "endTime": 1563778800
          },
          "assignments": null
        }
      }
    ]
  },
  {
    "rId": "17636",
    "class": "Resource",
    "name": "MONACO DEANA",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248816",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861736",
          "startTime": 1563171300,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9852620",
            "mealTime": 1563196500,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136249",
              "startTime": 1563171300,
              "endTime": 1563192000,
              "service": "PR 2K ET",
              "activityType": "148E",
              "requestNumber": "3786285",
              "jobId": "5083496",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12136956",
              "startTime": 1563192000,
              "endTime": 1563196500,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248817",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        }
      },
      {
        "rdtId": "16248818",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248819",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861737",
          "startTime": 1563603300,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137117",
              "startTime": 1563624000,
              "endTime": 1563628500,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137851",
              "startTime": 1563603300,
              "endTime": 1563624000,
              "service": "PR 2K ET",
              "activityType": "148E",
              "requestNumber": "3786480",
              "jobId": "5083691",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248820",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861738",
          "startTime": 1563689700,
          "duration": 8.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563689700,
            "endTime": 1563721200
          },
          "assignments": [
            {
              "jeId": "12137190",
              "startTime": 1563689700,
              "endTime": 1563710400,
              "service": "PR 2K ET",
              "activityType": "148E",
              "requestNumber": "3786399",
              "jobId": "5083610",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137227",
              "startTime": 1563714000,
              "endTime": 1563721200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17638",
    "class": "Resource",
    "name": "Nichols Gregory",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248442",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861413",
          "startTime": 1563163200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852302",
            "mealTime": 1563163200,
            "red": true
          },
          "overtime": {
            "startTime": 1563163200,
            "endTime": 1563192000
          },
          "assignments": [
            {
              "jeId": "12135625",
              "startTime": 1563165000,
              "endTime": 1563166800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786206",
              "jobId": "5083417",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            },
            {
              "jeId": "12136253",
              "startTime": 1563172200,
              "endTime": 1563192000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786285",
              "jobId": "5083496",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137740",
              "startTime": 1563166800,
              "endTime": 1563172200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786467",
              "jobId": "5083678",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16248443",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861414",
          "startTime": 1563249600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563249600,
            "endTime": 1563278400
          },
          "assignments": [
            {
              "jeId": "12135881",
              "startTime": 1563253200,
              "endTime": 1563258600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786236",
              "jobId": "5083447",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12136941",
              "startTime": 1563251400,
              "endTime": 1563253200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786373",
              "jobId": "5083584",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            },
            {
              "jeId": "12137984",
              "startTime": 1563258600,
              "endTime": 1563278400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786495",
              "jobId": "5083706",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248444",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861415",
          "startTime": 1563336000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563336000,
            "endTime": 1563364800
          },
          "assignments": [
            {
              "jeId": "12135934",
              "startTime": 1563339600,
              "endTime": 1563345000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786243",
              "jobId": "5083454",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12135941",
              "startTime": 1563345000,
              "endTime": 1563364800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786244",
              "jobId": "5083455",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137975",
              "startTime": 1563337800,
              "endTime": 1563339600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786494",
              "jobId": "5083705",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248445",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861416",
          "startTime": 1563595200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137854",
              "startTime": 1563604200,
              "endTime": 1563624000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786480",
              "jobId": "5083691",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137892",
              "startTime": 1563598800,
              "endTime": 1563604200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786484",
              "jobId": "5083695",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16248446",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861417",
          "startTime": 1563681600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563681600,
            "endTime": 1563710400
          },
          "assignments": [
            {
              "jeId": "12135817",
              "startTime": 1563685200,
              "endTime": 1563690600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786229",
              "jobId": "5083440",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12137193",
              "startTime": 1563690600,
              "endTime": 1563710400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786399",
              "jobId": "5083610",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137885",
              "startTime": 1563683400,
              "endTime": 1563685200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786483",
              "jobId": "5083694",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17642",
    "class": "Resource",
    "name": "Parisi Michael",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248449",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861420",
          "startTime": 1563217200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852309",
            "mealTime": 1563231600,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136226",
              "startTime": 1563217200,
              "endTime": 1563218100,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            },
            {
              "jeId": "12136266",
              "startTime": 1563235200,
              "endTime": 1563246000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136929",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137726",
              "startTime": 1563218100,
              "endTime": 1563224400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248450",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861421",
          "startTime": 1563303600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135894",
              "startTime": 1563321600,
              "endTime": 1563332400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12137257",
              "startTime": 1563304500,
              "endTime": 1563310800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137269",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137961",
              "startTime": 1563303600,
              "endTime": 1563304500,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248451",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861422",
          "startTime": 1563390000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563390000,
            "endTime": 1563422400
          },
          "assignments": [
            {
              "jeId": "12136585",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            },
            {
              "jeId": "12137338",
              "startTime": 1563390000,
              "endTime": 1563390900,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786410",
              "jobId": "5083621",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            },
            {
              "jeId": "12137346",
              "startTime": 1563390900,
              "endTime": 1563397200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248452",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861423",
          "startTime": 1563462000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELEX L3",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136677",
              "startTime": 1563462000,
              "endTime": 1563490800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248453",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861424",
          "startTime": 1563562800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136002",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248454",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861425",
          "startTime": 1563649200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136423",
              "startTime": 1563649200,
              "endTime": 1563650100,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 2K - Path Update",
              "comment": null
            },
            {
              "jeId": "12136433",
              "startTime": 1563650100,
              "endTime": 1563656400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136443",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137174",
              "startTime": 1563667200,
              "endTime": 1563676200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248455",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861426",
          "startTime": 1563735600,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563782400
          },
          "assignments": [
            {
              "jeId": "12137506",
              "startTime": 1563736500,
              "endTime": 1563753600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137507",
              "startTime": 1563757200,
              "endTime": 1563768000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137508",
              "startTime": 1563774300,
              "endTime": 1563782400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137908",
              "startTime": 1563735600,
              "endTime": 1563736500,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17649",
    "class": "Resource",
    "name": "Sourias Angelo",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247913",
        "title": "DH NPT",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "DH NPT",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16247914",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860940",
          "startTime": 1563264000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9851838",
            "mealTime": 1563289200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136479",
              "startTime": 1563269400,
              "endTime": 1563278400,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136480",
              "startTime": 1563264000,
              "endTime": 1563269400,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136497",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12137309",
              "startTime": 1563278400,
              "endTime": 1563282000,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247915",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16247916",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860941",
          "startTime": 1563606000,
          "duration": 5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137123",
              "startTime": 1563615000,
              "endTime": 1563624000,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137124",
              "startTime": 1563606000,
              "endTime": 1563615000,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16247917",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860942",
          "startTime": 1563696000,
          "duration": 4,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137207",
              "startTime": 1563701400,
              "endTime": 1563710400,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137208",
              "startTime": 1563696000,
              "endTime": 1563701400,
              "service": "RB 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17653",
    "class": "Resource",
    "name": "Taliaferro Ivory",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248026",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861033",
          "startTime": 1563480000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851929",
            "mealTime": 1563480000,
            "red": true
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136321",
              "startTime": 1563501600,
              "endTime": 1563508800,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786299",
              "jobId": "5083510",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SATURDAY STANDBY COVERAGE -4E FLASH / 2K CR"
            },
            {
              "jeId": "12137432",
              "startTime": 1563494400,
              "endTime": 1563501600,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137808",
              "startTime": 1563483600,
              "endTime": 1563490800,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            },
            {
              "jeId": "12137819",
              "startTime": 1563490800,
              "endTime": 1563494400,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248027",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861034",
          "startTime": 1563555600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135726",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135739",
              "startTime": 1563570000,
              "endTime": 1563584400,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137058",
              "startTime": 1563555600,
              "endTime": 1563562800,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17654",
    "class": "Resource",
    "name": "TEMBORSKI EDWARD",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247947",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860966",
          "startTime": 1563219000,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": "11pm wrap up A2 equipment",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9851862",
            "mealTime": 1563228000,
            "red": false
          },
          "overtime": {
            "startTime": 1563219000,
            "endTime": 1563253200
          },
          "assignments": [
            {
              "jeId": "12135649",
              "startTime": 1563238800,
              "endTime": 1563246000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136239",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137747",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12137760",
              "startTime": 1563249600,
              "endTime": 1563253200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247948",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860967",
          "startTime": 1563305400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136530",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12137282",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137297",
              "startTime": 1563325200,
              "endTime": 1563334200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247949",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860968",
          "startTime": 1563391800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "11pm wrap up A2 equipment",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136569",
              "startTime": 1563411600,
              "endTime": 1563420600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137475",
              "startTime": 1563392700,
              "endTime": 1563395400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16247950",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860969",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "3pm in time confirmed CM",
          "tourComment": "con fkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136006",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247951",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860970",
          "startTime": 1563651000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "11pm wrap up A2 equipment",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135786",
              "startTime": 1563670800,
              "endTime": 1563679800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12137154",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137873",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247952",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860971",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "PEDCAM ELEX 3A STUDIO",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137513",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17659",
    "class": "Resource",
    "name": "Youmans Douglas",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248136",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861128",
          "startTime": 1563213600,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852024",
            "mealTime": 1563220800,
            "red": false
          },
          "overtime": {
            "startTime": 1563213600,
            "endTime": 1563244200
          },
          "assignments": [
            {
              "jeId": "12135988",
              "startTime": 1563238800,
              "endTime": 1563244200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786256",
              "jobId": "5083467",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11th Hour Looksee - CR 2K / Plaza Prod Nook #4"
            },
            {
              "jeId": "12136208",
              "startTime": 1563235200,
              "endTime": 1563238800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148C",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136257",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "Video & LD 3 PM",
              "activityType": "148C",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136960",
              "startTime": 1563228000,
              "endTime": 1563235200,
              "service": "Video & LD HARDBALL",
              "activityType": "148C",
              "requestNumber": "3786375",
              "jobId": "5083586",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137743",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "Video & LD 5 PM",
              "activityType": "148C",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248137",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861129",
          "startTime": 1563310800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563310800,
            "endTime": 1563343200
          },
          "assignments": [
            {
              "jeId": "12136534",
              "startTime": 1563314400,
              "endTime": 1563321600,
              "service": "Video & LD HARDBALL",
              "activityType": "148C",
              "requestNumber": "3786318",
              "jobId": "5083529",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137441",
              "startTime": 1563321600,
              "endTime": 1563343200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786425",
              "jobId": "5083636",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            }
          ]
        }
      },
      {
        "rdtId": "16248138",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861130",
          "startTime": 1563386400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136576",
              "startTime": 1563400800,
              "endTime": 1563411600,
              "service": "Video & LD HARDBALL",
              "activityType": "148C",
              "requestNumber": "3786323",
              "jobId": "5083534",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            }
          ]
        }
      },
      {
        "rdtId": "16248139",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861131",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137467",
              "startTime": 1563562800,
              "endTime": 1563591600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786428",
              "jobId": "5083639",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248140",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861132",
          "startTime": 1563645600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137090",
              "startTime": 1563667200,
              "endTime": 1563670800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148C",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137142",
              "startTime": 1563645600,
              "endTime": 1563652800,
              "service": "Video & LD 3 PM",
              "activityType": "148C",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137163",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "Video & LD HARDBALL",
              "activityType": "148C",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137555",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786439",
              "jobId": "5083650",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELEX BLOCKING 3A STUDIO / 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16248141",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861133",
          "startTime": 1563746400,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563746400,
            "endTime": 1563789600
          },
          "assignments": [
            {
              "jeId": "12137505",
              "startTime": 1563746400,
              "endTime": 1563775200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17671",
    "class": "Resource",
    "name": "Dailey Karen",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "17681",
    "class": "Resource",
    "name": "OAKLEY JAMES",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248079",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861080",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "LIGHTING REFOCUS FOR LIVE 4PM IN STUDIO 3A WHEN POSSIBLE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851976",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136970",
              "startTime": 1563192000,
              "endTime": 1563195600,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786376",
              "jobId": "5083587",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 3A MJ relief/Standby",
              "comment": null
            },
            {
              "jeId": "12136992",
              "startTime": 1563202800,
              "endTime": 1563211800,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            },
            {
              "jeId": "12137692",
              "startTime": 1563195600,
              "endTime": 1563202800,
              "service": "Video & LD 10 AM",
              "activityType": "148C",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            }
          ]
        }
      },
      {
        "rdtId": "16248080",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861081",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "LIGHTING REFOCUS FOR LIVE 4PM IN STUDIO 3A WHEN POSSIBLE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135863",
              "startTime": 1563289200,
              "endTime": 1563296400,
              "service": "Video & LD MITCHELL",
              "activityType": "148C",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12135868",
              "startTime": 1563296400,
              "endTime": 1563303600,
              "service": "Video & LD 2 PM",
              "activityType": "148C",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12135905",
              "startTime": 1563278400,
              "endTime": 1563282000,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786239",
              "jobId": "5083450",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 3A MJ relief/Standby",
              "comment": null
            },
            {
              "jeId": "12136492",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "Video & LD 10 AM",
              "activityType": "148C",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            }
          ]
        }
      },
      {
        "rdtId": "16248081",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861082",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "LIGHTING REFOCUS FOR LIVE 4PM IN STUDIO 3A WHEN POSSIBLE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135676",
              "startTime": 1563368400,
              "endTime": 1563386400,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12135947",
              "startTime": 1563364800,
              "endTime": 1563368400,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786245",
              "jobId": "5083456",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 3A MJ relief/Standby",
              "comment": null
            },
            {
              "jeId": "12137337",
              "startTime": 1563386400,
              "endTime": 1563390000,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786410",
              "jobId": "5083621",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 2K",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248082",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861083",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137410",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137770",
              "startTime": 1563627600,
              "endTime": 1563642000,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248083",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861084",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135820",
              "startTime": 1563728400,
              "endTime": 1563735600,
              "service": "Video & LD 2 PM",
              "activityType": "148C",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12135835",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "Video & LD 9 AM",
              "activityType": "148C",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12137907",
              "startTime": 1563724800,
              "endTime": 1563728400,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12137925",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "Video & LD 11 AM",
              "activityType": "148C",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17825",
    "class": "Resource",
    "name": "Lopez Roberto",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248202",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861189",
          "startTime": 1563177600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "booked 10/10 JP",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852083",
            "mealTime": 1563177600,
            "red": true
          },
          "overtime": {
            "startTime": 1563177600,
            "endTime": 1563206400
          },
          "assignments": [
            {
              "jeId": "12135671",
              "startTime": 1563177600,
              "endTime": 1563206400,
              "service": "Camera Utility Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786215",
              "jobId": "5083426",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248203",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861190",
          "startTime": 1563296400,
          "duration": 8.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248204",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861191",
          "startTime": 1563382800,
          "duration": 10.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563382800,
            "endTime": 1563420600
          }
        }
      },
      {
        "rdtId": "16248205",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861192",
          "startTime": 1563466500,
          "duration": 13.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563466500,
            "endTime": 1563514200
          }
        }
      },
      {
        "rdtId": "16248206",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861193",
          "startTime": 1563559200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "Booked as Jeff Laterno UT for MSNBC Election Night",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248207",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861194",
          "startTime": 1563615900,
          "duration": 18.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563615900,
            "endTime": 1563681600
          },
          "assignments": [
            {
              "jeId": "12135813",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "Camera Utility",
              "activityType": "1291A5",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137005",
              "startTime": 1563615900,
              "endTime": 1563644700,
              "service": "Camera Utility Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786381",
              "jobId": "5083592",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137110",
              "startTime": 1563644700,
              "endTime": 1563660000,
              "service": "Available Network",
              "activityType": "ZD5104",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137172",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "Camera Utility",
              "activityType": "1291A5",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137186",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "Camera Utility",
              "activityType": "1291A5",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248208",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861195",
          "startTime": 1563732000,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": "Booked as Jeff Laterno UT for MSNBC Election Night",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563778800
          }
        }
      }
    ]
  },
  {
    "rId": "17884",
    "class": "Resource",
    "name": "DOBISH ANDREW",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248325",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861308",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852197",
            "mealTime": 1563213600,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12137397",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "Graphics PB Op - Elections",
              "activityType": "149P",
              "requestNumber": "3786418",
              "jobId": "5083629",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248326",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861309",
          "startTime": 1563285600,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563285600,
            "endTime": 1563343200
          },
          "assignments": [
            {
              "jeId": "12135963",
              "startTime": 1563285600,
              "endTime": 1563343200,
              "service": "Graphics PB Op - Elections",
              "activityType": "149P",
              "requestNumber": "3786249",
              "jobId": "5083460",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248327",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861310",
          "startTime": 1563372000,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563372000,
            "endTime": 1563429600
          }
        }
      },
      {
        "rdtId": "16248328",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861311",
          "startTime": 1563454800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248329",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861312",
          "startTime": 1563541200,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": "ELEX",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248330",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861313",
          "startTime": 1563624000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563624000,
            "endTime": 1563667200
          }
        }
      },
      {
        "rdtId": "16248331",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861314",
          "startTime": 1563717600,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563717600,
            "endTime": 1563764400
          }
        }
      }
    ]
  },
  {
    "rId": "17885",
    "class": "Resource",
    "name": "ERRICHIELLO ANDREW",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247811",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860848",
          "startTime": 1563188400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851749",
            "mealTime": 1563213600,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135656",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "Audio A1 11 AM",
              "activityType": "149M",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136225",
              "startTime": 1563206400,
              "endTime": 1563209100,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12136946",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "Audio A1 9 AM",
              "activityType": "149M",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136969",
              "startTime": 1563188400,
              "endTime": 1563192000,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786376",
              "jobId": "5083587",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 2E Standby",
              "comment": null
            },
            {
              "jeId": "12137702",
              "startTime": 1563209100,
              "endTime": 1563213600,
              "service": "Audio A1 1 PM",
              "activityType": "149M",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247812",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860849",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135883",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "Audio A1 9 AM",
              "activityType": "149M",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136508",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "Audio A1 11 AM",
              "activityType": "149M",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137300",
              "startTime": 1563300000,
              "endTime": 1563303600,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137946",
              "startTime": 1563295500,
              "endTime": 1563300000,
              "service": "Audio A1 1 PM",
              "activityType": "149M",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137959",
              "startTime": 1563292800,
              "endTime": 1563295500,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247813",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860850",
          "startTime": 1563361200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135909",
              "startTime": 1563379200,
              "endTime": 1563386400,
              "service": "Audio A1 1 PM",
              "activityType": "149M",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12135945",
              "startTime": 1563361200,
              "endTime": 1563364800,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786245",
              "jobId": "5083456",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 2E Standby",
              "comment": null
            },
            {
              "jeId": "12137355",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "Audio A1 9 AM",
              "activityType": "149M",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137371",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "Audio A1 11 AM",
              "activityType": "149M",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247814",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860851",
          "startTime": 1563559200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16247815",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860852",
          "startTime": 1563620400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135751",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "Audio A1 9 AM",
              "activityType": "149M",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135795",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "Audio A1 11 AM",
              "activityType": "149M",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136394",
              "startTime": 1563641100,
              "endTime": 1563645600,
              "service": "Audio A1 1 PM",
              "activityType": "149M",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136421",
              "startTime": 1563638400,
              "endTime": 1563641100,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12136422",
              "startTime": 1563620400,
              "endTime": 1563624000,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2E STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247816",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860853",
          "startTime": 1563706800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135831",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "Audio A1 9 AM",
              "activityType": "149M",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12137242",
              "startTime": 1563706800,
              "endTime": 1563710400,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786403",
              "jobId": "5083614",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 2E Standby",
              "comment": null
            },
            {
              "jeId": "12137894",
              "startTime": 1563724800,
              "endTime": 1563732000,
              "service": "Audio A1 1 PM",
              "activityType": "149M",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137924",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "Audio A1 11 AM",
              "activityType": "149M",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248882",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861790",
          "startTime": 1563782400,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563782400,
            "endTime": 1563818400
          }
        }
      }
    ]
  },
  {
    "rId": "17886",
    "class": "Resource",
    "name": "Heck ALBERT",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248714",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861658",
          "startTime": 1563217200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852542",
            "mealTime": 1563228000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135651",
              "startTime": 1563238800,
              "endTime": 1563246000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136206",
              "startTime": 1563224400,
              "endTime": 1563228000,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136237",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137731",
              "startTime": 1563217200,
              "endTime": 1563224400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248715",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861659",
          "startTime": 1563303600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136654",
              "startTime": 1563310800,
              "endTime": 1563314400,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786334",
              "jobId": "5083545",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Podcast RR #764S-3"
            },
            {
              "jeId": "12137262",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137278",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137298",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248716",
        "title": "Vacation Single Day",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation Single Day",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248717",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861660",
          "startTime": 1563566400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "will be in at 5p",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136005",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248718",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861661",
          "startTime": 1563649200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135787",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12137553",
              "startTime": 1563652800,
              "endTime": 1563663600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786439",
              "jobId": "5083650",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELEX BLOCKING 3A STUDIO / 3A CONTROL"
            },
            {
              "jeId": "12137869",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248719",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861662",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "PED ELEX 3A STUDIO",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137511",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17888",
    "class": "Resource",
    "name": "MILLER BRUCE",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248428",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861402",
          "startTime": 1563201000,
          "duration": 13.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852291",
            "mealTime": 1563224400,
            "red": false
          },
          "overtime": {
            "startTime": 1563201000,
            "endTime": 1563249600
          },
          "assignments": [
            {
              "jeId": "12135990",
              "startTime": 1563242400,
              "endTime": 1563244200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786256",
              "jobId": "5083467",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11th Hour Looksee - CR 2K / Plaza Prod Nook #4"
            },
            {
              "jeId": "12136275",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136958",
              "startTime": 1563228000,
              "endTime": 1563235200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786375",
              "jobId": "5083586",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137753",
              "startTime": 1563244200,
              "endTime": 1563249600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248429",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861403",
          "startTime": 1563287400,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563287400,
            "endTime": 1563330600
          },
          "assignments": [
            {
              "jeId": "12135903",
              "startTime": 1563321600,
              "endTime": 1563330600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248430",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861404",
          "startTime": 1563373800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563373800,
            "endTime": 1563417000
          }
        }
      },
      {
        "rdtId": "16248431",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861405",
          "startTime": 1563451200,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248432",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861406",
          "startTime": 1563541200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "network elections OTE for afternoon Elections REH",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136018",
              "startTime": 1563566400,
              "endTime": 1563580800,
              "service": "Graphics PB Op L3 WE Nightly News",
              "activityType": "149P",
              "requestNumber": "3786262",
              "jobId": "5083473",
              "costObject": "WKD Nightly O&TS",
              "costObjectNumber": "J0A206290",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248433",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861407",
          "startTime": 1563631200,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "MJ FRO RELIEF",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563631200,
            "endTime": 1563674400
          },
          "assignments": [
            {
              "jeId": "12136021",
              "startTime": 1563652800,
              "endTime": 1563667200,
              "service": "Graphics PB Op L3 Nightly News",
              "activityType": "149P",
              "requestNumber": "3786264",
              "jobId": "5083475",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137183",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248434",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861408",
          "startTime": 1563721200,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": "MJ FRO RELIEF",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563721200,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12136025",
              "startTime": 1563721200,
              "endTime": 1563752700,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786265",
              "jobId": "5083476",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17891",
    "class": "Resource",
    "name": "Sweetman BERNARD",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247938",
        "title": "Payback, Non Mand",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Payback, Non Mand",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16247939",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860959",
          "startTime": 1563303600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851855",
            "mealTime": 1563314400,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136529",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "A2 3K",
              "activityType": "148E",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12137280",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137296",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12137306",
              "startTime": 1563303600,
              "endTime": 1563307200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247940",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860960",
          "startTime": 1563390000,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563390000,
            "endTime": 1563429600
          },
          "assignments": [
            {
              "jeId": "12136568",
              "startTime": 1563411600,
              "endTime": 1563418800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136697",
              "startTime": 1563418800,
              "endTime": 1563429600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786341",
              "jobId": "5083552",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            },
            {
              "jeId": "12137351",
              "startTime": 1563390000,
              "endTime": 1563400800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247941",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10860961",
          "startTime": 1563472800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136663",
              "startTime": 1563472800,
              "endTime": 1563483600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137437",
              "startTime": 1563494400,
              "endTime": 1563501600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137823",
              "startTime": 1563487200,
              "endTime": 1563494400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247942",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10860962",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "3pm in time confirmed CM",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16247943",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860963",
          "startTime": 1563649200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135785",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12137153",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137871",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247944",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860964",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "SM ELEX 3A STUDIO",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137501",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "17986",
    "class": "Resource",
    "name": "ABLINE KATIE",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248520",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861488",
          "startTime": 1563175800,
          "duration": 10.5,
          "remainDuration": null,
          "notificationComment": "can SM or robo election blocking until 2:00",
          "tourComment": "CONF CM",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852377",
            "mealTime": 1563210000,
            "red": false
          },
          "overtime": {
            "startTime": 1563175800,
            "endTime": 1563213600
          },
          "assignments": [
            {
              "jeId": "12136915",
              "startTime": 1563183000,
              "endTime": 1563195600,
              "service": "SM 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136916",
              "startTime": 1563175800,
              "endTime": 1563183000,
              "service": "SM 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "SM/UTIL",
              "comment": "9AM MJ CR READ THROUGH"
            }
          ]
        }
      },
      {
        "rdtId": "16248521",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861489",
          "startTime": 1563269400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "emd",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136486",
              "startTime": 1563269400,
              "endTime": 1563283800,
              "service": "SM 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248522",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861490",
          "startTime": 1563348600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248523",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861491",
          "startTime": 1563454800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "stage dayside",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563498000
          },
          "assignments": [
            {
              "jeId": "12136679",
              "startTime": 1563454800,
              "endTime": 1563486300,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137044",
              "startTime": 1563488100,
              "endTime": 1563498000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137817",
              "startTime": 1563486300,
              "endTime": 1563488100,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248524",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861492",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135755",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "PR 2K MS",
              "activityType": "148E",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135791",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136415",
              "startTime": 1563643800,
              "endTime": 1563649200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137893",
              "startTime": 1563638400,
              "endTime": 1563643800,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786485",
              "jobId": "5083696",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "SHARPTON RADIO SHOW - 7TH FLOOR RADIO ROOM # 764S-3",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248525",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861493",
          "startTime": 1563692400,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "PLEASE HELP WITH PED SET UP IF YOU CAN..LITTLE SHORT HANDED THERE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563692400,
            "endTime": 1563728400
          },
          "assignments": [
            {
              "jeId": "12136618",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": "SET UP 8H",
              "comment": null
            },
            {
              "jeId": "12137206",
              "startTime": 1563692400,
              "endTime": 1563714000,
              "service": "A2 3A  MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "18159",
    "class": "Resource",
    "name": "Lambert Enid",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248772",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248773",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861709",
          "startTime": 1563282000,
          "duration": 10.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852593",
            "mealTime": 1563296400,
            "red": false
          },
          "overtime": {
            "startTime": 1563282000,
            "endTime": 1563320700
          },
          "assignments": [
            {
              "jeId": "12136016",
              "startTime": 1563315300,
              "endTime": 1563320700,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786260",
              "jobId": "5083471",
              "costObject": "Syfy Wire Editorial",
              "costObjectNumber": "KD-001.20",
              "description": "Syfy- Two hosts in studio, one call in",
              "comment": null
            },
            {
              "jeId": "12136518",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137307",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137308",
              "startTime": 1563292800,
              "endTime": 1563296400,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248774",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861710",
          "startTime": 1563370200,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563370200,
            "endTime": 1563404400
          },
          "assignments": [
            {
              "jeId": "12135913",
              "startTime": 1563379200,
              "endTime": 1563386400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136551",
              "startTime": 1563370200,
              "endTime": 1563375600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12137353",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137370",
              "startTime": 1563375600,
              "endTime": 1563379200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248775",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861711",
          "startTime": 1563453900,
          "duration": 11.25,
          "remainDuration": null,
          "notificationComment": "AM JOY NO STEADI/UTIL NEEDED please give kyle cooke a break and prompt for elex rehearsal",
          "tourComment": "CONFKP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563453900,
            "endTime": 1563494400
          },
          "assignments": [
            {
              "jeId": "12136337",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136666",
              "startTime": 1563469200,
              "endTime": 1563476400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": "please give kyle cooke a break and prompt for elex rehearsal",
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137023",
              "startTime": 1563464700,
              "endTime": 1563469200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137793",
              "startTime": 1563453900,
              "endTime": 1563461100,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            },
            {
              "jeId": "12137814",
              "startTime": 1563483600,
              "endTime": 1563490800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            },
            {
              "jeId": "12137826",
              "startTime": 1563490800,
              "endTime": 1563494400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248776",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861712",
          "startTime": 1563539400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136017",
              "startTime": 1563544800,
              "endTime": 1563552000,
              "service": "Tech Assoc MSNBC",
              "activityType": "148E",
              "requestNumber": "3786261",
              "jobId": "5083472",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": "Enid please go to 3AAudio and see Rob for directions",
              "comment": null
            },
            {
              "jeId": "12136357",
              "startTime": 1563539400,
              "endTime": 1563544800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137064",
              "startTime": 1563555600,
              "endTime": 1563562800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137073",
              "startTime": 1563562800,
              "endTime": 1563566400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248777",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861713",
          "startTime": 1563627600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "do not move/break meal ",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563627600,
            "endTime": 1563663600
          },
          "assignments": [
            {
              "jeId": "12136446",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137404",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137778",
              "startTime": 1563627600,
              "endTime": 1563642000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248778",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861714",
          "startTime": 1563717600,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135855",
              "startTime": 1563732000,
              "endTime": 1563739200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12136604",
              "startTime": 1563739200,
              "endTime": 1563760800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137930",
              "startTime": 1563717600,
              "endTime": 1563728400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "18481",
    "class": "Resource",
    "name": "Cook Lindsay",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248644",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861603",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852487",
            "mealTime": 1563206400,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135654",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136263",
              "startTime": 1563217200,
              "endTime": 1563220800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136954",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137720",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248645",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861604",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135860",
              "startTime": 1563289200,
              "endTime": 1563296400,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12135888",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136521",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137301",
              "startTime": 1563296400,
              "endTime": 1563300000,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248646",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861605",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136638",
              "startTime": 1563372000,
              "endTime": 1563382800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            },
            {
              "jeId": "12137362",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248647",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861606",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "robo",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136665",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248648",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861607",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "DO NOT ASSIGN",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135757",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137082",
              "startTime": 1563634800,
              "endTime": 1563652800,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248649",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861608",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "can only stay until 7pm",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135827",
              "startTime": 1563732000,
              "endTime": 1563735600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12135840",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12135852",
              "startTime": 1563735600,
              "endTime": 1563739200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137233",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            },
            {
              "jeId": "12137943",
              "startTime": 1563728400,
              "endTime": 1563732000,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786490",
              "jobId": "5083701",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "18497",
    "class": "Resource",
    "name": "Deuber Robert",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247709",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860754",
          "startTime": 1563421500,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9851657",
            "mealTime": 1563360300,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136316",
              "startTime": 1563421500,
              "endTime": 1563446700,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786299",
              "jobId": "5083510",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SATURDAY STANDBY COVERAGE -4E FLASH / 2K CR"
            }
          ]
        }
      },
      {
        "rdtId": "16247710",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860755",
          "startTime": 1563505200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "Scheduled for 11p-7a, but extended tour until 8a afterwards, because of extra hour worked due to time change at 2a. ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563505200,
            "endTime": 1563537600
          },
          "assignments": [
            {
              "jeId": "12136317",
              "startTime": 1563505200,
              "endTime": 1563508800,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786299",
              "jobId": "5083510",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SATURDAY STANDBY COVERAGE -4E FLASH / 2K CR"
            },
            {
              "jeId": "12137049",
              "startTime": 1563508800,
              "endTime": 1563534000,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "18498",
    "class": "Resource",
    "name": "Jimenez William",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "18499",
    "class": "Resource",
    "name": "Swaratsingh Daniel",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247929",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860951",
          "startTime": 1563215400,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9851847",
            "mealTime": 1563224400,
            "red": false
          },
          "overtime": {
            "startTime": 1563215400,
            "endTime": 1563246000
          },
          "assignments": [
            {
              "jeId": "12135648",
              "startTime": 1563240600,
              "endTime": 1563246000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136238",
              "startTime": 1563228000,
              "endTime": 1563238800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12136264",
              "startTime": 1563216300,
              "endTime": 1563224400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136276",
              "startTime": 1563238800,
              "endTime": 1563240600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16247930",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860952",
          "startTime": 1563303600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "STEPHEN TRAINING WITH YOU ON THE 4P PROMPTER",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135562",
              "startTime": 1563314400,
              "endTime": 1563318000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786199",
              "jobId": "5083410",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": "Nightly A2- Cynthia McFadden and Maria Shriver live tags on set",
              "comment": null
            },
            {
              "jeId": "12137259",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137281",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137294",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247931",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860953",
          "startTime": 1563390000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136011",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786258",
              "jobId": "5083469",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2E / 3A SDO"
            },
            {
              "jeId": "12136566",
              "startTime": 1563411600,
              "endTime": 1563418800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137568",
              "startTime": 1563400800,
              "endTime": 1563404400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786445",
              "jobId": "5083656",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": "Nightly A2 - Peter Alexandcer live tag on set.",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247932",
        "title": "Not Available (DH/FL Only) Available until 7pm",
        "myDayComment": "Available until 7pm",
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only) Available until 7pm",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": "Available until 7pm"
        }
      },
      {
        "rdtId": "16247933",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10860954",
          "startTime": 1563562800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "3pm in time confirmed CM",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135996",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247934",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860955",
          "startTime": 1563649200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "4P STEADI",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563649200,
            "endTime": 1563678000
          },
          "assignments": [
            {
              "jeId": "12135784",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12136439",
              "startTime": 1563649200,
              "endTime": 1563656400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136454",
              "startTime": 1563659100,
              "endTime": 1563663600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137872",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247935",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860956",
          "startTime": 1563735600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "STEADI 3A studio",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137528",
              "startTime": 1563735600,
              "endTime": 1563775200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "18632",
    "class": "Resource",
    "name": "Bruskin Daniel",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248604",
        "title": "Requested OFF",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Requested OFF",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248605",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861568",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852457",
            "mealTime": 1563300000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135907",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786240",
              "jobId": "5083451",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "2E STANDBY"
            },
            {
              "jeId": "12136535",
              "startTime": 1563314400,
              "endTime": 1563321600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786318",
              "jobId": "5083529",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137951",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248606",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861569",
          "startTime": 1563379200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136577",
              "startTime": 1563400800,
              "endTime": 1563408000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786323",
              "jobId": "5083534",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137479",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248607",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861570",
          "startTime": 1563638400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136398",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136414",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137158",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137164",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            }
          ]
        }
      },
      {
        "rdtId": "16248608",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861571",
          "startTime": 1563724800,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": " ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563724800,
            "endTime": 1563771600
          },
          "assignments": [
            {
              "jeId": "12135826",
              "startTime": 1563728400,
              "endTime": 1563735600,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12136462",
              "startTime": 1563735600,
              "endTime": 1563742800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "18643",
    "class": "Resource",
    "name": "Kotowski Kenneth",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248054",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861058",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/31 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851954",
            "mealTime": 1563318000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136526",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "Video & LD 5 PM",
              "activityType": "148C",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12136626",
              "startTime": 1563292800,
              "endTime": 1563310800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786328",
              "jobId": "5083539",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248055",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861059",
          "startTime": 1563382800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "COVERS MITCHELL, 1p Standby, Live 4p and 6p VLD (CHANGING GREGS DAYS)",
          "tourComment": "STANDBY",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137341",
              "startTime": 1563390000,
              "endTime": 1563390900,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786410",
              "jobId": "5083621",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            },
            {
              "jeId": "12137345",
              "startTime": 1563390900,
              "endTime": 1563397200,
              "service": "Video & LD 4 PM",
              "activityType": "148C",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248056",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861060",
          "startTime": 1563462000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "COVERS MEREDITH'S SHIFT INSTEAD OF NORMAL.  ADDY COVERS HIS SHIFT.  DAN V. Covers Addy's 9a-5p shift.",
          "tourComment": "CNF 10/18 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563462000,
            "endTime": 1563494400
          },
          "assignments": [
            {
              "jeId": "12135698",
              "startTime": 1563472800,
              "endTime": 1563480000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136334",
              "startTime": 1563480000,
              "endTime": 1563483600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137033",
              "startTime": 1563462000,
              "endTime": 1563472800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137820",
              "startTime": 1563487200,
              "endTime": 1563494400,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248057",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        }
      },
      {
        "rdtId": "16248058",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861061",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "LIGHTING REFOCUS FOR LIVE 4PM IN STUDIO 3A WHEN POSSIBLE  (BOOK FOR OAKLEY)",
          "tourComment": "BKD 10/17 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563624000,
            "endTime": 1563652800
          },
          "assignments": [
            {
              "jeId": "12135797",
              "startTime": 1563633900,
              "endTime": 1563638400,
              "service": "Video & LD 11 AM",
              "activityType": "148C",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137411",
              "startTime": 1563638400,
              "endTime": 1563652800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            }
          ]
        }
      },
      {
        "rdtId": "16248059",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861062",
          "startTime": 1563735600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136599",
              "startTime": 1563735600,
              "endTime": 1563760800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "18893",
    "class": "Resource",
    "name": "Fitzpatrick Kevin",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248343",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861326",
          "startTime": 1563192000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852215",
            "mealTime": 1563213600,
            "red": false
          },
          "overtime": {
            "startTime": 1563192000,
            "endTime": 1563224400
          },
          "assignments": [
            {
              "jeId": "12135661",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136227",
              "startTime": 1563206400,
              "endTime": 1563209100,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "Standby",
              "comment": null
            },
            {
              "jeId": "12136913",
              "startTime": 1563192000,
              "endTime": 1563193800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136948",
              "startTime": 1563193800,
              "endTime": 1563199200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137705",
              "startTime": 1563209100,
              "endTime": 1563213600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137727",
              "startTime": 1563217200,
              "endTime": 1563224400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248344",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861327",
          "startTime": 1563278400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563278400,
            "endTime": 1563310800
          },
          "assignments": [
            {
              "jeId": "12135886",
              "startTime": 1563280200,
              "endTime": 1563285600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136478",
              "startTime": 1563278400,
              "endTime": 1563280200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136511",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137258",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137950",
              "startTime": 1563295500,
              "endTime": 1563300000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137962",
              "startTime": 1563292800,
              "endTime": 1563295500,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "Standby",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248345",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861328",
          "startTime": 1563364800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563364800,
            "endTime": 1563397200
          },
          "assignments": [
            {
              "jeId": "12135912",
              "startTime": 1563381900,
              "endTime": 1563386400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136688",
              "startTime": 1563372000,
              "endTime": 1563374700,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786339",
              "jobId": "5083550",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Looksee - 3A west / CR 2K"
            },
            {
              "jeId": "12137339",
              "startTime": 1563379200,
              "endTime": 1563381900,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786410",
              "jobId": "5083621",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "Standby",
              "comment": null
            },
            {
              "jeId": "12137347",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137357",
              "startTime": 1563366600,
              "endTime": 1563372000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137375",
              "startTime": 1563374700,
              "endTime": 1563379200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248346",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861329",
          "startTime": 1563476400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "Cover Lori",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136336",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136345",
              "startTime": 1563483600,
              "endTime": 1563490800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137043",
              "startTime": 1563494400,
              "endTime": 1563498000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137435",
              "startTime": 1563498000,
              "endTime": 1563505200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            }
          ]
        }
      },
      {
        "rdtId": "16248347",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861330",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135731",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135742",
              "startTime": 1563570000,
              "endTime": 1563573600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136385",
              "startTime": 1563573600,
              "endTime": 1563588000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248348",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861331",
          "startTime": 1563624000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563624000,
            "endTime": 1563656400
          },
          "assignments": [
            {
              "jeId": "12135753",
              "startTime": 1563625800,
              "endTime": 1563631200,
              "service": "Graphics PB Op FS - 9 AM - GPO",
              "activityType": "149P",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135798",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "Graphics PB Op FS - 11 AM - GPO",
              "activityType": "149P",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136396",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "Graphics PB Op FS - 1 PM - GPO",
              "activityType": "149P",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136434",
              "startTime": 1563649200,
              "endTime": 1563656400,
              "service": "Graphics PB Op FS - 4 PM - GPO",
              "activityType": "149P",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136704",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786343",
              "jobId": "5083554",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "Cancelled - Hardball Pretape - 3A West / CR 2K"
            },
            {
              "jeId": "12137122",
              "startTime": 1563624000,
              "endTime": 1563625800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248349",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861332",
          "startTime": 1563710400,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563710400,
            "endTime": 1563753600
          },
          "assignments": [
            {
              "jeId": "12135833",
              "startTime": 1563712200,
              "endTime": 1563717600,
              "service": "Graphics PB Op FS - 9 AM - GPO",
              "activityType": "149P",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12136458",
              "startTime": 1563735600,
              "endTime": 1563742800,
              "service": "Graphics PB Op FS - 4 PM - GPO",
              "activityType": "149P",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137205",
              "startTime": 1563710400,
              "endTime": 1563712200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137527",
              "startTime": 1563742800,
              "endTime": 1563753600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137898",
              "startTime": 1563727500,
              "endTime": 1563732000,
              "service": "Graphics PB Op FS - 1 PM - GPO",
              "activityType": "149P",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137917",
              "startTime": 1563724800,
              "endTime": 1563727500,
              "service": "Graphics PB Op FS - Standby - GPO",
              "activityType": "149P",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "Standby",
              "comment": null
            },
            {
              "jeId": "12137927",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "Graphics PB Op FS - 11 AM - GPO",
              "activityType": "149P",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "19048",
    "class": "Resource",
    "name": "Driscoll Paul",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248668",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861626",
          "startTime": 1563217200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852510",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": {
            "startTime": 1563217200,
            "endTime": 1563249600
          },
          "assignments": [
            {
              "jeId": "12135992",
              "startTime": 1563242400,
              "endTime": 1563244200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786256",
              "jobId": "5083467",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11th Hour Looksee - CR 2K / Plaza Prod Nook #4"
            },
            {
              "jeId": "12136269",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "SM 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12137394",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786418",
              "jobId": "5083629",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137729",
              "startTime": 1563217200,
              "endTime": 1563224400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            },
            {
              "jeId": "12137755",
              "startTime": 1563244200,
              "endTime": 1563249600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248669",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861627",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135857",
              "startTime": 1563289200,
              "endTime": 1563296400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12136498",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12137260",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137458",
              "startTime": 1563296400,
              "endTime": 1563300000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786427",
              "jobId": "5083638",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Elx Looksee CR 2K / SDO 3AWEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248670",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861628",
          "startTime": 1563368400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135914",
              "startTime": 1563382800,
              "endTime": 1563386400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136547",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136552",
              "startTime": 1563375600,
              "endTime": 1563382800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12137349",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248671",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861629",
          "startTime": 1563627600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "Can't stay late",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135764",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136436",
              "startTime": 1563649200,
              "endTime": 1563656400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136706",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786343",
              "jobId": "5083554",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "Cancelled - Hardball Pretape - 3A West / CR 2K"
            },
            {
              "jeId": "12137864",
              "startTime": 1563627600,
              "endTime": 1563634800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248672",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861630",
          "startTime": 1563735600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "STAGE 3A WEST",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12136460",
              "startTime": 1563735600,
              "endTime": 1563742800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12136714",
              "startTime": 1563742800,
              "endTime": 1563775200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786345",
              "jobId": "5083556",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A WEST (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "19059",
    "class": "Resource",
    "name": "deKorte Nils",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247791",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860834",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/30 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851735",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136645",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            }
          ]
        }
      },
      {
        "rdtId": "16247792",
        "title": "Death In Family",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Death In Family",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        }
      },
      {
        "rdtId": "16247793",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860835",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135920",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "Audio A1 2 PM",
              "activityType": "149M",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136542",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "Audio A1 10 AM",
              "activityType": "149M",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136555",
              "startTime": 1563375600,
              "endTime": 1563382800,
              "service": "Audio A1 MITCHELL",
              "activityType": "149M",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            }
          ]
        }
      },
      {
        "rdtId": "16247794",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10860836",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137464",
              "startTime": 1563562800,
              "endTime": 1563591600,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786428",
              "jobId": "5083639",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247795",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860837",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "A1 for audio assist for during change over from Morning Joe to Day-side in 3A CTL",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135763",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "Audio A1 9 AM",
              "activityType": "149M",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135769",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "Audio A1 MITCHELL",
              "activityType": "149M",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136407",
              "startTime": 1563642000,
              "endTime": 1563649200,
              "service": "Audio A1 2 PM",
              "activityType": "149M",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137857",
              "startTime": 1563631200,
              "endTime": 1563634800,
              "service": "Audio A1 10 AM",
              "activityType": "149M",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16247796",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860838",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135819",
              "startTime": 1563731100,
              "endTime": 1563735600,
              "service": "Audio A1 2 PM",
              "activityType": "149M",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12137219",
              "startTime": 1563714000,
              "endTime": 1563721200,
              "service": "Audio A1 10 AM",
              "activityType": "149M",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137243",
              "startTime": 1563710400,
              "endTime": 1563714000,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786403",
              "jobId": "5083614",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 3A MJ relief/Standby",
              "comment": null
            },
            {
              "jeId": "12137913",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12137914",
              "startTime": 1563728400,
              "endTime": 1563731100,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "19079",
    "class": "Resource",
    "name": "Crowley Sean",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248029",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861036",
          "startTime": 1563204600,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": "REQ 1P MEAL.",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851932",
            "mealTime": 1563210000,
            "red": true
          },
          "assignments": [
            {
              "jeId": "12136211",
              "startTime": 1563213600,
              "endTime": 1563217200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6208",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136221",
              "startTime": 1563204600,
              "endTime": 1563210000,
              "service": "Video & LD MITCHELL",
              "activityType": "148C",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136231",
              "startTime": 1563217200,
              "endTime": 1563218100,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A- Path Update",
              "comment": null
            },
            {
              "jeId": "12136245",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "Video & LD HAYES",
              "activityType": "148C",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12136935",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "Video & LD 6 PM",
              "activityType": "148C",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137725",
              "startTime": 1563218100,
              "endTime": 1563224400,
              "service": "Video & LD 4 PM",
              "activityType": "148C",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248030",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861037",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "COVER ADDY - who works ET",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248031",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861038",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "LIGHTING REFOCUS FOR LIVE 4PM IN STUDIO 3A WHEN POSSIBLE  (BOOK FOR OAKLEY)",
          "tourComment": "CNF 10/30 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136009",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786258",
              "jobId": "5083469",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2E / 3A SDO"
            },
            {
              "jeId": "12136636",
              "startTime": 1563372000,
              "endTime": 1563390000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248032",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861039",
          "startTime": 1563476400,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/1 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563476400,
            "endTime": 1563507000
          },
          "assignments": [
            {
              "jeId": "12136015",
              "startTime": 1563492600,
              "endTime": 1563507000,
              "service": "LD",
              "activityType": "1291A5",
              "requestNumber": "3786259",
              "jobId": "5083470",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137561",
              "startTime": 1563476400,
              "endTime": 1563492600,
              "service": "Video V1 WE Nightly News",
              "activityType": "1291A5",
              "requestNumber": "3786443",
              "jobId": "5083654",
              "costObject": "WKD Nightly O&TS",
              "costObjectNumber": "J0A206290",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248033",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861040",
          "startTime": 1563528600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 11/1 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137468",
              "startTime": 1563528600,
              "endTime": 1563553800,
              "service": "LIGHTING DIRECTOR - MS",
              "activityType": "148C",
              "requestNumber": "3786429",
              "jobId": "5083640",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "LIGHTING SETUP FOR DAYSIDE PROGRAMMING FROM 3A WEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248034",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861041",
          "startTime": 1563615900,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "please start day at MJ with Gonzo on star desk",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137003",
              "startTime": 1563618600,
              "endTime": 1563644700,
              "service": "Video V1 Today 9am",
              "activityType": "148C",
              "requestNumber": "3786381",
              "jobId": "5083592",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137127",
              "startTime": 1563615900,
              "endTime": 1563618600,
              "service": "Video & LD MJ",
              "activityType": "148C",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248035",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861042",
          "startTime": 1563702300,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563702300,
            "endTime": 1563731100
          },
          "assignments": [
            {
              "jeId": "12137007",
              "startTime": 1563702300,
              "endTime": 1563731100,
              "service": "Video V1 Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786382",
              "jobId": "5083593",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "19389",
    "class": "Resource",
    "name": "Broll Daniel",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248595",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861559",
          "startTime": 1563197400,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "con fkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852448",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": {
            "startTime": 1563197400,
            "endTime": 1563228000
          },
          "assignments": [
            {
              "jeId": "12136217",
              "startTime": 1563202800,
              "endTime": 1563210000,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136649",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            },
            {
              "jeId": "12137698",
              "startTime": 1563198300,
              "endTime": 1563202800,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            },
            {
              "jeId": "12137749",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "PR 2K MS",
              "activityType": "148E",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248596",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861560",
          "startTime": 1563285600,
          "duration": 9.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563285600,
            "endTime": 1563320700
          },
          "assignments": [
            {
              "jeId": "12135561",
              "startTime": 1563310800,
              "endTime": 1563320700,
              "service": "Camera Robo Nightly News",
              "activityType": "148E",
              "requestNumber": "3786199",
              "jobId": "5083410",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136504",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137266",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137954",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248597",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861561",
          "startTime": 1563372000,
          "duration": 9.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563372000,
            "endTime": 1563407100
          },
          "assignments": [
            {
              "jeId": "12135924",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136012",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786258",
              "jobId": "5083469",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2E / 3A SDO"
            },
            {
              "jeId": "12136690",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786339",
              "jobId": "5083550",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Looksee - 3A west / CR 2K"
            },
            {
              "jeId": "12137567",
              "startTime": 1563397200,
              "endTime": 1563407100,
              "service": "Camera Robo Nightly News",
              "activityType": "148E",
              "requestNumber": "3786445",
              "jobId": "5083656",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248598",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861562",
          "startTime": 1563472800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136340",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136349",
              "startTime": 1563483600,
              "endTime": 1563487200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137045",
              "startTime": 1563489900,
              "endTime": 1563498000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137430",
              "startTime": 1563498000,
              "endTime": 1563501600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137816",
              "startTime": 1563487200,
              "endTime": 1563490800,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248599",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861563",
          "startTime": 1563551100,
          "duration": 9.25,
          "remainDuration": null,
          "notificationComment": "cannot come in earlier",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563551100,
            "endTime": 1563584400
          },
          "assignments": [
            {
              "jeId": "12135736",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135743",
              "startTime": 1563570000,
              "endTime": 1563573600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136387",
              "startTime": 1563573600,
              "endTime": 1563584400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137831",
              "startTime": 1563551100,
              "endTime": 1563555600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            },
            {
              "jeId": "12137840",
              "startTime": 1563555600,
              "endTime": 1563559200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248600",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861564",
          "startTime": 1563631200,
          "duration": 9.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563631200,
            "endTime": 1563666300
          },
          "assignments": [
            {
              "jeId": "12136023",
              "startTime": 1563656400,
              "endTime": 1563666300,
              "service": "Camera Robo Nightly News",
              "activityType": "148E",
              "requestNumber": "3786264",
              "jobId": "5083475",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137138",
              "startTime": 1563645600,
              "endTime": 1563652800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137777",
              "startTime": 1563631200,
              "endTime": 1563642000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248601",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861565",
          "startTime": 1563735600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "3A WEST ROBO",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136715",
              "startTime": 1563746400,
              "endTime": 1563775200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786345",
              "jobId": "5083556",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A WEST (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137937",
              "startTime": 1563735600,
              "endTime": 1563746400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "19524",
    "class": "Resource",
    "name": "Nasrallah Lori",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248437",
        "title": "Requested OFF",
        "myDayComment": "missing 1 weekend of work: 10/27 & 10/28 but i'll be out of town 10/22 thru 10/31",
        "dayOff": {
          "dorId": "0",
          "title": "Requested OFF",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": "missing 1 weekend of work: 10/27 & 10/28 but i'll be out of town 10/22 thru 10/31"
        }
      },
      {
        "rdtId": "16248438",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861409",
          "startTime": 1563454800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "Cover Felece",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852298",
            "mealTime": 1563465600,
            "red": false
          },
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563494400
          },
          "assignments": [
            {
              "jeId": "12135691",
              "startTime": 1563469200,
              "endTime": 1563476400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786218",
              "jobId": "5083429",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12135700",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137798",
              "startTime": 1563454800,
              "endTime": 1563465600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137811",
              "startTime": 1563483600,
              "endTime": 1563490800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            },
            {
              "jeId": "12137822",
              "startTime": 1563490800,
              "endTime": 1563494400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248439",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861410",
          "startTime": 1563543000,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563543000,
            "endTime": 1563577200
          },
          "assignments": [
            {
              "jeId": "12136363",
              "startTime": 1563543000,
              "endTime": 1563552000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12136375",
              "startTime": 1563570000,
              "endTime": 1563577200,
              "service": "Graphics Build Op",
              "activityType": "149P",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12137061",
              "startTime": 1563555600,
              "endTime": 1563562800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137067",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "19694",
    "class": "Resource",
    "name": "Downer Gerald",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247801",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16247802",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860841",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851742",
            "mealTime": 1563307200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135867",
              "startTime": 1563299100,
              "endTime": 1563303600,
              "service": "Audio A1 2 PM",
              "activityType": "149M",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137318",
              "startTime": 1563303600,
              "endTime": 1563307200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137969",
              "startTime": 1563296400,
              "endTime": 1563299100,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247803",
        "title": "DH PTO NABET",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "DH PTO NABET",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16247804",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860842",
          "startTime": 1563454800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "9A-9:45A - Setup and FACs 2K CTL for DR",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135688",
              "startTime": 1563469200,
              "endTime": 1563476400,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786218",
              "jobId": "5083429",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136332",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137800",
              "startTime": 1563457500,
              "endTime": 1563465600,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137801",
              "startTime": 1563454800,
              "endTime": 1563457500,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16247805",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860843",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135707",
              "startTime": 1563530400,
              "endTime": 1563535800,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12135716",
              "startTime": 1563535800,
              "endTime": 1563541200,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136351",
              "startTime": 1563541200,
              "endTime": 1563544800,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137830",
              "startTime": 1563548400,
              "endTime": 1563559200,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16247806",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860844",
          "startTime": 1563739200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 11/1 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137537",
              "startTime": 1563742800,
              "endTime": 1563746400,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786436",
              "jobId": "5083647",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC ELECTION NIGHT - 2K SUBSWITCH  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137542",
              "startTime": 1563739200,
              "endTime": 1563742800,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786437",
              "jobId": "5083648",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137543",
              "startTime": 1563746400,
              "endTime": 1563768000,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786437",
              "jobId": "5083648",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "19700",
    "class": "Resource",
    "name": "Kidda Lisa",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "20226",
    "class": "Resource",
    "name": "Pearson Sean",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247739",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860783",
          "startTime": 1563195600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851685",
            "mealTime": 1563195600,
            "red": true
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136210",
              "startTime": 1563199200,
              "endTime": 1563202800,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6212",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136218",
              "startTime": 1563202800,
              "endTime": 1563210000,
              "service": "TD MITCHELL",
              "activityType": "149N",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136230",
              "startTime": 1563217200,
              "endTime": 1563218100,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            },
            {
              "jeId": "12136233",
              "startTime": 1563210000,
              "endTime": 1563212700,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12137712",
              "startTime": 1563212700,
              "endTime": 1563217200,
              "service": "TD 2 PM",
              "activityType": "149N",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137724",
              "startTime": 1563218100,
              "endTime": 1563224400,
              "service": "TD 4 PM",
              "activityType": "149N",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16247740",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860784",
          "startTime": 1563289200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135861",
              "startTime": 1563289200,
              "endTime": 1563296400,
              "service": "TD MITCHELL",
              "activityType": "149N",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12137254",
              "startTime": 1563304500,
              "endTime": 1563310800,
              "service": "TD 4 PM",
              "activityType": "149N",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137273",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "TD 6 PM",
              "activityType": "149N",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137460",
              "startTime": 1563296400,
              "endTime": 1563300000,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786427",
              "jobId": "5083638",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Elx Looksee CR 2K / SDO 3AWEST"
            },
            {
              "jeId": "12137965",
              "startTime": 1563303600,
              "endTime": 1563304500,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247741",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860785",
          "startTime": 1563375600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136556",
              "startTime": 1563375600,
              "endTime": 1563382800,
              "service": "TD MITCHELL",
              "activityType": "149N",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136684",
              "startTime": 1563382800,
              "endTime": 1563386400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786338",
              "jobId": "5083549",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "Deadline WH Looksee- 3A WEST / CR 2K after Kornacki Digital wraps"
            },
            {
              "jeId": "12137342",
              "startTime": 1563390000,
              "endTime": 1563390900,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786410",
              "jobId": "5083621",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            },
            {
              "jeId": "12137343",
              "startTime": 1563390900,
              "endTime": 1563397200,
              "service": "TD 4 PM",
              "activityType": "149N",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247742",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860786",
          "startTime": 1563454800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "9A-9:45A - Setup and FACs 2K CTL for DR",
          "tourComment": "BKD 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135689",
              "startTime": 1563469200,
              "endTime": 1563476400,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786218",
              "jobId": "5083429",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12135696",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137802",
              "startTime": 1563457500,
              "endTime": 1563465600,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137803",
              "startTime": 1563454800,
              "endTime": 1563457500,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16247743",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860787",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135709",
              "startTime": 1563530400,
              "endTime": 1563535800,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12135715",
              "startTime": 1563535800,
              "endTime": 1563541200,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136364",
              "startTime": 1563541200,
              "endTime": 1563555600,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16247744",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860788",
          "startTime": 1563634800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135767",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "TD MITCHELL",
              "activityType": "149N",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136393",
              "startTime": 1563642000,
              "endTime": 1563645600,
              "service": "TD 1 PM",
              "activityType": "149N",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136425",
              "startTime": 1563649200,
              "endTime": 1563650100,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 2K - Path Update",
              "comment": null
            },
            {
              "jeId": "12136431",
              "startTime": 1563650100,
              "endTime": 1563656400,
              "service": "TD 4 PM",
              "activityType": "149N",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136450",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "TD 6 PM",
              "activityType": "149N",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            }
          ]
        }
      },
      {
        "rdtId": "16247745",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860789",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135844",
              "startTime": 1563732000,
              "endTime": 1563739200,
              "service": "TD 3 PM",
              "activityType": "149N",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137217",
              "startTime": 1563710400,
              "endTime": 1563721200,
              "service": "TD 10 AM",
              "activityType": "149N",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137234",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "TD MITCHELL",
              "activityType": "149N",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "20393",
    "class": "Resource",
    "name": "Erbeck Daniel",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248176",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248177",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248178",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248179",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248180",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        },
        "tour": null
      }
    ]
  },
  {
    "rId": "20419",
    "class": "Resource",
    "name": "Galardi Hal",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248697",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248698",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248699",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248700",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248701",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248702",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248703",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563681600,
          "endTime": 1563767940,
          "comment": null
        },
        "tour": null
      }
    ]
  },
  {
    "rId": "20672",
    "class": "Resource",
    "name": "Banasiak Michael",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248012",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248013",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861023",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851919",
            "mealTime": 1563303600,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136621",
              "startTime": 1563278400,
              "endTime": 1563303600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786328",
              "jobId": "5083539",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248014",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248015",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        }
      },
      {
        "rdtId": "16248016",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861024",
          "startTime": 1563566400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "jib..elex  Help out if needed  Talk with TM on duty / cannot work earlier",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136700",
              "startTime": 1563566400,
              "endTime": 1563595200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786342",
              "jobId": "5083553",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248017",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861025",
          "startTime": 1563625800,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": "HE CAN STAY LONGER",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563625800,
            "endTime": 1563656400
          },
          "assignments": [
            {
              "jeId": "12135762",
              "startTime": 1563625800,
              "endTime": 1563631200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136404",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136419",
              "startTime": 1563645600,
              "endTime": 1563656400,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137868",
              "startTime": 1563631200,
              "endTime": 1563634800,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248018",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861026",
          "startTime": 1563760800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "jib 3a studio",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137518",
              "startTime": 1563760800,
              "endTime": 1563771600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "20734",
    "class": "Resource",
    "name": "Kerns Simon",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248754",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861693",
          "startTime": 1563220800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852577",
            "mealTime": 1563220800,
            "red": false
          },
          "overtime": {
            "startTime": 1563220800,
            "endTime": 1563253200
          },
          "assignments": [
            {
              "jeId": "12136270",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "JB 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12137396",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786418",
              "jobId": "5083629",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137757",
              "startTime": 1563242400,
              "endTime": 1563253200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248755",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861694",
          "startTime": 1563307200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563307200,
            "endTime": 1563343200
          },
          "assignments": [
            {
              "jeId": "12135897",
              "startTime": 1563321600,
              "endTime": 1563328800,
              "service": "JB 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136537",
              "startTime": 1563314400,
              "endTime": 1563321600,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786318",
              "jobId": "5083529",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137322",
              "startTime": 1563310800,
              "endTime": 1563314400,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137442",
              "startTime": 1563336000,
              "endTime": 1563343200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786425",
              "jobId": "5083636",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            },
            {
              "jeId": "12137994",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248756",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861695",
          "startTime": 1563393600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563393600,
            "endTime": 1563429600
          },
          "assignments": [
            {
              "jeId": "12136579",
              "startTime": 1563400800,
              "endTime": 1563408000,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786323",
              "jobId": "5083534",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12136590",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            },
            {
              "jeId": "12136696",
              "startTime": 1563422400,
              "endTime": 1563429600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786341",
              "jobId": "5083552",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            }
          ]
        }
      },
      {
        "rdtId": "16248757",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861696",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136668",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248758",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861697",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "CHECK WITH TM ABOUT MEAL",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135997",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248759",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861698",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135809",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137179",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "JB 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            },
            {
              "jeId": "12137552",
              "startTime": 1563652800,
              "endTime": 1563663600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786439",
              "jobId": "5083650",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELEX BLOCKING 3A STUDIO / 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16248760",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861699",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "JIB 3A STUDIO",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137529",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21115",
    "class": "Resource",
    "name": "McKelvey Kareem",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248807",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248808",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248809",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248810",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248811",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248812",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248813",
        "title": "Vacation",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Vacation",
          "startTime": 1563681600,
          "endTime": 1563767940,
          "comment": null
        },
        "tour": null
      }
    ]
  },
  {
    "rId": "21333",
    "class": "Resource",
    "name": "Miho William",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247855",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860890",
          "startTime": 1563444000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851791",
            "mealTime": 1563458400,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136326",
              "startTime": 1563444000,
              "endTime": 1563451200,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            },
            {
              "jeId": "12137024",
              "startTime": 1563462000,
              "endTime": 1563472800,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137782",
              "startTime": 1563451200,
              "endTime": 1563458400,
              "service": "Audio A1 WEEKEND",
              "activityType": "149M",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            }
          ]
        }
      },
      {
        "rdtId": "16247856",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860891",
          "startTime": 1563508800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137056",
              "startTime": 1563508800,
              "endTime": 1563534000,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21361",
    "class": "Resource",
    "name": "Greenwood Keith",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "21372",
    "class": "Resource",
    "name": "Harris Gregory",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248183",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861170",
          "startTime": 1563181200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "COVER PED FOR MJ",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852066",
            "mealTime": 1563195600,
            "red": false
          },
          "overtime": {
            "startTime": 1563181200,
            "endTime": 1563213600
          },
          "assignments": [
            {
              "jeId": "12136914",
              "startTime": 1563181200,
              "endTime": 1563195600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12137002",
              "startTime": 1563199200,
              "endTime": 1563213600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248184",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861171",
          "startTime": 1563267600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "COVER PED FOR MJ",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136489",
              "startTime": 1563267600,
              "endTime": 1563296400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248185",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861172",
          "startTime": 1563354000,
          "duration": 11.5,
          "remainDuration": null,
          "notificationComment": "COVER PED FOR MJ",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563354000,
            "endTime": 1563395400
          },
          "assignments": [
            {
              "jeId": "12135685",
              "startTime": 1563372000,
              "endTime": 1563386400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12137478",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248186",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861173",
          "startTime": 1563465600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137559",
              "startTime": 1563465600,
              "endTime": 1563494400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786441",
              "jobId": "5083652",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248187",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861174",
          "startTime": 1563553800,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563553800,
            "endTime": 1563588000
          },
          "assignments": [
            {
              "jeId": "12135737",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135747",
              "startTime": 1563570000,
              "endTime": 1563573600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136380",
              "startTime": 1563573600,
              "endTime": 1563584400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12137066",
              "startTime": 1563554700,
              "endTime": 1563562800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248188",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861175",
          "startTime": 1563616800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135761",
              "startTime": 1563620400,
              "endTime": 1563631200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135777",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135801",
              "startTime": 1563634800,
              "endTime": 1563638400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137867",
              "startTime": 1563631200,
              "endTime": 1563634800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248189",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861176",
          "startTime": 1563742800,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563742800,
            "endTime": 1563778800
          }
        }
      }
    ]
  },
  {
    "rId": "21374",
    "class": "Resource",
    "name": "Barroso Joey",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248573",
        "title": "Remote Asn (ST)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861540",
          "startTime": 1563199200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "HARDBALL REMOTE",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852429",
            "mealTime": 1563210000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135986",
              "startTime": 1563199200,
              "endTime": 1563228000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786255",
              "jobId": "5083466",
              "costObject": "MSNBC Hardball Houston 2018",
              "costObjectNumber": "NM-S18.032",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248574",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861541",
          "startTime": 1563282900,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135872",
              "startTime": 1563297300,
              "endTime": 1563303600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136507",
              "startTime": 1563282900,
              "endTime": 1563292800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137261",
              "startTime": 1563303600,
              "endTime": 1563311700,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248575",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861542",
          "startTime": 1563368400,
          "duration": 8.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563368400,
            "endTime": 1563398100
          },
          "assignments": [
            {
              "jeId": "12135925",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136549",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12137350",
              "startTime": 1563390000,
              "endTime": 1563398100,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137369",
              "startTime": 1563375600,
              "endTime": 1563379200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248576",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861543",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "cant stay late",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563487200
          },
          "assignments": [
            {
              "jeId": "12136673",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248577",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861544",
          "startTime": 1563628500,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "cannot stay later",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136437",
              "startTime": 1563649200,
              "endTime": 1563657300,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137557",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786440",
              "jobId": "5083651",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2K / Plaza"
            },
            {
              "jeId": "12137776",
              "startTime": 1563628500,
              "endTime": 1563642000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248578",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861545",
          "startTime": 1563732000,
          "duration": 13.25,
          "remainDuration": null,
          "notificationComment": "A2 ELEX 3A STUDIO/  CAN ONLY WORK UNTIL 4AM",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563779700
          },
          "assignments": [
            {
              "jeId": "12137517",
              "startTime": 1563732000,
              "endTime": 1563779700,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21430",
    "class": "Resource",
    "name": "Mathews Victor",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248801",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861730",
          "startTime": 1563202800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf ap",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852614",
            "mealTime": 1563228000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136653",
              "startTime": 1563202800,
              "endTime": 1563217200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            }
          ]
        }
      },
      {
        "rdtId": "16248802",
        "title": "Not Available (DH/FL Only) only avail after 5pm",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only) only avail after 5pm",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248803",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861731",
          "startTime": 1563537600,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "JIB REHEARSAL (GRAPHICS TESTING) - outside 10:45-2pm",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563537600,
            "endTime": 1563580800
          },
          "assignments": [
            {
              "jeId": "12137451",
              "startTime": 1563537600,
              "endTime": 1563546600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248804",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861732",
          "startTime": 1563750000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "BREAKER FOR DEMOC PLAZA AND 3A STUDIO BREAKER...JIB",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563750000,
            "endTime": 1563782400
          }
        }
      }
    ]
  },
  {
    "rId": "21576",
    "class": "Resource",
    "name": "Lotito Curtis",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248401",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861375",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852264",
            "mealTime": 1563199200,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          }
        }
      },
      {
        "rdtId": "16248402",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861376",
          "startTime": 1563285600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248403",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861377",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248404",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861378",
          "startTime": 1563454800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248405",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861379",
          "startTime": 1563523200,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137011",
              "startTime": 1563523200,
              "endTime": 1563552000,
              "service": "Graphics PB Op - Elections",
              "activityType": "149P",
              "requestNumber": "3786383",
              "jobId": "5083594",
              "costObject": "MEET THE PRESS PRODUCTION",
              "costObjectNumber": "J0A203130",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248406",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861380",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248407",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861381",
          "startTime": 1563735600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563775200
          }
        }
      }
    ]
  },
  {
    "rId": "21722",
    "class": "Resource",
    "name": "Long Kevin",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248392",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861366",
          "startTime": 1563199200,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": "network elections",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852255",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563229800
          }
        }
      },
      {
        "rdtId": "16248393",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861367",
          "startTime": 1563285600,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": "network elections",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563285600,
            "endTime": 1563316200
          }
        }
      },
      {
        "rdtId": "16248394",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861368",
          "startTime": 1563372000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "network elections",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563372000,
            "endTime": 1563408000
          }
        }
      },
      {
        "rdtId": "16248395",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861369",
          "startTime": 1563451200,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "network elections and weekend nightly",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137562",
              "startTime": 1563480000,
              "endTime": 1563494400,
              "service": "Graphics PB Op FS WE Nightly",
              "activityType": "149P",
              "requestNumber": "3786443",
              "jobId": "5083654",
              "costObject": "WKD Nightly O&TS",
              "costObjectNumber": "J0A206290",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248396",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861370",
          "startTime": 1563523200,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": "meet the press and network elections and weekend nightly",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136019",
              "startTime": 1563566400,
              "endTime": 1563580800,
              "service": "Graphics PB Op FS WE Nightly",
              "activityType": "149P",
              "requestNumber": "3786262",
              "jobId": "5083473",
              "costObject": "WKD Nightly O&TS",
              "costObjectNumber": "J0A206290",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137012",
              "startTime": 1563523200,
              "endTime": 1563552000,
              "service": "Graphics PB Op - Elections",
              "activityType": "149P",
              "requestNumber": "3786383",
              "jobId": "5083594",
              "costObject": "MEET THE PRESS PRODUCTION",
              "costObjectNumber": "J0A203130",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248397",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861371",
          "startTime": 1563631200,
          "duration": 10.75,
          "remainDuration": null,
          "notificationComment": "VIZ LEAD",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563631200,
            "endTime": 1563669900
          },
          "assignments": [
            {
              "jeId": "12136022",
              "startTime": 1563652800,
              "endTime": 1563667200,
              "service": "Graphics PB Op FS Nightly News",
              "activityType": "149P",
              "requestNumber": "3786264",
              "jobId": "5083475",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248398",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861372",
          "startTime": 1563721200,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": "VIZ LEAD",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563721200,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12136026",
              "startTime": 1563721200,
              "endTime": 1563752700,
              "service": "Graphics PB Op FS Nightly News",
              "activityType": "149P",
              "requestNumber": "3786265",
              "jobId": "5083476",
              "costObject": "NIGHTLY O&TS",
              "costObjectNumber": "J0A206280",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21767",
    "class": "Resource",
    "name": "Schumann Rebecca",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248485",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861456",
          "startTime": 1563202800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852345",
            "mealTime": 1563228000,
            "red": false
          }
        }
      },
      {
        "rdtId": "16248486",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861457",
          "startTime": 1563303600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563303600,
            "endTime": 1563343200
          }
        }
      },
      {
        "rdtId": "16248487",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861458",
          "startTime": 1563390000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248488",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861459",
          "startTime": 1563469200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "elex rehearsal",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248489",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861460",
          "startTime": 1563562800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "ELEX",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248490",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861461",
          "startTime": 1563645600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248491",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861462",
          "startTime": 1563735600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563775200
          }
        }
      },
      {
        "rdtId": "16248887",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861795",
          "startTime": 1563825600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137091",
              "startTime": 1563847200,
              "endTime": 1563854400,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA149P",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21798",
    "class": "Resource",
    "name": "Stone Austin",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248503",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861473",
          "startTime": 1563172200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9852362",
            "mealTime": 1563197400,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136919",
              "startTime": 1563172200,
              "endTime": 1563197400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            }
          ]
        }
      },
      {
        "rdtId": "16248504",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861474",
          "startTime": 1563258600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136482",
              "startTime": 1563258600,
              "endTime": 1563283800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248505",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861475",
          "startTime": 1563345000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248506",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861476",
          "startTime": 1563594300,
          "duration": 10.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563594300,
            "endTime": 1563633000
          },
          "assignments": [
            {
              "jeId": "12137129",
              "startTime": 1563604200,
              "endTime": 1563629400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248507",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861477",
          "startTime": 1563680700,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563680700,
            "endTime": 1563720300
          },
          "assignments": [
            {
              "jeId": "12137210",
              "startTime": 1563690600,
              "endTime": 1563716700,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248508",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861478",
          "startTime": 1563757200,
          "duration": 12.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563757200,
            "endTime": 1563803100
          },
          "assignments": [
            {
              "jeId": "12137522",
              "startTime": 1563757200,
              "endTime": 1563771600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21885",
    "class": "Resource",
    "name": "May Robert",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247848",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860883",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9851784",
            "mealTime": 1563220800,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12136256",
              "startTime": 1563216300,
              "endTime": 1563220800,
              "service": "Audio A1 3 PM",
              "activityType": "149M",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136302",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786296",
              "jobId": "5083507",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12136990",
              "startTime": 1563199200,
              "endTime": 1563216300,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16247849",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860884",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "OTT - 5p-8p - CR74",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136642",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786332",
              "jobId": "5083543",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "CR 2K audio for elex night"
            },
            {
              "jeId": "12137247",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            }
          ]
        }
      },
      {
        "rdtId": "16247850",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860885",
          "startTime": 1563379200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136580",
              "startTime": 1563400800,
              "endTime": 1563408000,
              "service": "Audio A1 Hardball",
              "activityType": "149M",
              "requestNumber": "3786323",
              "jobId": "5083534",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            }
          ]
        }
      },
      {
        "rdtId": "16247851",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860886",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136658",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247852",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860887",
          "startTime": 1563541200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563541200,
            "endTime": 1563577200
          },
          "assignments": [
            {
              "jeId": "12137447",
              "startTime": 1563541200,
              "endTime": 1563555600,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247853",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860888",
          "startTime": 1563638400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136428",
              "startTime": 1563642000,
              "endTime": 1563645600,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12137141",
              "startTime": 1563648300,
              "endTime": 1563652800,
              "service": "Audio A1 3 PM",
              "activityType": "149M",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137165",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "Audio A1 Hardball",
              "activityType": "149M",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137490",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "Training MSNBC",
              "activityType": "TR6211",
              "requestNumber": "3786434",
              "jobId": "5083645",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "TRAIN: MATT IN CR 74",
              "comment": null
            },
            {
              "jeId": "12137558",
              "startTime": 1563645600,
              "endTime": 1563648300,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786440",
              "jobId": "5083651",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2K / Plaza"
            }
          ]
        }
      },
      {
        "rdtId": "16247854",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860889",
          "startTime": 1563739200,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563739200,
            "endTime": 1563789600
          },
          "assignments": [
            {
              "jeId": "12137497",
              "startTime": 1563739200,
              "endTime": 1563775200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21924",
    "class": "Resource",
    "name": "Nosal Daniel",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248839",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861755",
          "startTime": 1563202800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "JIB DEMOCRACY PLAZA",
          "tourComment": "conf CM",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852639",
            "mealTime": 1563210000,
            "red": false
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248840",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861756",
          "startTime": 1563303600,
          "duration": 9.75,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf CM",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248841",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861757",
          "startTime": 1563390000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "JIB DEMOCRACY PLAZA",
          "tourComment": "conf CM",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248842",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861758",
          "startTime": 1563469200,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "hours tbd/ JIB DEMOCRACY PLAZA",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563469200,
            "endTime": 1563508800
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248843",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861759",
          "startTime": 1563559200,
          "duration": 12.5,
          "remainDuration": null,
          "notificationComment": "DEMOCRACY PLAZA JIB",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563559200,
            "endTime": 1563604200
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248844",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861760",
          "startTime": 1563645600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf CM",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563645600,
            "endTime": 1563681600
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248845",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861761",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "JIB DEMOCRACY PLAZA",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": null
        }
      }
    ]
  },
  {
    "rId": "21941",
    "class": "Resource",
    "name": "Powers Brian",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247748",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860792",
          "startTime": 1563242400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "meal": {
            "mealId": "9851694",
            "mealTime": 1563166800,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135987",
              "startTime": 1563242400,
              "endTime": 1563244200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786256",
              "jobId": "5083467",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11th Hour Looksee - CR 2K / Plaza Prod Nook #4"
            },
            {
              "jeId": "12136485",
              "startTime": 1563256800,
              "endTime": 1563271200,
              "service": "TD MJ",
              "activityType": "149N",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "2AM-4AM - 3A CTL STANDBY / MJ FIRST LOOK 4AM PREP - 5AM LIVE",
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12137750",
              "startTime": 1563244200,
              "endTime": 1563253200,
              "service": "TD BW",
              "activityType": "149N",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247749",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860793",
          "startTime": 1563328800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137972",
              "startTime": 1563336000,
              "endTime": 1563339600,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786494",
              "jobId": "5083705",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            },
            {
              "jeId": "12137986",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "TD BW",
              "activityType": "149N",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247750",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": "Not available this weekend noted.",
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": "Not available this weekend noted."
        }
      },
      {
        "rdtId": "16247751",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860794",
          "startTime": 1563588000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137053",
              "startTime": 1563590700,
              "endTime": 1563595200,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            },
            {
              "jeId": "12137132",
              "startTime": 1563602400,
              "endTime": 1563616800,
              "service": "TD MJ",
              "activityType": "149N",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "2AM-4AM - 3A CTL STANDBY / MJ FIRST LOOK 4AM PREP - 5AM LIVE",
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137889",
              "startTime": 1563595200,
              "endTime": 1563598800,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786484",
              "jobId": "5083695",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16247752",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860795",
          "startTime": 1563674400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135802",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "TD BW",
              "activityType": "149N",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137214",
              "startTime": 1563688800,
              "endTime": 1563703200,
              "service": "TD MJ",
              "activityType": "149N",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": "2AM-4AM - 3A CTL STANDBY / MJ FIRST LOOK 4AM PREP - 5AM LIVE",
              "comment": null
            },
            {
              "jeId": "12137881",
              "startTime": 1563681600,
              "endTime": 1563685200,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786483",
              "jobId": "5083694",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247753",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860796",
          "startTime": 1563746400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/5 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137535",
              "startTime": 1563746400,
              "endTime": 1563775200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786436",
              "jobId": "5083647",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC ELECTION NIGHT - 2K SUBSWITCH  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21971",
    "class": "Resource",
    "name": "Conde Ryan",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248171",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861163",
          "startTime": 1563177600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852059",
            "mealTime": 1563177600,
            "red": true
          },
          "overtime": {
            "startTime": 1563177600,
            "endTime": 1563206400
          },
          "assignments": [
            {
              "jeId": "12135672",
              "startTime": 1563177600,
              "endTime": 1563206400,
              "service": "Prompter Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786215",
              "jobId": "5083426",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248172",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861164",
          "startTime": 1563270300,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563270300,
            "endTime": 1563299100
          },
          "assignments": [
            {
              "jeId": "12137767",
              "startTime": 1563270300,
              "endTime": 1563299100,
              "service": "Prompter Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786472",
              "jobId": "5083683",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248173",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861165",
          "startTime": 1563356700,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563356700,
            "endTime": 1563385500
          },
          "assignments": [
            {
              "jeId": "12136641",
              "startTime": 1563356700,
              "endTime": 1563385500,
              "service": "Prompter Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786331",
              "jobId": "5083542",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248174",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861166",
          "startTime": 1563615900,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563615900,
            "endTime": 1563644700
          },
          "assignments": [
            {
              "jeId": "12137006",
              "startTime": 1563615900,
              "endTime": 1563644700,
              "service": "Prompter Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786381",
              "jobId": "5083592",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248175",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861167",
          "startTime": 1563702300,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563702300,
            "endTime": 1563731100
          },
          "assignments": [
            {
              "jeId": "12137009",
              "startTime": 1563702300,
              "endTime": 1563731100,
              "service": "Prompter Today 9am",
              "activityType": "1291A5",
              "requestNumber": "3786382",
              "jobId": "5083593",
              "costObject": "MK Today Production",
              "costObjectNumber": "J0A200002",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "21998",
    "class": "Resource",
    "name": "Ortiz David",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248847",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861763",
          "startTime": 1563195600,
          "duration": 8.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852647",
            "mealTime": 1563206400,
            "red": false
          },
          "overtime": {
            "startTime": 1563195600,
            "endTime": 1563225300
          },
          "assignments": [
            {
              "jeId": "12136650",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            },
            {
              "jeId": "12137730",
              "startTime": 1563217200,
              "endTime": 1563225300,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248848",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861764",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136496",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12136522",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137315",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137316",
              "startTime": 1563307200,
              "endTime": 1563310800,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248849",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861765",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "has to leave at 4pm",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136629",
              "startTime": 1563368400,
              "endTime": 1563393600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248850",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861766",
          "startTime": 1563444000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "AM JOY IN ATLANTA",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137034",
              "startTime": 1563468300,
              "endTime": 1563472800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137792",
              "startTime": 1563447600,
              "endTime": 1563454800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            },
            {
              "jeId": "12137797",
              "startTime": 1563454800,
              "endTime": 1563468300,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16248851",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861767",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137453",
              "startTime": 1563544800,
              "endTime": 1563555600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248852",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861768",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135760",
              "startTime": 1563624000,
              "endTime": 1563631200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786224",
              "jobId": "5083435",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135773",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137140",
              "startTime": 1563645600,
              "endTime": 1563652800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137865",
              "startTime": 1563631200,
              "endTime": 1563634800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248853",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861769",
          "startTime": 1563714000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "re-emd",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135828",
              "startTime": 1563728400,
              "endTime": 1563735600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12137225",
              "startTime": 1563714000,
              "endTime": 1563721200,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137241",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            },
            {
              "jeId": "12137942",
              "startTime": 1563739200,
              "endTime": 1563746400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "22026",
    "class": "Resource",
    "name": "Martin Jocilyn",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248410",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861384",
          "startTime": 1563199200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852273",
            "mealTime": 1563199200,
            "red": false
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248411",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861385",
          "startTime": 1563282000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563282000,
            "endTime": 1563314400
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248412",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861386",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": null
        }
      },
      {
        "rdtId": "16248413",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861387",
          "startTime": 1563454800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": null
        }
      },
      {
        "rdtId": "16248414",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861388",
          "startTime": 1563541200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": null
        }
      },
      {
        "rdtId": "16248415",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861389",
          "startTime": 1563624000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "VIZ LEAD",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563624000,
            "endTime": 1563660000
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248416",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861390",
          "startTime": 1563735600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563775200
          },
          "assignments": null
        }
      }
    ]
  },
  {
    "rId": "22051",
    "class": "Resource",
    "name": "Tolud Stephen",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247955",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860974",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CM Conf",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9851870",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12135653",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12137399",
              "startTime": 1563220800,
              "endTime": 1563235200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786418",
              "jobId": "5083629",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137709",
              "startTime": 1563208200,
              "endTime": 1563213600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137719",
              "startTime": 1563213600,
              "endTime": 1563217200,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247956",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860975",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CM Conf",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135552",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "Training MSNBC",
              "activityType": "TR6206",
              "requestNumber": "3786196",
              "jobId": "5083407",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "TRAIN 4P PROMPTER/ I know you know it but just left it in here...please do the show..thanks",
              "comment": null
            },
            {
              "jeId": "12135966",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786249",
              "jobId": "5083460",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137313",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247957",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860976",
          "startTime": 1563372000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CM Conf",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563372000,
            "endTime": 1563408000
          },
          "assignments": [
            {
              "jeId": "12136637",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            },
            {
              "jeId": "12136692",
              "startTime": 1563397200,
              "endTime": 1563400800,
              "service": "Audio A1",
              "activityType": "148E",
              "requestNumber": "3786340",
              "jobId": "5083551",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": "All In Podcast- Recording podcast intro. No guest",
              "comment": null
            },
            {
              "jeId": "12137367",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137476",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16247958",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860977",
          "startTime": 1563454800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135703",
              "startTime": 1563472800,
              "endTime": 1563480000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136339",
              "startTime": 1563480000,
              "endTime": 1563483600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136674",
              "startTime": 1563454800,
              "endTime": 1563465600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137029",
              "startTime": 1563465600,
              "endTime": 1563469200,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            }
          ]
        }
      },
      {
        "rdtId": "16247959",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860978",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "AM JOY A2 prepro then Nick B takes over",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135711",
              "startTime": 1563530400,
              "endTime": 1563535800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12135723",
              "startTime": 1563535800,
              "endTime": 1563541200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136359",
              "startTime": 1563541200,
              "endTime": 1563543000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136366",
              "startTime": 1563543000,
              "endTime": 1563545700,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137456",
              "startTime": 1563545700,
              "endTime": 1563555600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247960",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860979",
          "startTime": 1563627600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "cannot stay later",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135765",
              "startTime": 1563638400,
              "endTime": 1563642000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135792",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136418",
              "startTime": 1563642000,
              "endTime": 1563649200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137146",
              "startTime": 1563649200,
              "endTime": 1563656400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16247961",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860980",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135823",
              "startTime": 1563728400,
              "endTime": 1563735600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12136612",
              "startTime": 1563710400,
              "endTime": 1563714000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": "setup/load prompter",
              "comment": null
            },
            {
              "jeId": "12136615",
              "startTime": 1563714000,
              "endTime": 1563728400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "22260",
    "class": "Resource",
    "name": "Olanrewaju Adeola",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248086",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861087",
          "startTime": 1563163200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 9/24 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9851983",
            "mealTime": 1563163200,
            "red": true
          },
          "assignments": [
            {
              "jeId": "12136254",
              "startTime": 1563166800,
              "endTime": 1563192000,
              "service": "Video & LD ET",
              "activityType": "148C",
              "requestNumber": "3786285",
              "jobId": "5083496",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248087",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861088",
          "startTime": 1563249600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 9/24 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137985",
              "startTime": 1563253200,
              "endTime": 1563278400,
              "service": "Video & LD ET",
              "activityType": "148C",
              "requestNumber": "3786495",
              "jobId": "5083706",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248088",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861089",
          "startTime": 1563336000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 9/24 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135942",
              "startTime": 1563339600,
              "endTime": 1563364800,
              "service": "Video & LD ET",
              "activityType": "148C",
              "requestNumber": "3786244",
              "jobId": "5083455",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248089",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861090",
          "startTime": 1563442200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136329",
              "startTime": 1563442200,
              "endTime": 1563451200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            },
            {
              "jeId": "12137027",
              "startTime": 1563462000,
              "endTime": 1563471000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137788",
              "startTime": 1563451200,
              "endTime": 1563458400,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            }
          ]
        }
      },
      {
        "rdtId": "16248090",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861091",
          "startTime": 1563528600,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563528600,
            "endTime": 1563559200
          },
          "assignments": [
            {
              "jeId": "12135712",
              "startTime": 1563528600,
              "endTime": 1563535800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12135717",
              "startTime": 1563535800,
              "endTime": 1563541200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136352",
              "startTime": 1563541200,
              "endTime": 1563544800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137832",
              "startTime": 1563548400,
              "endTime": 1563555600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            },
            {
              "jeId": "12137841",
              "startTime": 1563555600,
              "endTime": 1563559200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248091",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861092",
          "startTime": 1563595200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137855",
              "startTime": 1563598800,
              "endTime": 1563624000,
              "service": "Video & LD ET",
              "activityType": "148C",
              "requestNumber": "3786480",
              "jobId": "5083691",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248092",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861093",
          "startTime": 1563681600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137194",
              "startTime": 1563685200,
              "endTime": 1563710400,
              "service": "Video & LD ET",
              "activityType": "148C",
              "requestNumber": "3786399",
              "jobId": "5083610",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "22325",
    "class": "Resource",
    "name": "DeSiena Derek",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248300",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861283",
          "startTime": 1563213600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852172",
            "mealTime": 1563235200,
            "red": false
          },
          "overtime": {
            "startTime": 1563213600,
            "endTime": 1563249600
          },
          "assignments": [
            {
              "jeId": "12136054",
              "startTime": 1563238800,
              "endTime": 1563242400,
              "service": "AVAILABLE MSNBC",
              "activityType": "149P",
              "requestNumber": "3786268",
              "jobId": "5083479",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136259",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136965",
              "startTime": 1563228000,
              "endTime": 1563235200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786375",
              "jobId": "5083586",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137745",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12137752",
              "startTime": 1563242400,
              "endTime": 1563249600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248301",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861284",
          "startTime": 1563300000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563300000,
            "endTime": 1563336000
          },
          "assignments": [
            {
              "jeId": "12136055",
              "startTime": 1563325200,
              "endTime": 1563328800,
              "service": "AVAILABLE MSNBC",
              "activityType": "149P",
              "requestNumber": "3786268",
              "jobId": "5083479",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136517",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12136528",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12136538",
              "startTime": 1563314400,
              "endTime": 1563321600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786318",
              "jobId": "5083529",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137989",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248302",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861285",
          "startTime": 1563386400,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563386400,
            "endTime": 1563422400
          },
          "assignments": [
            {
              "jeId": "12136564",
              "startTime": 1563411600,
              "endTime": 1563422400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136581",
              "startTime": 1563400800,
              "endTime": 1563408000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786323",
              "jobId": "5083534",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137472",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248303",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861286",
          "startTime": 1563483600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136319",
              "startTime": 1563498000,
              "endTime": 1563512400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786299",
              "jobId": "5083510",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SATURDAY STANDBY COVERAGE -4E FLASH / 2K CR"
            },
            {
              "jeId": "12137810",
              "startTime": 1563483600,
              "endTime": 1563490800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            },
            {
              "jeId": "12137821",
              "startTime": 1563490800,
              "endTime": 1563494400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248304",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861287",
          "startTime": 1563562800,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135728",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135741",
              "startTime": 1563570000,
              "endTime": 1563573600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136374",
              "startTime": 1563573600,
              "endTime": 1563580800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12137055",
              "startTime": 1563584400,
              "endTime": 1563595200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16248305",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861288",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135804",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "Graphics PB Op L3 - BW - FRO",
              "activityType": "149P",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137100",
              "startTime": 1563670800,
              "endTime": 1563674400,
              "service": "AVAILABLE MSNBC",
              "activityType": "149P",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137104",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "AVAILABLE MSNBC",
              "activityType": "149P",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137168",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "Graphics PB Op L3 - Hardball - FRO",
              "activityType": "149P",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            }
          ]
        }
      },
      {
        "rdtId": "16248306",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861289",
          "startTime": 1563735600,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563789600
          },
          "assignments": [
            {
              "jeId": "12136456",
              "startTime": 1563735600,
              "endTime": 1563742800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137519",
              "startTime": 1563750000,
              "endTime": 1563768000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137520",
              "startTime": 1563768000,
              "endTime": 1563775200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137521",
              "startTime": 1563781500,
              "endTime": 1563789600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137935",
              "startTime": 1563742800,
              "endTime": 1563746400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248889",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861797",
          "startTime": 1563825600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137101",
              "startTime": 1563843600,
              "endTime": 1563847200,
              "service": "AVAILABLE MSNBC",
              "activityType": "149P",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248890",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861798",
          "startTime": 1563912000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137102",
              "startTime": 1563930000,
              "endTime": 1563933600,
              "service": "AVAILABLE MSNBC",
              "activityType": "149P",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "22326",
    "class": "Resource",
    "name": "Hazarian Harry",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "22397",
    "class": "Resource",
    "name": "Alexander Robert",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247782",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860825",
          "startTime": 1563213600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9851726",
            "mealTime": 1563220800,
            "red": false
          },
          "overtime": {
            "startTime": 1563213600,
            "endTime": 1563249600
          },
          "assignments": [
            {
              "jeId": "12135989",
              "startTime": 1563242400,
              "endTime": 1563244200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786256",
              "jobId": "5083467",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11th Hour Looksee - CR 2K / Plaza Prod Nook #4"
            },
            {
              "jeId": "12136271",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "Audio A1 MADDOW",
              "activityType": "149M",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136964",
              "startTime": 1563228000,
              "endTime": 1563235200,
              "service": "Audio A1 Hardball",
              "activityType": "149M",
              "requestNumber": "3786375",
              "jobId": "5083586",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137742",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "Audio A1 5 PM",
              "activityType": "149M",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            }
          ]
        }
      },
      {
        "rdtId": "16247783",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860826",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136514",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "Audio A1 3 PM",
              "activityType": "149M",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12136525",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12136643",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786332",
              "jobId": "5083543",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "CR 2K audio for elex night"
            },
            {
              "jeId": "12137325",
              "startTime": 1563314400,
              "endTime": 1563318000,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247784",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860827",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137470",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16247785",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860828",
          "startTime": 1563462000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136289",
              "startTime": 1563462000,
              "endTime": 1563490800,
              "service": "Audio A1 Commercial Control 72",
              "activityType": "CT5104",
              "requestNumber": "3786292",
              "jobId": "5083503",
              "costObject": "Sports Control",
              "costObjectNumber": "WT-64321",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247786",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860829",
          "startTime": 1563541200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136290",
              "startTime": 1563541200,
              "endTime": 1563562800,
              "service": "Audio A1 Sports Commercial Control 8H",
              "activityType": "TR5104",
              "requestNumber": "3786293",
              "jobId": "5083504",
              "costObject": "Sports Control",
              "costObjectNumber": "WT-64321",
              "description": null,
              "comment": "CR 8H"
            }
          ]
        }
      },
      {
        "rdtId": "16247787",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860830",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137098",
              "startTime": 1563663600,
              "endTime": 1563667200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137149",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "Audio A1 5 PM",
              "activityType": "149M",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137180",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "Audio A1 MADDOW",
              "activityType": "149M",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16247788",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860831",
          "startTime": 1563739200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/1 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137538",
              "startTime": 1563739200,
              "endTime": 1563768000,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786436",
              "jobId": "5083647",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC ELECTION NIGHT - 2K SUBSWITCH  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "22465",
    "class": "Resource",
    "name": "Meli Gregory",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248061",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861063",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/5 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851959",
            "mealTime": 1563217200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135659",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "Video & LD 11 AM",
              "activityType": "148C",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136234",
              "startTime": 1563210000,
              "endTime": 1563212700,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12136950",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "Video & LD 9 AM",
              "activityType": "148C",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137714",
              "startTime": 1563212700,
              "endTime": 1563217200,
              "service": "Video & LD 2 PM",
              "activityType": "148C",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248062",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861064",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/31 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136627",
              "startTime": 1563296400,
              "endTime": 1563303600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786328",
              "jobId": "5083539",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            },
            {
              "jeId": "12137256",
              "startTime": 1563304500,
              "endTime": 1563310800,
              "service": "Video & LD 4 PM",
              "activityType": "148C",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137967",
              "startTime": 1563303600,
              "endTime": 1563304500,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A- Path Update",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248063",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861065",
          "startTime": 1563368400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/31 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135669",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "Camera & A2 6E",
              "activityType": "148C",
              "requestNumber": "3786214",
              "jobId": "5083425",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": "Meal relief",
              "comment": null
            },
            {
              "jeId": "12135910",
              "startTime": 1563382800,
              "endTime": 1563386400,
              "service": "Video & LD 1 PM",
              "activityType": "148C",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136543",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "Video & LD 10 AM",
              "activityType": "148C",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136558",
              "startTime": 1563375600,
              "endTime": 1563382800,
              "service": "Video & LD MITCHELL",
              "activityType": "148C",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            }
          ]
        }
      },
      {
        "rdtId": "16248064",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861066",
          "startTime": 1563472800,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563472800,
            "endTime": 1563503400
          },
          "assignments": [
            {
              "jeId": "12136342",
              "startTime": 1563476400,
              "endTime": 1563487200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137041",
              "startTime": 1563490800,
              "endTime": 1563498000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137433",
              "startTime": 1563498000,
              "endTime": 1563503400,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137809",
              "startTime": 1563487200,
              "endTime": 1563490800,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248065",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861067",
          "startTime": 1563559200,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": "LD FOCUS FOR LIVE 4PM MJ DESK @ 2p",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563559200,
            "endTime": 1563589800
          },
          "assignments": [
            {
              "jeId": "12135729",
              "startTime": 1563565500,
              "endTime": 1563570000,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135730",
              "startTime": 1563559200,
              "endTime": 1563565500,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135740",
              "startTime": 1563570000,
              "endTime": 1563573600,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136373",
              "startTime": 1563573600,
              "endTime": 1563577200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12136383",
              "startTime": 1563577200,
              "endTime": 1563586200,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248066",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861068",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135770",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "Video & LD MITCHELL",
              "activityType": "148C",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136408",
              "startTime": 1563644700,
              "endTime": 1563649200,
              "service": "Video & LD 2 PM",
              "activityType": "148C",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12136429",
              "startTime": 1563642000,
              "endTime": 1563644700,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12137858",
              "startTime": 1563630300,
              "endTime": 1563634800,
              "service": "Video & LD 10 AM",
              "activityType": "148C",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248067",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861069",
          "startTime": 1563714000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/31 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136457",
              "startTime": 1563736500,
              "endTime": 1563742800,
              "service": "Video & LD 4 PM",
              "activityType": "148C",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137218",
              "startTime": 1563714000,
              "endTime": 1563721200,
              "service": "Video & LD 10 AM",
              "activityType": "148C",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137235",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "Video & LD MITCHELL",
              "activityType": "148C",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            },
            {
              "jeId": "12137909",
              "startTime": 1563735600,
              "endTime": 1563736500,
              "service": "Video V1",
              "activityType": "148C",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            },
            {
              "jeId": "12137915",
              "startTime": 1563728400,
              "endTime": 1563732000,
              "service": "Video & LD STANDBY",
              "activityType": "148C",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "22639",
    "class": "Resource",
    "name": "Silverman Scott",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247897",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860925",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9851825",
            "mealTime": 1563213600,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12136307",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786296",
              "jobId": "5083507",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12136999",
              "startTime": 1563199200,
              "endTime": 1563213600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            },
            {
              "jeId": "12137733",
              "startTime": 1563217200,
              "endTime": 1563224400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16247898",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860926",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137253",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137326",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247899",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860927",
          "startTime": 1563354000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563354000,
            "endTime": 1563386400
          },
          "assignments": [
            {
              "jeId": "12135681",
              "startTime": 1563372000,
              "endTime": 1563386400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16247900",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860928",
          "startTime": 1563444000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136328",
              "startTime": 1563444000,
              "endTime": 1563451200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            },
            {
              "jeId": "12137026",
              "startTime": 1563464700,
              "endTime": 1563469200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137035",
              "startTime": 1563469200,
              "endTime": 1563472800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137787",
              "startTime": 1563451200,
              "endTime": 1563458400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            },
            {
              "jeId": "12137805",
              "startTime": 1563458400,
              "endTime": 1563459300,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": "COVERS 1ST BLOCK OF MHP TO ALLOW FOR TRANSITION BETWEEN ASSIGNMENTS",
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16247901",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860929",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "8, 9 am ped",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135710",
              "startTime": 1563530400,
              "endTime": 1563535800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786220",
              "jobId": "5083431",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "2K CONTROL / 3A WEST STUDIO - LIVE 7AM  (6AM PREP)"
            },
            {
              "jeId": "12135725",
              "startTime": 1563535800,
              "endTime": 1563544800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137836",
              "startTime": 1563548400,
              "endTime": 1563559200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16247902",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860930",
          "startTime": 1563606000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12137134",
              "startTime": 1563606000,
              "endTime": 1563631200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16247903",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860931",
          "startTime": 1563699600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137216",
              "startTime": 1563699600,
              "endTime": 1563717600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137228",
              "startTime": 1563717600,
              "endTime": 1563721200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            }
          ]
        }
      },
      {
        "rdtId": "16248885",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861793",
          "startTime": 1563768000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "pedcam studio 3A",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563768000,
            "endTime": 1563796800
          }
        }
      }
    ]
  },
  {
    "rId": "22653",
    "class": "Resource",
    "name": "Hanna Maureen",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248352",
        "title": "Parental Leave  (Baby Bonding)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Parental Leave  (Baby Bonding)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248353",
        "title": "Parental Leave  (Baby Bonding)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Parental Leave  (Baby Bonding)",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248354",
        "title": "Parental Leave  (Baby Bonding)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Parental Leave  (Baby Bonding)",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248355",
        "title": "Parental Leave  (Baby Bonding)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Parental Leave  (Baby Bonding)",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16248356",
        "title": "Parental Leave  (Baby Bonding)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Parental Leave  (Baby Bonding)",
          "startTime": 1563681600,
          "endTime": 1563767940,
          "comment": null
        },
        "tour": null
      }
    ]
  },
  {
    "rId": "22678",
    "class": "Resource",
    "name": "Valentin Pedro",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "22728",
    "class": "Resource",
    "name": "Oliver Brian",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248144",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861136",
          "startTime": 1563199200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852032",
            "mealTime": 1563217200,
            "red": false
          }
        }
      },
      {
        "rdtId": "16248145",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861137",
          "startTime": 1563285600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248146",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861138",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248147",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861139",
          "startTime": 1563451200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "Hold for Elections",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248148",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861140",
          "startTime": 1563525000,
          "duration": 14.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563525000,
            "endTime": 1563577200
          },
          "assignments": [
            {
              "jeId": "12135560",
              "startTime": 1563525000,
              "endTime": 1563541200,
              "service": "Prompter Weekend Today Show",
              "activityType": "148C",
              "requestNumber": "3786198",
              "jobId": "5083409",
              "costObject": "WKD TODAY SHOW O&TS",
              "costObjectNumber": "J0A206210",
              "description": null,
              "comment": "CR 71/Studio 6A"
            }
          ]
        }
      },
      {
        "rdtId": "16248149",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861141",
          "startTime": 1563637500,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "will be in 12:45pm",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248150",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861142",
          "startTime": 1563721200,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": "Hold for Elections",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563721200,
            "endTime": 1563775200
          }
        }
      }
    ]
  },
  {
    "rId": "22848",
    "class": "Resource",
    "name": "Stone Norman",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247920",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860943",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "help with coverage/ CANNOT STAY LATER TODAY",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851839",
            "mealTime": 1563217200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136951",
              "startTime": 1563193800,
              "endTime": 1563199200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137699",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            },
            {
              "jeId": "12137710",
              "startTime": 1563206400,
              "endTime": 1563213600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137722",
              "startTime": 1563213600,
              "endTime": 1563217200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247921",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860944",
          "startTime": 1563297300,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "CANNOT WORK EARLIER/ break nosal democracy plaza",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135876",
              "startTime": 1563299100,
              "endTime": 1563303600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137287",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137336",
              "startTime": 1563303600,
              "endTime": 1563307200,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247922",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860945",
          "startTime": 1563364800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "IS HE NEEDED AT NIGHT?",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563364800,
            "endTime": 1563404400
          },
          "assignments": [
            {
              "jeId": "12135918",
              "startTime": 1563379200,
              "endTime": 1563386400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137360",
              "startTime": 1563364800,
              "endTime": 1563375600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137481",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16247923",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        }
      },
      {
        "rdtId": "16247924",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860946",
          "startTime": 1563555600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563555600,
            "endTime": 1563584400
          },
          "assignments": [
            {
              "jeId": "12135748",
              "startTime": 1563569100,
              "endTime": 1563573600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136390",
              "startTime": 1563573600,
              "endTime": 1563584400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137076",
              "startTime": 1563561000,
              "endTime": 1563566400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16247925",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860947",
          "startTime": 1563645600,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563645600,
            "endTime": 1563678000
          },
          "assignments": [
            {
              "jeId": "12137488",
              "startTime": 1563645600,
              "endTime": 1563652800,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786433",
              "jobId": "5083644",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "3A STUDIO Ped/ Jib"
            },
            {
              "jeId": "12137550",
              "startTime": 1563652800,
              "endTime": 1563663600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786439",
              "jobId": "5083650",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELEX BLOCKING 3A STUDIO / 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16247926",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860948",
          "startTime": 1563732000,
          "duration": 19.5,
          "remainDuration": null,
          "notificationComment": "BREAKER JIB/STEADI/PED 3A STUDIO",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563802200
          },
          "assignments": [
            {
              "jeId": "12136717",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786345",
              "jobId": "5083556",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A WEST (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "22861",
    "class": "Resource",
    "name": "Jackson Jerrel",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248738",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861681",
          "startTime": 1563217200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852565",
            "mealTime": 1563217200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135646",
              "startTime": 1563238800,
              "endTime": 1563246000,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136212",
              "startTime": 1563228000,
              "endTime": 1563231600,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136242",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137748",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248739",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861682",
          "startTime": 1563303600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136532",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12137283",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137299",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12137324",
              "startTime": 1563314400,
              "endTime": 1563318000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248740",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861683",
          "startTime": 1563390000,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563390000,
            "endTime": 1563422400
          },
          "assignments": [
            {
              "jeId": "12136571",
              "startTime": 1563411600,
              "endTime": 1563418800,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136593",
              "startTime": 1563418800,
              "endTime": 1563422400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248741",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861684",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "CHECK WITH TM ABOUT MEAL... 3pm in time confirmed CM",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136007",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248742",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861685",
          "startTime": 1563649200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135783",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12136448",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137097",
              "startTime": 1563652800,
              "endTime": 1563656400,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137874",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248743",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861686",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "PEDCAM ELEX 3A STUDIO",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137531",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "22898",
    "class": "Resource",
    "name": "Knolle Robert",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248763",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861702",
          "startTime": 1563195600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852586",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136209",
              "startTime": 1563217200,
              "endTime": 1563220800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136648",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            }
          ]
        }
      },
      {
        "rdtId": "16248764",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861703",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "con fkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135874",
              "startTime": 1563296400,
              "endTime": 1563303600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12137263",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137311",
              "startTime": 1563292800,
              "endTime": 1563296400,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248765",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861704",
          "startTime": 1563379200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136682",
              "startTime": 1563379200,
              "endTime": 1563386400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786338",
              "jobId": "5083549",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "Deadline WH Looksee- 3A WEST / CR 2K after Kornacki Digital wraps"
            }
          ]
        }
      },
      {
        "rdtId": "16248766",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861705",
          "startTime": 1563465600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "JIB elex rehearsls/ also BREAKER IN AND OUTside democ plazy",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563465600,
            "endTime": 1563501600
          },
          "assignments": [
            {
              "jeId": "12136667",
              "startTime": 1563465600,
              "endTime": 1563501600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248767",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861706",
          "startTime": 1563537600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563537600,
            "endTime": 1563577200
          },
          "assignments": [
            {
              "jeId": "12135733",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135745",
              "startTime": 1563570000,
              "endTime": 1563573600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136379",
              "startTime": 1563573600,
              "endTime": 1563577200,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12137450",
              "startTime": 1563537600,
              "endTime": 1563559200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248768",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861707",
          "startTime": 1563634800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "please don't pull the 12:15-1:15pm outside jib assignment ",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563634800,
            "endTime": 1563678000
          },
          "assignments": [
            {
              "jeId": "12135775",
              "startTime": 1563634800,
              "endTime": 1563639300,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12135788",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12136721",
              "startTime": 1563639300,
              "endTime": 1563645600,
              "service": "Tech Assoc MSNBC",
              "activityType": "148E",
              "requestNumber": "3786346",
              "jobId": "5083557",
              "costObject": "MSNBC Democracy Plaza",
              "costObjectNumber": "NM-T10.DPL",
              "description": "outside jib bump shots record for kara",
              "comment": null
            },
            {
              "jeId": "12137147",
              "startTime": 1563645600,
              "endTime": 1563652800,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137160",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137173",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            }
          ]
        }
      },
      {
        "rdtId": "16248769",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861708",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CM Conf",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135825",
              "startTime": 1563728400,
              "endTime": 1563735600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12135842",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12137229",
              "startTime": 1563717600,
              "endTime": 1563721200,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137929",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248883",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861791",
          "startTime": 1563768000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "STAGE 3A ",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563768000,
            "endTime": 1563796800
          }
        }
      }
    ]
  },
  {
    "rId": "22913",
    "class": "Resource",
    "name": "Kates Jessica",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248383",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861357",
          "startTime": 1563220800,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852246",
            "mealTime": 1563228000,
            "red": false
          },
          "overtime": {
            "startTime": 1563220800,
            "endTime": 1563251400
          },
          "assignments": [
            {
              "jeId": "12135641",
              "startTime": 1563238800,
              "endTime": 1563246000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136243",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12136940",
              "startTime": 1563246000,
              "endTime": 1563251400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786373",
              "jobId": "5083584",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            },
            {
              "jeId": "12137744",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248384",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861358",
          "startTime": 1563307200,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563307200,
            "endTime": 1563337800
          },
          "assignments": [
            {
              "jeId": "12136527",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12137284",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137292",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12137973",
              "startTime": 1563332400,
              "endTime": 1563337800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786494",
              "jobId": "5083705",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248385",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861359",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137473",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248386",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861360",
          "startTime": 1563454800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "elex rehearsal",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248387",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861361",
          "startTime": 1563570000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELEX",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248388",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861362",
          "startTime": 1563652800,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563652800,
            "endTime": 1563683400
          },
          "assignments": [
            {
              "jeId": "12135778",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12137151",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137875",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            },
            {
              "jeId": "12137883",
              "startTime": 1563678000,
              "endTime": 1563683400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786483",
              "jobId": "5083694",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248389",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861363",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          }
        }
      }
    ]
  },
  {
    "rId": "22968",
    "class": "Resource",
    "name": "Black Kirsten",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247688",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16247689",
        "title": "DH NPT",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "DH NPT",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16247690",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860740",
          "startTime": 1563476400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9851643",
            "mealTime": 1563483600,
            "red": false
          },
          "overtime": {
            "startTime": 1563476400,
            "endTime": 1563508800
          },
          "assignments": [
            {
              "jeId": "12136318",
              "startTime": 1563501600,
              "endTime": 1563508800,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786299",
              "jobId": "5083510",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SATURDAY STANDBY COVERAGE -4E FLASH / 2K CR"
            },
            {
              "jeId": "12136333",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137431",
              "startTime": 1563494400,
              "endTime": 1563501600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137807",
              "startTime": 1563486300,
              "endTime": 1563490800,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            },
            {
              "jeId": "12137818",
              "startTime": 1563490800,
              "endTime": 1563494400,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247691",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860741",
          "startTime": 1563570000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136371",
              "startTime": 1563572700,
              "endTime": 1563577200,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12136381",
              "startTime": 1563577200,
              "endTime": 1563584400,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137051",
              "startTime": 1563588000,
              "endTime": 1563591600,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            },
            {
              "jeId": "12137052",
              "startTime": 1563594300,
              "endTime": 1563598800,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16247692",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        }
      }
    ]
  },
  {
    "rId": "22969",
    "class": "Resource",
    "name": "Worsley Justin",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "23021",
    "class": "Resource",
    "name": "Geller Michelle",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "23092",
    "class": "Resource",
    "name": "Barton Robert",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247679",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860733",
          "startTime": 1563213600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851636",
            "mealTime": 1563213600,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136268",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "TD MADDOW",
              "activityType": "149N",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136959",
              "startTime": 1563228000,
              "endTime": 1563235200,
              "service": "TD HARDBALL",
              "activityType": "149N",
              "requestNumber": "3786375",
              "jobId": "5083586",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            }
          ]
        }
      },
      {
        "rdtId": "16247680",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860734",
          "startTime": 1563310800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563310800,
            "endTime": 1563343200
          },
          "assignments": [
            {
              "jeId": "12137438",
              "startTime": 1563321600,
              "endTime": 1563343200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786425",
              "jobId": "5083636",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            },
            {
              "jeId": "12137964",
              "startTime": 1563314400,
              "endTime": 1563321600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "PROJECT WORK",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247681",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860735",
          "startTime": 1563393600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563393600,
            "endTime": 1563429600
          },
          "assignments": [
            {
              "jeId": "12136693",
              "startTime": 1563408000,
              "endTime": 1563429600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786341",
              "jobId": "5083552",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            },
            {
              "jeId": "12137485",
              "startTime": 1563393600,
              "endTime": 1563404400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786431",
              "jobId": "5083642",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247682",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860736",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136656",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247683",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860737",
          "startTime": 1563562800,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135999",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247684",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860738",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137556",
              "startTime": 1563652800,
              "endTime": 1563663600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786439",
              "jobId": "5083650",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELEX BLOCKING 3A STUDIO / 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16247685",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860739",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/1 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137495",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "23093",
    "class": "Resource",
    "name": "Criscione Kelly",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247695",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860744",
          "startTime": 1563206400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851647",
            "mealTime": 1563213600,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135686",
              "startTime": 1563206400,
              "endTime": 1563224400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786217",
              "jobId": "5083428",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT NETWORK - LAUNCH/PRE-PRO - CONTROL 74"
            },
            {
              "jeId": "12136309",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786296",
              "jobId": "5083507",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            }
          ]
        }
      },
      {
        "rdtId": "16247696",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860745",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137016",
              "startTime": 1563292800,
              "endTime": 1563310800,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786386",
              "jobId": "5083597",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT NETWORK - LAUNCH/PRE-PRO - CONTROL 74"
            },
            {
              "jeId": "12137244",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            }
          ]
        }
      },
      {
        "rdtId": "16247697",
        "title": "1/2 Personal Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860746",
          "startTime": 1563372000,
          "duration": 3.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136313",
              "startTime": 1563372000,
              "endTime": 1563384600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786298",
              "jobId": "5083509",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT NETWORK - LAUNCH/PRE-PRO - CONTROL 74"
            }
          ]
        }
      },
      {
        "rdtId": "16247698",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": "KC Approved",
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": "KC Approved"
        }
      },
      {
        "rdtId": "16247699",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": "KC approved",
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": "KC approved"
        }
      },
      {
        "rdtId": "16247700",
        "title": "Personal Business",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Personal Business",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        }
      },
      {
        "rdtId": "16247701",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860747",
          "startTime": 1563739200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "2K SUBSWITCH",
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137534",
              "startTime": 1563739200,
              "endTime": 1563768000,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786436",
              "jobId": "5083647",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC ELECTION NIGHT - 2K SUBSWITCH  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "23094",
    "class": "Resource",
    "name": "Massa Kourtney",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247841",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860876",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851777",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136989",
              "startTime": 1563204600,
              "endTime": 1563211800,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16247842",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860877",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135906",
              "startTime": 1563278400,
              "endTime": 1563282000,
              "service": "Audio A1",
              "activityType": "6214",
              "requestNumber": "3786239",
              "jobId": "5083450",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 3A MJ relief/Standby",
              "comment": null
            },
            {
              "jeId": "12137310",
              "startTime": 1563300000,
              "endTime": 1563303600,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6214",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137947",
              "startTime": 1563295500,
              "endTime": 1563300000,
              "service": "TD 1 PM",
              "activityType": "6214",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247843",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860878",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "standby",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135673",
              "startTime": 1563372000,
              "endTime": 1563390000,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12136686",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786339",
              "jobId": "5083550",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Hardball Looksee - 3A west / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16247844",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860879",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137089",
              "startTime": 1563627600,
              "endTime": 1563631200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6214",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137144",
              "startTime": 1563645600,
              "endTime": 1563652800,
              "service": "TD 3 PM",
              "activityType": "6214",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137768",
              "startTime": 1563631200,
              "endTime": 1563645600,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16247845",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860880",
          "startTime": 1563724800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135845",
              "startTime": 1563732000,
              "endTime": 1563739200,
              "service": "Audio A1 3 PM",
              "activityType": "6214",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137895",
              "startTime": 1563724800,
              "endTime": 1563732000,
              "service": "TD 1 PM",
              "activityType": "6214",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137931",
              "startTime": 1563739200,
              "endTime": 1563750000,
              "service": "Audio A1 5 PM",
              "activityType": "6214",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "23303",
    "class": "Resource",
    "name": "Groh Emily",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247716",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860761",
          "startTime": 1563195600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9851664",
            "mealTime": 1563210000,
            "red": false
          },
          "overtime": {
            "startTime": 1563195600,
            "endTime": 1563231600
          },
          "assignments": [
            {
              "jeId": "12135663",
              "startTime": 1563220800,
              "endTime": 1563224400,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786211",
              "jobId": "5083422",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "2E STANDBY"
            },
            {
              "jeId": "12136932",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "TD 6 PM",
              "activityType": "149N",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            }
          ]
        }
      },
      {
        "rdtId": "16247717",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860762",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135962",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786249",
              "jobId": "5083460",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": "Dan also assigned for colab work if needed",
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12136625",
              "startTime": 1563292800,
              "endTime": 1563310800,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786328",
              "jobId": "5083539",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16247718",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860763",
          "startTime": 1563386400,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136695",
              "startTime": 1563408000,
              "endTime": 1563429600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786341",
              "jobId": "5083552",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            }
          ]
        }
      },
      {
        "rdtId": "16247719",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860764",
          "startTime": 1563490800,
          "duration": 5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 7H",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16247720",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860765",
          "startTime": 1563562800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563562800,
            "endTime": 1563602400
          },
          "assignments": [
            {
              "jeId": "12137463",
              "startTime": 1563562800,
              "endTime": 1563598800,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786428",
              "jobId": "5083639",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247721",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860766",
          "startTime": 1563645600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136702",
              "startTime": 1563645600,
              "endTime": 1563656400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786343",
              "jobId": "5083554",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "Cancelled - Hardball Pretape - 3A West / CR 2K"
            },
            {
              "jeId": "12137166",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "TD HARDBALL",
              "activityType": "149N",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137181",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "TD MADDOW",
              "activityType": "149N",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16247722",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860767",
          "startTime": 1563735600,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/12 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563768000
          },
          "assignments": [
            {
              "jeId": "12137540",
              "startTime": 1563736500,
              "endTime": 1563768000,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786437",
              "jobId": "5083648",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137910",
              "startTime": 1563735600,
              "endTime": 1563736500,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786487",
              "jobId": "5083698",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A  - Path Update",
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "23677",
    "class": "Resource",
    "name": "Haberli Christopher",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "23688",
    "class": "Resource",
    "name": "Sinavsky Amy",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247906",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860933",
          "startTime": 1563212700,
          "duration": 9.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONFKP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9851833",
            "mealTime": 1563220800,
            "red": false
          },
          "overtime": {
            "startTime": 1563212700,
            "endTime": 1563246000
          },
          "assignments": [
            {
              "jeId": "12135647",
              "startTime": 1563240600,
              "endTime": 1563246000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136241",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12136265",
              "startTime": 1563217200,
              "endTime": 1563220800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136277",
              "startTime": 1563238800,
              "endTime": 1563240600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136938",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137723",
              "startTime": 1563212700,
              "endTime": 1563217200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16247907",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860934",
          "startTime": 1563303600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137251",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137295",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12137319",
              "startTime": 1563321600,
              "endTime": 1563325200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137320",
              "startTime": 1563307200,
              "endTime": 1563310800,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247908",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860935",
          "startTime": 1563469200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563469200,
            "endTime": 1563501600
          },
          "assignments": [
            {
              "jeId": "12135702",
              "startTime": 1563472800,
              "endTime": 1563480000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136348",
              "startTime": 1563480000,
              "endTime": 1563487200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137047",
              "startTime": 1563490800,
              "endTime": 1563498000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137436",
              "startTime": 1563498000,
              "endTime": 1563501600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137487",
              "startTime": 1563469200,
              "endTime": 1563472800,
              "service": "MEETING MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786432",
              "jobId": "5083643",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": "meeting with Vic in 3A audio",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247909",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860936",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135744",
              "startTime": 1563566400,
              "endTime": 1563573600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136378",
              "startTime": 1563573600,
              "endTime": 1563577200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12136389",
              "startTime": 1563577200,
              "endTime": 1563584400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137050",
              "startTime": 1563584400,
              "endTime": 1563591600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16247910",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860937",
          "startTime": 1563742800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "texted again   A2/4E FLASHCAM",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563742800,
            "endTime": 1563775200
          }
        }
      }
    ]
  },
  {
    "rId": "23734",
    "class": "Resource",
    "name": "Fink Sean",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248683",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861640",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852524",
            "mealTime": 1563202800,
            "red": false
          },
          "overtime": {
            "startTime": 1563192000,
            "endTime": 1563220800
          },
          "assignments": [
            {
              "jeId": "12135666",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "Camera & A2 6E",
              "activityType": "1291A5",
              "requestNumber": "3786213",
              "jobId": "5083424",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": "6E relief",
              "comment": null
            },
            {
              "jeId": "12137697",
              "startTime": 1563198300,
              "endTime": 1563202800,
              "service": "A2",
              "activityType": "1291A5",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            },
            {
              "jeId": "12137711",
              "startTime": 1563206400,
              "endTime": 1563213600,
              "service": "UT",
              "activityType": "1291A5",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248684",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861641",
          "startTime": 1563291000,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": "re-emd",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563291000,
            "endTime": 1563321600
          },
          "assignments": [
            {
              "jeId": "12135858",
              "startTime": 1563291900,
              "endTime": 1563296400,
              "service": "A2",
              "activityType": "1291A5",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12136283",
              "startTime": 1563296400,
              "endTime": 1563321600,
              "service": "6E super user",
              "activityType": "1291A5",
              "requestNumber": "3786290",
              "jobId": "5083501",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248685",
        "title": "Requested OFF",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Requested OFF",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248686",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861642",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563631200,
            "endTime": 1563660000
          },
          "assignments": [
            {
              "jeId": "12135799",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "PR",
              "activityType": "1291A5",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136417",
              "startTime": 1563642000,
              "endTime": 1563649200,
              "service": "UT",
              "activityType": "1291A5",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137096",
              "startTime": 1563649200,
              "endTime": 1563652800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA5104",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137156",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "PR 2K MS",
              "activityType": "1291A5",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248687",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861643",
          "startTime": 1563710400,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "  CAN STAY LATE",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563710400,
            "endTime": 1563746400
          },
          "assignments": [
            {
              "jeId": "12135829",
              "startTime": 1563728400,
              "endTime": 1563735600,
              "service": "UT",
              "activityType": "1291A5",
              "requestNumber": "3786230",
              "jobId": "5083441",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / REMOTE (Georgia) / 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12135837",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "UT",
              "activityType": "1291A5",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12135854",
              "startTime": 1563735600,
              "endTime": 1563739200,
              "service": "UT",
              "activityType": "1291A5",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137928",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "PR 3A MS",
              "activityType": "1291A5",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            },
            {
              "jeId": "12137939",
              "startTime": 1563739200,
              "endTime": 1563746400,
              "service": "PR 2K MS",
              "activityType": "1291A5",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "23740",
    "class": "Resource",
    "name": "Ortiz Samuel",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248856",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861772",
          "startTime": 1563199200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852656",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563231600
          },
          "assignments": [
            {
              "jeId": "12135655",
              "startTime": 1563199200,
              "endTime": 1563210000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136651",
              "startTime": 1563210000,
              "endTime": 1563217200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            },
            {
              "jeId": "12136937",
              "startTime": 1563220800,
              "endTime": 1563231600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            }
          ]
        }
      },
      {
        "rdtId": "16248857",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861773",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "MANNY TRAINS WITH YOU ON THE 9AM STEADI..THANKS",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135890",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136505",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136622",
              "startTime": 1563292800,
              "endTime": 1563303600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786328",
              "jobId": "5083539",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248858",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861774",
          "startTime": 1563386400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563386400,
            "endTime": 1563418800
          },
          "assignments": [
            {
              "jeId": "12136567",
              "startTime": 1563411600,
              "endTime": 1563418800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248859",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        }
      },
      {
        "rdtId": "16248860",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        }
      },
      {
        "rdtId": "16248861",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861775",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563631200,
            "endTime": 1563660000
          },
          "assignments": [
            {
              "jeId": "12135794",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "UT 3A  MS",
              "activityType": "148E",
              "requestNumber": "3786227",
              "jobId": "5083438",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136402",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137135",
              "startTime": 1563648300,
              "endTime": 1563652800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137159",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248862",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861776",
          "startTime": 1563715800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confk p",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136463",
              "startTime": 1563735600,
              "endTime": 1563742800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137226",
              "startTime": 1563715800,
              "endTime": 1563721200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137239",
              "startTime": 1563721200,
              "endTime": 1563732000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "24080",
    "class": "Resource",
    "name": "Vilanova Paul",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248511",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861481",
          "startTime": 1563195600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852370",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248512",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861482",
          "startTime": 1563314400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248513",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861483",
          "startTime": 1563372000,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248514",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861484",
          "startTime": 1563454800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563494400
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248515",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861485",
          "startTime": 1563541200,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563541200,
            "endTime": 1563598800
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248516",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861486",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248517",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861487",
          "startTime": 1563735600,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563778800
          },
          "assignments": null
        }
      }
    ]
  },
  {
    "rId": "24081",
    "class": "Resource",
    "name": "Rossi Jordan",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248874",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248875",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        }
      },
      {
        "rdtId": "16248876",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248877",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861785",
          "startTime": 1563465600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "PLEASE SEE CHRISTY IN 3A TO SEE IF SOMEONE NEEDS A BREAK..MAYBE PROMPTER/  cannot work later",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852669",
            "mealTime": 1563476400,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135694",
              "startTime": 1563471900,
              "endTime": 1563476400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786218",
              "jobId": "5083429",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137036",
              "startTime": 1563465600,
              "endTime": 1563472800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137812",
              "startTime": 1563480000,
              "endTime": 1563490800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            },
            {
              "jeId": "12137825",
              "startTime": 1563490800,
              "endTime": 1563494400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248878",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861786",
          "startTime": 1563541200,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "help out A2 4p",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563541200,
            "endTime": 1563584400
          },
          "assignments": [
            {
              "jeId": "12135735",
              "startTime": 1563559200,
              "endTime": 1563568200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": "help out 4pm A2",
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135749",
              "startTime": 1563568200,
              "endTime": 1563573600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136391",
              "startTime": 1563573600,
              "endTime": 1563584400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137457",
              "startTime": 1563541200,
              "endTime": 1563555600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248879",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861787",
          "startTime": 1563638400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf AP 11/2",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563638400,
            "endTime": 1563670800
          },
          "assignments": [
            {
              "jeId": "12135776",
              "startTime": 1563638400,
              "endTime": 1563642000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136435",
              "startTime": 1563649200,
              "endTime": 1563656400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136453",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136705",
              "startTime": 1563642000,
              "endTime": 1563649200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786343",
              "jobId": "5083554",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "Cancelled - Hardball Pretape - 3A West / CR 2K"
            },
            {
              "jeId": "12137876",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248880",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861788",
          "startTime": 1563761700,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "UTILITY 3A",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12136711",
              "startTime": 1563761700,
              "endTime": 1563775200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786344",
              "jobId": "5083555",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "24110",
    "class": "Resource",
    "name": "Massimino Erik",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248419",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861393",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852282",
            "mealTime": 1563206400,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12136994",
              "startTime": 1563199200,
              "endTime": 1563213600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248420",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861394",
          "startTime": 1563292800,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563292800,
            "endTime": 1563343200
          }
        }
      },
      {
        "rdtId": "16248421",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861395",
          "startTime": 1563372000,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563372000,
            "endTime": 1563429600
          },
          "assignments": [
            {
              "jeId": "12135677",
              "startTime": 1563372000,
              "endTime": 1563386400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248422",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861396",
          "startTime": 1563462000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "elex rehearsal",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248423",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861397",
          "startTime": 1563548400,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": "ELEX",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248424",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861398",
          "startTime": 1563631200,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563631200,
            "endTime": 1563681600
          },
          "assignments": [
            {
              "jeId": "12137772",
              "startTime": 1563631200,
              "endTime": 1563642000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248425",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861399",
          "startTime": 1563735600,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563778800
          }
        }
      }
    ]
  },
  {
    "rId": "24378",
    "class": "Resource",
    "name": "Ryan Daniel",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248102",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861096",
          "startTime": 1563206400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9851992",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136255",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "TD 3 PM",
              "activityType": "6214",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12137395",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786418",
              "jobId": "5083629",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137701",
              "startTime": 1563206400,
              "endTime": 1563213600,
              "service": "TD 1 PM",
              "activityType": "6214",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248103",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861097",
          "startTime": 1563307200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/31 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135961",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786249",
              "jobId": "5083460",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": "Emily also assigned for colab work if needed",
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137439",
              "startTime": 1563321600,
              "endTime": 1563343200,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786425",
              "jobId": "5083636",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            }
          ]
        }
      },
      {
        "rdtId": "16248104",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861098",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136008",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786258",
              "jobId": "5083469",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2E / 3A SDO"
            },
            {
              "jeId": "12136633",
              "startTime": 1563372000,
              "endTime": 1563390000,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248105",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861099",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563487200
          }
        }
      },
      {
        "rdtId": "16248106",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861100",
          "startTime": 1563541200,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563541200,
            "endTime": 1563573600
          },
          "assignments": [
            {
              "jeId": "12135727",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135738",
              "startTime": 1563570000,
              "endTime": 1563573600,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137059",
              "startTime": 1563558300,
              "endTime": 1563562800,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137448",
              "startTime": 1563541200,
              "endTime": 1563555600,
              "service": "Video V1",
              "activityType": "6214",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248107",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861101",
          "startTime": 1563739200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "2E WALL CONTROL - ELECTIONS",
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563739200,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137536",
              "startTime": 1563739200,
              "endTime": 1563775200,
              "service": "TD",
              "activityType": "6214",
              "requestNumber": "3786436",
              "jobId": "5083647",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC ELECTION NIGHT - 2K SUBSWITCH  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "24563",
    "class": "Resource",
    "name": "Finnegan Jack",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248334",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861317",
          "startTime": 1563172200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9852206",
            "mealTime": 1563197400,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136920",
              "startTime": 1563172200,
              "endTime": 1563197400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            }
          ]
        }
      },
      {
        "rdtId": "16248335",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861318",
          "startTime": 1563258600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136484",
              "startTime": 1563258600,
              "endTime": 1563283800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248336",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861319",
          "startTime": 1563345000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null
        }
      },
      {
        "rdtId": "16248337",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861320",
          "startTime": 1563429600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137563",
              "startTime": 1563429600,
              "endTime": 1563458400,
              "service": "Graphics PB Op L3 WE Today",
              "activityType": "149P",
              "requestNumber": "3786444",
              "jobId": "5083655",
              "costObject": "WKD TODAY SHOW O&TS",
              "costObjectNumber": "J0A206210",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248338",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861321",
          "startTime": 1563516000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135558",
              "startTime": 1563516000,
              "endTime": 1563544800,
              "service": "Graphics PB Op L3 WE Today",
              "activityType": "149P",
              "requestNumber": "3786198",
              "jobId": "5083409",
              "costObject": "WKD TODAY SHOW O&TS",
              "costObjectNumber": "J0A206210",
              "description": null,
              "comment": "CR 71/Studio 6A"
            }
          ]
        }
      },
      {
        "rdtId": "16248339",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861322",
          "startTime": 1563604200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137133",
              "startTime": 1563604200,
              "endTime": 1563629400,
              "service": "Graphics PB Op L3 - MJ - FRO",
              "activityType": "149P",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248340",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861323",
          "startTime": 1563690600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137215",
              "startTime": 1563690600,
              "endTime": 1563715800,
              "service": "Graphics PB Op L3 - MJ - FRO",
              "activityType": "149P",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "24600",
    "class": "Resource",
    "name": "Jacobs Jessica",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "24601",
    "class": "Resource",
    "name": "Cappa Joseph",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248291",
        "title": "DH PTO NABET",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "DH PTO NABET",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248292",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861275",
          "startTime": 1563310800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9852164",
            "mealTime": 1563321600,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136059",
              "startTime": 1563325200,
              "endTime": 1563328800,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6213",
              "requestNumber": "3786268",
              "jobId": "5083479",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136539",
              "startTime": 1563314400,
              "endTime": 1563321600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786318",
              "jobId": "5083529",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137330",
              "startTime": 1563310800,
              "endTime": 1563314400,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6213",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137976",
              "startTime": 1563336000,
              "endTime": 1563339600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786494",
              "jobId": "5083705",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137990",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248293",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861276",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135952",
              "startTime": 1563393600,
              "endTime": 1563397200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786246",
              "jobId": "5083457",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "2E STANDBY"
            },
            {
              "jeId": "12136060",
              "startTime": 1563408000,
              "endTime": 1563411600,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6213",
              "requestNumber": "3786268",
              "jobId": "5083479",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136563",
              "startTime": 1563411600,
              "endTime": 1563418800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136582",
              "startTime": 1563400800,
              "endTime": 1563408000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786323",
              "jobId": "5083534",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            }
          ]
        }
      },
      {
        "rdtId": "16248294",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861277",
          "startTime": 1563454800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": "elex rehearsal",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ]
        }
      },
      {
        "rdtId": "16248295",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861278",
          "startTime": 1563562800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "ELEX",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563562800,
            "endTime": 1563595200
          }
        }
      },
      {
        "rdtId": "16248296",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861279",
          "startTime": 1563652800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563652800,
            "endTime": 1563685200
          },
          "assignments": [
            {
              "jeId": "12135805",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137105",
              "startTime": 1563670800,
              "endTime": 1563674400,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6213",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137152",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137167",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137886",
              "startTime": 1563681600,
              "endTime": 1563685200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786483",
              "jobId": "5083694",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248297",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861280",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "wall",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          }
        }
      },
      {
        "rdtId": "16248892",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861800",
          "startTime": 1563814800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "wall",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563814800,
            "endTime": 1563858000
          },
          "assignments": [
            {
              "jeId": "12137106",
              "startTime": 1563843600,
              "endTime": 1563847200,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6213",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "24602",
    "class": "Resource",
    "name": "Campesi Bryan",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248162",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861154",
          "startTime": 1563195600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852050",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136222",
              "startTime": 1563202800,
              "endTime": 1563210000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136258",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12137693",
              "startTime": 1563195600,
              "endTime": 1563202800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            },
            {
              "jeId": "12137704",
              "startTime": 1563210000,
              "endTime": 1563213600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248163",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861155",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135864",
              "startTime": 1563289200,
              "endTime": 1563296400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12136493",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12136516",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137949",
              "startTime": 1563296400,
              "endTime": 1563300000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248164",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861156",
          "startTime": 1563368400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135911",
              "startTime": 1563382800,
              "endTime": 1563386400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136544",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136559",
              "startTime": 1563375600,
              "endTime": 1563382800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            }
          ]
        }
      },
      {
        "rdtId": "16248165",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861157",
          "startTime": 1563454800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135690",
              "startTime": 1563469200,
              "endTime": 1563476400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786218",
              "jobId": "5083429",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12135699",
              "startTime": 1563476400,
              "endTime": 1563483600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12137806",
              "startTime": 1563454800,
              "endTime": 1563465600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            }
          ]
        }
      },
      {
        "rdtId": "16248166",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861158",
          "startTime": 1563541200,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563541200,
            "endTime": 1563584400
          },
          "assignments": [
            {
              "jeId": "12136367",
              "startTime": 1563541200,
              "endTime": 1563552000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12136384",
              "startTime": 1563570000,
              "endTime": 1563584400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137060",
              "startTime": 1563555600,
              "endTime": 1563562800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137068",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248167",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861159",
          "startTime": 1563627600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135771",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "Graphics PB Op L3 - MITCHELL - FRO",
              "activityType": "149P",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136397",
              "startTime": 1563642000,
              "endTime": 1563645600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137137",
              "startTime": 1563645600,
              "endTime": 1563652800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137859",
              "startTime": 1563627600,
              "endTime": 1563634800,
              "service": "Graphics PB Op L3 - 10 AM - FRO",
              "activityType": "149P",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248168",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861160",
          "startTime": 1563714000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135847",
              "startTime": 1563734700,
              "endTime": 1563739200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137220",
              "startTime": 1563716700,
              "endTime": 1563721200,
              "service": "Graphics PB Op L3 - 10 AM - FRO",
              "activityType": "149P",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137237",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "Graphics PB Op L3 - MITCHELL - FRO",
              "activityType": "149P",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            },
            {
              "jeId": "12137897",
              "startTime": 1563728400,
              "endTime": 1563732000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "24712",
    "class": "Resource",
    "name": "Sofio Jose",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248494",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861465",
          "startTime": 1563220800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852354",
            "mealTime": 1563220800,
            "red": true
          },
          "overtime": {
            "startTime": 1563220800,
            "endTime": 1563253200
          },
          "assignments": [
            {
              "jeId": "12135642",
              "startTime": 1563238800,
              "endTime": 1563249600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136244",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12136933",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12136942",
              "startTime": 1563249600,
              "endTime": 1563253200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786373",
              "jobId": "5083584",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248495",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861466",
          "startTime": 1563307200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137272",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137285",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137291",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12137977",
              "startTime": 1563332400,
              "endTime": 1563336000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786494",
              "jobId": "5083705",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248496",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861467",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136061",
              "startTime": 1563411600,
              "endTime": 1563415200,
              "service": "AVAILABLE MSNBC",
              "activityType": "149P",
              "requestNumber": "3786268",
              "jobId": "5083479",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136586",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248497",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861468",
          "startTime": 1563462000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136676",
              "startTime": 1563462000,
              "endTime": 1563498000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248498",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861469",
          "startTime": 1563562800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "ELEX",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563562800,
            "endTime": 1563595200
          },
          "assignments": [
            {
              "jeId": "12136003",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248499",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861470",
          "startTime": 1563645600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563645600,
            "endTime": 1563681600
          },
          "assignments": [
            {
              "jeId": "12135779",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12136449",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137139",
              "startTime": 1563648300,
              "endTime": 1563652800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137877",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            },
            {
              "jeId": "12137887",
              "startTime": 1563678000,
              "endTime": 1563681600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786483",
              "jobId": "5083694",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248500",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861471",
          "startTime": 1563732000,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563789600
          },
          "assignments": [
            {
              "jeId": "12135848",
              "startTime": 1563732000,
              "endTime": 1563739200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137523",
              "startTime": 1563750000,
              "endTime": 1563768000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137524",
              "startTime": 1563768000,
              "endTime": 1563778800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137525",
              "startTime": 1563778800,
              "endTime": 1563789600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137936",
              "startTime": 1563739200,
              "endTime": 1563746400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "24723",
    "class": "Resource",
    "name": "DiBari Peter",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248309",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861292",
          "startTime": 1563195600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852181",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248310",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861293",
          "startTime": 1563307200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563307200,
            "endTime": 1563343200
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248311",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861294",
          "startTime": 1563372000,
          "duration": 16,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563372000,
            "endTime": 1563429600
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248312",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861295",
          "startTime": 1563454800,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563494400
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248313",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861296",
          "startTime": 1563541200,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": "side panel",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563541200,
            "endTime": 1563595200
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248314",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861297",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248315",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861298",
          "startTime": 1563735600,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563789600
          },
          "assignments": null
        }
      }
    ]
  },
  {
    "rId": "24735",
    "class": "Resource",
    "name": "Latonero Jeffrey",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248286",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861270",
          "startTime": 1563559200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "booked MSNBC Steadi do not approve",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248287",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861271",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf CM",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135812",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "ST",
              "activityType": "145P",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12137171",
              "startTime": 1563660000,
              "endTime": 1563667200,
              "service": "ST",
              "activityType": "145P",
              "requestNumber": "3786397",
              "jobId": "5083608",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2E / 3A SDO - HB Live"
            },
            {
              "jeId": "12137185",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "ST",
              "activityType": "145P",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248288",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861272",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "booked as MSNBC steadi do NOT approve ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "meal": {
            "mealId": "9852161",
            "mealTime": 1563739200,
            "red": false
          },
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          }
        }
      }
    ]
  },
  {
    "rId": "24835",
    "class": "Resource",
    "name": "Lefcort David",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247833",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860869",
          "startTime": 1563202800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "booked 8/8 JP",
          "tourComment": "Late Night",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9851770",
            "mealTime": 1563213600,
            "red": false
          },
          "overtime": {
            "startTime": 1563202800,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12136739",
              "startTime": 1563202800,
              "endTime": 1563235200,
              "service": "Audio FOH Late Night",
              "activityType": "1291A5",
              "requestNumber": "3786356",
              "jobId": "5083567",
              "costObject": "Late Night w Seth Meyers S6 Week 4",
              "costObjectNumber": "WT-00600.4",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247834",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860870",
          "startTime": 1563307200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "BKD 10/30 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135899",
              "startTime": 1563321600,
              "endTime": 1563328800,
              "service": "Audio A1 MADDOW",
              "activityType": "149M",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136540",
              "startTime": 1563314400,
              "endTime": 1563321600,
              "service": "Audio A1 Hardball",
              "activityType": "149M",
              "requestNumber": "3786318",
              "jobId": "5083529",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            },
            {
              "jeId": "12137321",
              "startTime": 1563310800,
              "endTime": 1563314400,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6211",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137987",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "Audio A1 BW",
              "activityType": "149M",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247835",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        }
      },
      {
        "rdtId": "16247836",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860871",
          "startTime": 1563559200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136291",
              "startTime": 1563559200,
              "endTime": 1563562800,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786293",
              "jobId": "5083504",
              "costObject": "Network Training",
              "costObjectNumber": "WT-10051",
              "description": "Training: 8H CR w/ Rob Alexander build for OTT",
              "comment": "CR 8H"
            }
          ]
        }
      },
      {
        "rdtId": "16247837",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860872",
          "startTime": 1563624000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563624000,
            "endTime": 1563660000
          },
          "assignments": [
            {
              "jeId": "12137414",
              "startTime": 1563638400,
              "endTime": 1563652800,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137547",
              "startTime": 1563624000,
              "endTime": 1563638400,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786438",
              "jobId": "5083649",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal CR 8H / 3E Flash"
            }
          ]
        }
      },
      {
        "rdtId": "16247838",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10860873",
          "startTime": 1563735600,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563768000
          },
          "assignments": [
            {
              "jeId": "12136606",
              "startTime": 1563739200,
              "endTime": 1563757200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25053",
    "class": "Resource",
    "name": "Anderson Erik",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248537",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861504",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852393",
            "mealTime": 1563213600,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12136306",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786296",
              "jobId": "5083507",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137000",
              "startTime": 1563199200,
              "endTime": 1563213600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            },
            {
              "jeId": "12137732",
              "startTime": 1563217200,
              "endTime": 1563224400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248538",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861505",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137252",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137956",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248539",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861506",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "COVER KAREEM HOURS MAY NEED TO BE ADJUSTED",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135683",
              "startTime": 1563372000,
              "endTime": 1563386400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12137480",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248540",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861507",
          "startTime": 1563444000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "plese give simon a jib break if you can at 11 please",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136672",
              "startTime": 1563458400,
              "endTime": 1563472800,
              "service": "JB",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137785",
              "startTime": 1563447600,
              "endTime": 1563458400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            }
          ]
        }
      },
      {
        "rdtId": "16248541",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861508",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137408",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137779",
              "startTime": 1563631200,
              "endTime": 1563642000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248542",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861509",
          "startTime": 1563728400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563728400,
            "endTime": 1563760800
          },
          "assignments": [
            {
              "jeId": "12135853",
              "startTime": 1563732000,
              "endTime": 1563739200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12136603",
              "startTime": 1563739200,
              "endTime": 1563760800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25127",
    "class": "Resource",
    "name": "Cooke Kyle",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248652",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861611",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852495",
            "mealTime": 1563220800,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12136260",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786286",
              "jobId": "5083497",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136303",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786296",
              "jobId": "5083507",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12136995",
              "startTime": 1563199200,
              "endTime": 1563213600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248653",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861612",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137249",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137379",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786415",
              "jobId": "5083626",
              "costObject": "2017 THE UNIVERSAL KIDS",
              "costObjectNumber": "T-NIQPD050.J0A2",
              "description": null,
              "comment": "Universal Kids News - Nook #4"
            }
          ]
        }
      },
      {
        "rdtId": "16248654",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861613",
          "startTime": 1563368400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf ap",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135678",
              "startTime": 1563368400,
              "endTime": 1563386400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12137348",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248655",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861614",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "con fkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563487200
          },
          "assignments": [
            {
              "jeId": "12136671",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248656",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861615",
          "startTime": 1563548400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "3pm-3:30pm Help A2 with 3pm/4pm setup for panel show (Kyle confirmed perm. shift) ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135732",
              "startTime": 1563564600,
              "endTime": 1563570000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12135746",
              "startTime": 1563570000,
              "endTime": 1563573600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786223",
              "jobId": "5083434",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "Politics Nation - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137072",
              "startTime": 1563562800,
              "endTime": 1563564600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": "3pm A2 help/4pm A2 help setup",
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137833",
              "startTime": 1563548400,
              "endTime": 1563555600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            },
            {
              "jeId": "12137843",
              "startTime": 1563555600,
              "endTime": 1563559200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248657",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861616",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137416",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137774",
              "startTime": 1563631200,
              "endTime": 1563642000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248658",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861617",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "PROMPTER 3A STUDIO",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137530",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25161",
    "class": "Resource",
    "name": "Bartolomeo Ashley",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248580",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861546",
          "startTime": 1563195600,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "cannot work later today",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852435",
            "mealTime": 1563224400,
            "red": false
          },
          "overtime": {
            "startTime": 1563195600,
            "endTime": 1563228000
          },
          "assignments": [
            {
              "jeId": "12136219",
              "startTime": 1563205500,
              "endTime": 1563210000,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136647",
              "startTime": 1563210000,
              "endTime": 1563224400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            }
          ]
        }
      },
      {
        "rdtId": "16248581",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861547",
          "startTime": 1563285600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "can't stay late",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136284",
              "startTime": 1563292800,
              "endTime": 1563296400,
              "service": "6E super user",
              "activityType": "148E",
              "requestNumber": "3786290",
              "jobId": "5083501",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136285",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "Camera & A2 6E",
              "activityType": "148E",
              "requestNumber": "3786290",
              "jobId": "5083501",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": "6E relief",
              "comment": null
            },
            {
              "jeId": "12136531",
              "startTime": 1563307200,
              "endTime": 1563314400,
              "service": "PR 2K MS",
              "activityType": "148E",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            }
          ]
        }
      },
      {
        "rdtId": "16248582",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861548",
          "startTime": 1563379200,
          "duration": 12.5,
          "remainDuration": null,
          "notificationComment": "will cover Super user until midnight",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563379200,
            "endTime": 1563424200
          },
          "assignments": [
            {
              "jeId": "12135668",
              "startTime": 1563379200,
              "endTime": 1563408000,
              "service": "6E super user",
              "activityType": "148E",
              "requestNumber": "3786214",
              "jobId": "5083425",
              "costObject": "EC STUDIO 6E",
              "costObjectNumber": "S0A507557",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136592",
              "startTime": 1563415200,
              "endTime": 1563424200,
              "service": "6E super user",
              "activityType": "148E",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248583",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        }
      },
      {
        "rdtId": "16248584",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861549",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135734",
              "startTime": 1563562800,
              "endTime": 1563570000,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786222",
              "jobId": "5083433",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136376",
              "startTime": 1563573600,
              "endTime": 1563577200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12136388",
              "startTime": 1563577200,
              "endTime": 1563584400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137054",
              "startTime": 1563584400,
              "endTime": 1563591600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786390",
              "jobId": "5083601",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "SUNDAY STANDBY COVERAGE - 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16248585",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861550",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137136",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137548",
              "startTime": 1563624000,
              "endTime": 1563638400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786438",
              "jobId": "5083649",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal CR 8H / 3E Flash"
            }
          ]
        }
      },
      {
        "rdtId": "16248586",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861551",
          "startTime": 1563714000,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563714000,
            "endTime": 1563760800
          },
          "assignments": [
            {
              "jeId": "12135849",
              "startTime": 1563732000,
              "endTime": 1563739200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12136602",
              "startTime": 1563739200,
              "endTime": 1563760800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137222",
              "startTime": 1563714000,
              "endTime": 1563721200,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786401",
              "jobId": "5083612",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ DCNC N5 / 3A SDO FOR GUESTS"
            },
            {
              "jeId": "12137240",
              "startTime": 1563721200,
              "endTime": 1563728400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25168",
    "class": "Resource",
    "name": "Campbell Reginald",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248618",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861579",
          "startTime": 1563224400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf CM",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9852466",
            "mealTime": 1563224400,
            "red": true
          },
          "assignments": [
            {
              "jeId": "12135650",
              "startTime": 1563238800,
              "endTime": 1563246000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136963",
              "startTime": 1563228000,
              "endTime": 1563235200,
              "service": "Camera Robo DC",
              "activityType": "148E",
              "requestNumber": "3786375",
              "jobId": "5083586",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "CR 2K - HB Live segment play-out & 7:30p Cut-in"
            }
          ]
        }
      },
      {
        "rdtId": "16248619",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        }
      },
      {
        "rdtId": "16248620",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861580",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "w/ hotel..needs first meal",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136570",
              "startTime": 1563411600,
              "endTime": 1563418800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136594",
              "startTime": 1563418800,
              "endTime": 1563422400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248621",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861581",
          "startTime": 1563454800,
          "duration": 12.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563499800
          },
          "assignments": [
            {
              "jeId": "12135695",
              "startTime": 1563465600,
              "endTime": 1563476400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786218",
              "jobId": "5083429",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12135704",
              "startTime": 1563476400,
              "endTime": 1563480000,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786219",
              "jobId": "5083430",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136669",
              "startTime": 1563494400,
              "endTime": 1563499800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137804",
              "startTime": 1563454800,
              "endTime": 1563465600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786475",
              "jobId": "5083686",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137815",
              "startTime": 1563483600,
              "endTime": 1563490800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786476",
              "jobId": "5083687",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6PM Live - REMOTE (Georgia) / 4E FLASH FOR GUESTS / 2K CR - NO PREP"
            },
            {
              "jeId": "12137824",
              "startTime": 1563490800,
              "endTime": 1563494400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786477",
              "jobId": "5083688",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "7PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248622",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861582",
          "startTime": 1563537600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563537600,
            "endTime": 1563566400
          },
          "assignments": [
            {
              "jeId": "12137065",
              "startTime": 1563558300,
              "endTime": 1563562800,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786391",
              "jobId": "5083602",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 2PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137075",
              "startTime": 1563562800,
              "endTime": 1563566400,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137454",
              "startTime": 1563537600,
              "endTime": 1563555600,
              "service": "RB",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248623",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563681600,
          "endTime": 1563767940,
          "comment": null
        }
      }
    ]
  },
  {
    "rId": "25197",
    "class": "Resource",
    "name": "Baden Jessi",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248557",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861524",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "needs to work this shift or latest till 5p",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852413",
            "mealTime": 1563192000,
            "red": true
          },
          "assignments": [
            {
              "jeId": "12136996",
              "startTime": 1563195600,
              "endTime": 1563211800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248558",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861525",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "con fkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137250",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137952",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248559",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861526",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "need LHL",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135679",
              "startTime": 1563364800,
              "endTime": 1563386400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12136634",
              "startTime": 1563386400,
              "endTime": 1563390000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248560",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861527",
          "startTime": 1563555600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "emd",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136377",
              "startTime": 1563570000,
              "endTime": 1563577200,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786305",
              "jobId": "5083516",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "6P KC DC PRETAPE - 2K CONTROL / SDO 3A WEST"
            },
            {
              "jeId": "12136386",
              "startTime": 1563577200,
              "endTime": 1563584400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786306",
              "jobId": "5083517",
              "costObject": "MSNBC Kasie Hunt",
              "costObjectNumber": "T-KHXX1001.J077",
              "description": null,
              "comment": "Kasie Hunt - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137074",
              "startTime": 1563555600,
              "endTime": 1563566400,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248561",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861528",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "emd",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137094",
              "startTime": 1563627600,
              "endTime": 1563631200,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137403",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137775",
              "startTime": 1563631200,
              "endTime": 1563642000,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248562",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861529",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "  ",
          "tourComment": "con fkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12136601",
              "startTime": 1563735600,
              "endTime": 1563760800,
              "service": "SM",
              "activityType": "148E",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25205",
    "class": "Resource",
    "name": "Smith Laurel",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248118",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861110",
          "startTime": 1563220800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "COVER DINA",
          "tourComment": "CNF 10/20 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852006",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135643",
              "startTime": 1563238800,
              "endTime": 1563247800,
              "service": "Video & LD HAYES",
              "activityType": "6214",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136310",
              "startTime": 1563224400,
              "endTime": 1563238800,
              "service": "Video V1",
              "activityType": "6214",
              "requestNumber": "3786296",
              "jobId": "5083507",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12136943",
              "startTime": 1563247800,
              "endTime": 1563249600,
              "service": "Video & LD STANDBY",
              "activityType": "6214",
              "requestNumber": "3786373",
              "jobId": "5083584",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248119",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861111",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "OTT 74 VIDEO 5p-8p",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136515",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "Video & LD 3 PM",
              "activityType": "6214",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137248",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "Video V1",
              "activityType": "6214",
              "requestNumber": "3786404",
              "jobId": "5083615",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137948",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "Video & LD 1 PM",
              "activityType": "6214",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248120",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861112",
          "startTime": 1563364800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135921",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "Video & LD 2 PM",
              "activityType": "6214",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12135951",
              "startTime": 1563379200,
              "endTime": 1563382800,
              "service": "Video & LD STANDBY",
              "activityType": "6214",
              "requestNumber": "3786245",
              "jobId": "5083456",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 2K Standby",
              "comment": null
            },
            {
              "jeId": "12137359",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "Video & LD 9 AM",
              "activityType": "6214",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137373",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "Video & LD 11 AM",
              "activityType": "6214",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248121",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861113",
          "startTime": 1563463800,
          "duration": 9.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563463800,
            "endTime": 1563498000
          },
          "assignments": [
            {
              "jeId": "12136344",
              "startTime": 1563476400,
              "endTime": 1563490800,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137028",
              "startTime": 1563463800,
              "endTime": 1563469200,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786387",
              "jobId": "5083598",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 12PM"
            },
            {
              "jeId": "12137038",
              "startTime": 1563469200,
              "endTime": 1563472800,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786388",
              "jobId": "5083599",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 1PM"
            },
            {
              "jeId": "12137039",
              "startTime": 1563490800,
              "endTime": 1563498000,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248122",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861114",
          "startTime": 1563537600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136350",
              "startTime": 1563537600,
              "endTime": 1563544800,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137070",
              "startTime": 1563559200,
              "endTime": 1563566400,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786392",
              "jobId": "5083603",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 3PM - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12137835",
              "startTime": 1563548400,
              "endTime": 1563555600,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            },
            {
              "jeId": "12137845",
              "startTime": 1563555600,
              "endTime": 1563559200,
              "service": "TD WEEKEND",
              "activityType": "6214",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248123",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861115",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12136395",
              "startTime": 1563638400,
              "endTime": 1563645600,
              "service": "Video & LD 1 PM",
              "activityType": "6214",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136426",
              "startTime": 1563649200,
              "endTime": 1563650100,
              "service": "Video V1",
              "activityType": "6214",
              "requestNumber": "3786309",
              "jobId": "5083520",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 2K - Path Update",
              "comment": null
            },
            {
              "jeId": "12136432",
              "startTime": 1563650100,
              "endTime": 1563656400,
              "service": "Video & LD 4 PM",
              "activityType": "6214",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136703",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "Video V1",
              "activityType": "6214",
              "requestNumber": "3786343",
              "jobId": "5083554",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "Cancelled - Hardball Pretape - 3A West / CR 2K"
            },
            {
              "jeId": "12137095",
              "startTime": 1563631200,
              "endTime": 1563638400,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6214",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248124",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861116",
          "startTime": 1563726600,
          "duration": 13.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/20 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ],
          "assignments": [
            {
              "jeId": "12135846",
              "startTime": 1563732000,
              "endTime": 1563739200,
              "service": "Video & LD 3 PM",
              "activityType": "6214",
              "requestNumber": "3786232",
              "jobId": "5083443",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137544",
              "startTime": 1563739200,
              "endTime": 1563775200,
              "service": "Video V1",
              "activityType": "6214",
              "requestNumber": "3786437",
              "jobId": "5083648",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137896",
              "startTime": 1563726600,
              "endTime": 1563732000,
              "service": "Video & LD 1 PM",
              "activityType": "6214",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25206",
    "class": "Resource",
    "name": "Pircher Meredith",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248458",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861429",
          "startTime": 1563220800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "COVERS RACHEL",
          "tourComment": "CNF 8/8 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852318",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136272",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "Video & LD MADDOW",
              "activityType": "6214",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12137400",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "Video V1",
              "activityType": "6214",
              "requestNumber": "3786418",
              "jobId": "5083629",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            },
            {
              "jeId": "12137751",
              "startTime": 1563242400,
              "endTime": 1563249600,
              "service": "Video & LD BW",
              "activityType": "6214",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248459",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861430",
          "startTime": 1563285600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELECTIONS GRAPHICS",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248460",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861431",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELECTIONS GRAPHICS",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248461",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861432",
          "startTime": 1563454800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248462",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861433",
          "startTime": 1563523200,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563523200,
            "endTime": 1563570000
          },
          "assignments": [
            {
              "jeId": "12137010",
              "startTime": 1563523200,
              "endTime": 1563552000,
              "service": "Graphics PB Op - Elections",
              "activityType": "6214",
              "requestNumber": "3786383",
              "jobId": "5083594",
              "costObject": "MEET THE PRESS PRODUCTION",
              "costObjectNumber": "J0A203130",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248463",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861434",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "ELECTIONS GRAPHICS",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null
        }
      },
      {
        "rdtId": "16248464",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861435",
          "startTime": 1563696000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563696000,
            "endTime": 1563739200
          }
        }
      }
    ]
  },
  {
    "rId": "25235",
    "class": "Resource",
    "name": "Avitable Michael",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248550",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861517",
          "startTime": 1563174000,
          "duration": 11.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852406",
            "mealTime": 1563174000,
            "red": true
          },
          "overtime": {
            "startTime": 1563174000,
            "endTime": 1563215400
          },
          "assignments": [
            {
              "jeId": "12136278",
              "startTime": 1563177600,
              "endTime": 1563197400,
              "service": "Camera Utility Today Show",
              "activityType": "148E",
              "requestNumber": "3786288",
              "jobId": "5083499",
              "costObject": "Today Show O&TS",
              "costObjectNumber": "J0A206200",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136279",
              "startTime": 1563197400,
              "endTime": 1563202800,
              "service": "Camera Utility Today Show",
              "activityType": "148E",
              "requestNumber": "3786288",
              "jobId": "5083499",
              "costObject": "TODAY SHOW 10 AM",
              "costObjectNumber": "T-TODAY10A.J0A2",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248551",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861518",
          "startTime": 1563260400,
          "duration": 8.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563260400,
            "endTime": 1563290100
          },
          "assignments": [
            {
              "jeId": "12136280",
              "startTime": 1563272100,
              "endTime": 1563283800,
              "service": "Camera Utility Today Show",
              "activityType": "148E",
              "requestNumber": "3786289",
              "jobId": "5083500",
              "costObject": "Today Show O&TS",
              "costObjectNumber": "J0A206200",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136281",
              "startTime": 1563283800,
              "endTime": 1563290100,
              "service": "Camera Utility Today Show",
              "activityType": "148E",
              "requestNumber": "3786289",
              "jobId": "5083500",
              "costObject": "TODAY SHOW 10 AM",
              "costObjectNumber": "T-TODAY10A.J0A2",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136487",
              "startTime": 1563269400,
              "endTime": 1563272100,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12136488",
              "startTime": 1563264000,
              "endTime": 1563269400,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            }
          ]
        }
      },
      {
        "rdtId": "16248552",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861519",
          "startTime": 1563346800,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563346800,
            "endTime": 1563382800
          },
          "assignments": [
            {
              "jeId": "12135664",
              "startTime": 1563358500,
              "endTime": 1563382800,
              "service": "Camera Utility Today Show",
              "activityType": "148E",
              "requestNumber": "3786212",
              "jobId": "5083423",
              "costObject": "Today Show O&TS",
              "costObjectNumber": "J0A206200",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248553",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861520",
          "startTime": 1563606000,
          "duration": 10.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563606000,
            "endTime": 1563642900
          },
          "assignments": [
            {
              "jeId": "12136736",
              "startTime": 1563617700,
              "endTime": 1563629400,
              "service": "Camera Utility Today Show",
              "activityType": "148E",
              "requestNumber": "3786355",
              "jobId": "5083566",
              "costObject": "Today Show O&TS",
              "costObjectNumber": "J0A206200",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136737",
              "startTime": 1563629400,
              "endTime": 1563635700,
              "service": "Camera Utility Today Show",
              "activityType": "148E",
              "requestNumber": "3786355",
              "jobId": "5083566",
              "costObject": "TODAY SHOW 10 AM",
              "costObjectNumber": "T-TODAY10A.J0A2",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137125",
              "startTime": 1563615000,
              "endTime": 1563617700,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137126",
              "startTime": 1563606000,
              "endTime": 1563615000,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            }
          ]
        }
      },
      {
        "rdtId": "16248554",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861521",
          "startTime": 1563721200,
          "duration": 15.25,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563721200,
            "endTime": 1563776100
          }
        }
      }
    ]
  },
  {
    "rId": "25265",
    "class": "Resource",
    "name": "Wilson Dane",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247765",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860808",
          "startTime": 1563220800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/22 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851710",
            "mealTime": 1563228000,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135645",
              "startTime": 1563238800,
              "endTime": 1563246000,
              "service": "TD LAST WORD",
              "activityType": "149N",
              "requestNumber": "3786209",
              "jobId": "5083420",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            },
            {
              "jeId": "12136246",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "TD HAYES",
              "activityType": "149N",
              "requestNumber": "3786284",
              "jobId": "5083495",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12136944",
              "startTime": 1563246000,
              "endTime": 1563249600,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786373",
              "jobId": "5083584",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            },
            {
              "jeId": "12137741",
              "startTime": 1563220800,
              "endTime": 1563228000,
              "service": "TD 5 PM",
              "activityType": "149N",
              "requestNumber": "3786468",
              "jobId": "5083679",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            }
          ]
        }
      },
      {
        "rdtId": "16247766",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860809",
          "startTime": 1563303600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/22 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136524",
              "startTime": 1563303600,
              "endTime": 1563314400,
              "service": "TD 5 PM",
              "activityType": "149N",
              "requestNumber": "3786317",
              "jobId": "5083528",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K & 4E FLASH FOR GUEST"
            },
            {
              "jeId": "12137288",
              "startTime": 1563318000,
              "endTime": 1563325200,
              "service": "TD HAYES",
              "activityType": "149N",
              "requestNumber": "3786407",
              "jobId": "5083618",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / 4E FLASH - 7pm PREP"
            },
            {
              "jeId": "12137290",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "TD LAST WORD",
              "activityType": "149N",
              "requestNumber": "3786408",
              "jobId": "5083619",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A /4E FLASH - 9PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247767",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860810",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/22 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136562",
              "startTime": 1563411600,
              "endTime": 1563418800,
              "service": "TD LAST WORD",
              "activityType": "149N",
              "requestNumber": "3786321",
              "jobId": "5083532",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P - CR 3A /4E FLASH"
            },
            {
              "jeId": "12136574",
              "startTime": 1563418800,
              "endTime": 1563422400,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786322",
              "jobId": "5083533",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            },
            {
              "jeId": "12137469",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16247768",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860811",
          "startTime": 1563444000,
          "duration": 4,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136331",
              "startTime": 1563444000,
              "endTime": 1563451200,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786300",
              "jobId": "5083511",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 7AM-7:30AM  (6AM PREP)"
            },
            {
              "jeId": "12137783",
              "startTime": 1563451200,
              "endTime": 1563458400,
              "service": "TD WEEKEND",
              "activityType": "149N",
              "requestNumber": "3786474",
              "jobId": "5083685",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "4E FLASH / 2K CR - LIVE 8AM & 9AM"
            }
          ]
        }
      },
      {
        "rdtId": "16247769",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860812",
          "startTime": 1563546600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "CR 7A",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136292",
              "startTime": 1563546600,
              "endTime": 1563575400,
              "service": "Training Network",
              "activityType": "1291A5",
              "requestNumber": "3786294",
              "jobId": "5083505",
              "costObject": "Network Training",
              "costObjectNumber": "WT-10051",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247770",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860813",
          "startTime": 1563649200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/22 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135782",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "TD LAST WORD",
              "activityType": "149N",
              "requestNumber": "3786226",
              "jobId": "5083437",
              "costObject": "LAWRENCE O'DONNELL SHOW MSNBC ENG OPS IN",
              "costObjectNumber": "T-LDXX1001.J077",
              "description": null,
              "comment": "LOD 10P LIVE - CR 3A / REMOTE (Los Angeles) / SDO 3A WEST FOR GUESTS"
            },
            {
              "jeId": "12137109",
              "startTime": 1563649200,
              "endTime": 1563652800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA149N",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137148",
              "startTime": 1563652800,
              "endTime": 1563660000,
              "service": "TD 5 PM",
              "activityType": "149N",
              "requestNumber": "3786396",
              "jobId": "5083607",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2E / 3A WEST"
            },
            {
              "jeId": "12137879",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "TD HAYES",
              "activityType": "149N",
              "requestNumber": "3786482",
              "jobId": "5083693",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "HAYES 8P LIVE - CR 3A / REMOTE ( Dallas) / SDO 3A WEST FOR GUESTS - 7pm PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16247771",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860814",
          "startTime": 1563735600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/22 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136455",
              "startTime": 1563735600,
              "endTime": 1563742800,
              "service": "TD 4 PM",
              "activityType": "149N",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137533",
              "startTime": 1563750000,
              "endTime": 1563764400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786436",
              "jobId": "5083647",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC ELECTION NIGHT - 2K SUBSWITCH  (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137932",
              "startTime": 1563742800,
              "endTime": 1563746400,
              "service": "TD 5 PM",
              "activityType": "149N",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25319",
    "class": "Resource",
    "name": "Johansky Justin",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248745",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        }
      },
      {
        "rdtId": "16248746",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861687",
          "startTime": 1563292800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "cannot come in earlier",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852571",
            "mealTime": 1563300000,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137264",
              "startTime": 1563303600,
              "endTime": 1563310800,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137277",
              "startTime": 1563310800,
              "endTime": 1563321600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137955",
              "startTime": 1563292800,
              "endTime": 1563300000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786492",
              "jobId": "5083703",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248747",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861688",
          "startTime": 1563379200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135928",
              "startTime": 1563379200,
              "endTime": 1563390000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12137352",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786411",
              "jobId": "5083622",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248748",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861689",
          "startTime": 1563454800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "can only stay until 5p",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136670",
              "startTime": 1563454800,
              "endTime": 1563483600,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248749",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        }
      },
      {
        "rdtId": "16248750",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        }
      },
      {
        "rdtId": "16248751",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861690",
          "startTime": 1563739200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "STEADICAM BREAKER 3A STUDIO WEST",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136718",
              "startTime": 1563746400,
              "endTime": 1563768000,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786345",
              "jobId": "5083556",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A WEST (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137941",
              "startTime": 1563739200,
              "endTime": 1563746400,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25354",
    "class": "Resource",
    "name": "Smith Ashley",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247756",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860799",
          "startTime": 1563195600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/19 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851701",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136644",
              "startTime": 1563213600,
              "endTime": 1563220800,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            }
          ]
        }
      },
      {
        "rdtId": "16247757",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860800",
          "startTime": 1563310800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/19 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563310800,
            "endTime": 1563343200
          },
          "assignments": [
            {
              "jeId": "12137440",
              "startTime": 1563314400,
              "endTime": 1563336000,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786425",
              "jobId": "5083636",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            }
          ]
        }
      },
      {
        "rdtId": "16247758",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860801",
          "startTime": 1563393600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "now covers 6p thru Elections.",
          "tourComment": "CNF 10/19 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563393600,
            "endTime": 1563429600
          },
          "assignments": [
            {
              "jeId": "12136583",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "TD BW",
              "activityType": "149N",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            },
            {
              "jeId": "12136694",
              "startTime": 1563422400,
              "endTime": 1563429600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786341",
              "jobId": "5083552",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Overnight Elections Wall Testing. 2E CR from 08:00 PM - 11:00 PM, then 3A CR / SDO 3A 11PM - 2A"
            },
            {
              "jeId": "12137486",
              "startTime": 1563393600,
              "endTime": 1563404400,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786431",
              "jobId": "5083642",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247759",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860802",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136657",
              "startTime": 1563454800,
              "endTime": 1563487200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247760",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860803",
          "startTime": 1563541200,
          "duration": 14,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137446",
              "startTime": 1563541200,
              "endTime": 1563555600,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16247761",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860804",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "now covers 6p thru Elections.",
          "tourComment": "CNF 10/19 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137882",
              "startTime": 1563678000,
              "endTime": 1563681600,
              "service": "TD STANDBY",
              "activityType": "149N",
              "requestNumber": "3786483",
              "jobId": "5083694",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3A STANDBY",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16247762",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10860805",
          "startTime": 1563746400,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563746400,
            "endTime": 1563793200
          },
          "assignments": [
            {
              "jeId": "12137496",
              "startTime": 1563746400,
              "endTime": 1563775200,
              "service": "TD",
              "activityType": "149N",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25382",
    "class": "Resource",
    "name": "Magistro Nicholas",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248795",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861725",
          "startTime": 1563220800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852609",
            "mealTime": 1563220800,
            "red": true
          },
          "assignments": [
            {
              "jeId": "12136273",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "A2 3A  MD",
              "activityType": "148E",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136931",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12136972",
              "startTime": 1563231600,
              "endTime": 1563235200,
              "service": "3E",
              "activityType": "148E",
              "requestNumber": "3786376",
              "jobId": "5083587",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": "7:30p HB Cutin in 3E",
              "comment": null
            },
            {
              "jeId": "12137756",
              "startTime": 1563242400,
              "endTime": 1563249600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248796",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861726",
          "startTime": 1563282900,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "needs this in time",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136520",
              "startTime": 1563300000,
              "endTime": 1563307200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786316",
              "jobId": "5083527",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137328",
              "startTime": 1563307200,
              "endTime": 1563310800,
              "service": "AVAILABLE MSNBC",
              "activityType": "ZD6206",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248797",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861727",
          "startTime": 1563368400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135915",
              "startTime": 1563382800,
              "endTime": 1563386400,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786241",
              "jobId": "5083452",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12136548",
              "startTime": 1563368400,
              "endTime": 1563375600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786319",
              "jobId": "5083530",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (West Virginia) /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136553",
              "startTime": 1563375600,
              "endTime": 1563382800,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            }
          ]
        }
      },
      {
        "rdtId": "16248798",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861728",
          "startTime": 1563454800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "cannot stay past 5p today",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136675",
              "startTime": 1563454800,
              "endTime": 1563483600,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786336",
              "jobId": "5083547",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Elections Rehearsal - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248799",
        "title": "DH NPT",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "DH NPT",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        }
      },
      {
        "rdtId": "16248800",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861729",
          "startTime": 1563739200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "A2 3A WEST",
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563739200,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12136716",
              "startTime": 1563739200,
              "endTime": 1563775200,
              "service": "A2",
              "activityType": "148E",
              "requestNumber": "3786345",
              "jobId": "5083556",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A WEST (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25413",
    "class": "Resource",
    "name": "Venezia Michael",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248211",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861198",
          "startTime": 1563163200,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "meal": {
            "mealId": "9852089",
            "mealTime": 1563163200,
            "red": true
          },
          "overtime": {
            "startTime": 1563163200,
            "endTime": 1563193800
          },
          "assignments": [
            {
              "jeId": "12136252",
              "startTime": 1563172200,
              "endTime": 1563192000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786285",
              "jobId": "5083496",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12136918",
              "startTime": 1563192000,
              "endTime": 1563193800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12137739",
              "startTime": 1563166800,
              "endTime": 1563172200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786467",
              "jobId": "5083678",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16248212",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861199",
          "startTime": 1563249600,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563249600,
            "endTime": 1563280200
          },
          "assignments": [
            {
              "jeId": "12135880",
              "startTime": 1563253200,
              "endTime": 1563258600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786236",
              "jobId": "5083447",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12136481",
              "startTime": 1563278400,
              "endTime": 1563280200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12137983",
              "startTime": 1563258600,
              "endTime": 1563278400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786495",
              "jobId": "5083706",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248213",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861200",
          "startTime": 1563336000,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563336000,
            "endTime": 1563366600
          },
          "assignments": [
            {
              "jeId": "12135933",
              "startTime": 1563339600,
              "endTime": 1563345000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786243",
              "jobId": "5083454",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12135940",
              "startTime": 1563345000,
              "endTime": 1563364800,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786244",
              "jobId": "5083455",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            }
          ]
        }
      },
      {
        "rdtId": "16248214",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861201",
          "startTime": 1563472800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136335",
              "startTime": 1563472800,
              "endTime": 1563483600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786301",
              "jobId": "5083512",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "MSNBC Live - 4PM - 4E FLASH / 2K CR"
            },
            {
              "jeId": "12136341",
              "startTime": 1563483600,
              "endTime": 1563487200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786302",
              "jobId": "5083513",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "5p Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137042",
              "startTime": 1563490800,
              "endTime": 1563498000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786389",
              "jobId": "5083600",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "8PM Live - 4E FLASH / 2K CR - NO PREP"
            },
            {
              "jeId": "12137434",
              "startTime": 1563498000,
              "endTime": 1563501600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786424",
              "jobId": "5083635",
              "costObject": "DAYSIDE WEEKEND UNIT COSTS",
              "costObjectNumber": "T-DWXXUNIT.J077",
              "description": null,
              "comment": "9pm LIVE - 4E FLASH / 2K CR"
            }
          ]
        }
      },
      {
        "rdtId": "16248215",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861202",
          "startTime": 1563595200,
          "duration": 13,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563595200,
            "endTime": 1563642000
          },
          "assignments": [
            {
              "jeId": "12137128",
              "startTime": 1563624000,
              "endTime": 1563625800,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137771",
              "startTime": 1563625800,
              "endTime": 1563642000,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            },
            {
              "jeId": "12137853",
              "startTime": 1563604200,
              "endTime": 1563624000,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786480",
              "jobId": "5083691",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137891",
              "startTime": 1563598800,
              "endTime": 1563604200,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786484",
              "jobId": "5083695",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            }
          ]
        }
      },
      {
        "rdtId": "16248216",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861203",
          "startTime": 1563681600,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563681600,
            "endTime": 1563712200
          },
          "assignments": [
            {
              "jeId": "12135816",
              "startTime": 1563685200,
              "endTime": 1563690600,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786229",
              "jobId": "5083440",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": null,
              "comment": "CONTROL 2K STANDBY"
            },
            {
              "jeId": "12137192",
              "startTime": 1563690600,
              "endTime": 1563710400,
              "service": "Graphics PB Op FS - GPO",
              "activityType": "149P",
              "requestNumber": "3786399",
              "jobId": "5083610",
              "costObject": "EARLY TODAY MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-ETXX1001.J077",
              "description": null,
              "comment": "ET/FL - CR 2K / 4E Flashcam"
            },
            {
              "jeId": "12137209",
              "startTime": 1563710400,
              "endTime": 1563712200,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25572",
    "class": "Resource",
    "name": "Hutchinson Rashaun",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248731",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861674",
          "startTime": 1563177600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS"
          ],
          "meal": {
            "mealId": "9852558",
            "mealTime": 1563184800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12135657",
              "startTime": 1563199200,
              "endTime": 1563206400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786210",
              "jobId": "5083421",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 2K /4E FLASH  (NO PREP)"
            },
            {
              "jeId": "12136921",
              "startTime": 1563183000,
              "endTime": 1563192000,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136922",
              "startTime": 1563177600,
              "endTime": 1563183000,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12136955",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248732",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861675",
          "startTime": 1563271200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136483",
              "startTime": 1563271200,
              "endTime": 1563285600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786313",
              "jobId": "5083524",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "MJ post tape Crew in place until 9:30am."
            },
            {
              "jeId": "12137329",
              "startTime": 1563289200,
              "endTime": 1563300000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248733",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861676",
          "startTime": 1563357600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135684",
              "startTime": 1563372000,
              "endTime": 1563386400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248734",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861677",
          "startTime": 1563606000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563606000,
            "endTime": 1563642000
          },
          "assignments": [
            {
              "jeId": "12137130",
              "startTime": 1563606000,
              "endTime": 1563629400,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786394",
              "jobId": "5083605",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "CR 3A / SDO 3A / MOVES TO 2K & 3A WEST FOR POSTTAPE 9-930A"
            },
            {
              "jeId": "12137780",
              "startTime": 1563631200,
              "endTime": 1563642000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248735",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861678",
          "startTime": 1563692400,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563692400,
            "endTime": 1563724800
          },
          "assignments": [
            {
              "jeId": "12136619",
              "startTime": 1563714000,
              "endTime": 1563724800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786327",
              "jobId": "5083538",
              "costObject": "MSNBC MJ 8H Post Election Show",
              "costObjectNumber": "NM-S18.037",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137211",
              "startTime": 1563701400,
              "endTime": 1563704100,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137212",
              "startTime": 1563704100,
              "endTime": 1563714000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137213",
              "startTime": 1563696000,
              "endTime": 1563701400,
              "service": "PR 3A MJ",
              "activityType": "148E",
              "requestNumber": "3786400",
              "jobId": "5083611",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": null
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25671",
    "class": "Resource",
    "name": "Zingman Jesse",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248003",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861016",
          "startTime": 1563220800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9851912",
            "mealTime": 1563231600,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136213",
              "startTime": 1563220800,
              "endTime": 1563224400,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136274",
              "startTime": 1563235200,
              "endTime": 1563242400,
              "service": "PR 2K MD",
              "activityType": "148E",
              "requestNumber": "3786287",
              "jobId": "5083498",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12136934",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137754",
              "startTime": 1563242400,
              "endTime": 1563249600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786469",
              "jobId": "5083680",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248004",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861017",
          "startTime": 1563307200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135898",
              "startTime": 1563321600,
              "endTime": 1563328800,
              "service": "PR 2K MD",
              "activityType": "148E",
              "requestNumber": "3786238",
              "jobId": "5083449",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP 8PM"
            },
            {
              "jeId": "12137275",
              "startTime": 1563310800,
              "endTime": 1563318000,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786406",
              "jobId": "5083617",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A / 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137331",
              "startTime": 1563307200,
              "endTime": 1563310800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137991",
              "startTime": 1563328800,
              "endTime": 1563336000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786496",
              "jobId": "5083707",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248005",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861018",
          "startTime": 1563393600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "can't come in earlier ",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136587",
              "startTime": 1563415200,
              "endTime": 1563422400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786324",
              "jobId": "5083535",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ 6E nook 4 - 10PM PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248006",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563422400,
          "endTime": 1563508740,
          "comment": null
        }
      },
      {
        "rdtId": "16248007",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861019",
          "startTime": 1563562800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "check with TM about meal.. 3pm in time confirmed CM",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136004",
              "startTime": 1563580800,
              "endTime": 1563588000,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786257",
              "jobId": "5083468",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "9pm LIVE - 3A SDO / CR 3A - 8P PREP"
            }
          ]
        }
      },
      {
        "rdtId": "16248008",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861020",
          "startTime": 1563652800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135806",
              "startTime": 1563674400,
              "endTime": 1563681600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786228",
              "jobId": "5083439",
              "costObject": "MSNBC 11PM END OPS INTERNAL",
              "costObjectNumber": "T-11PX1001.J077",
              "description": null,
              "comment": "11PM LIVE - CR 2K/ STUDIO 3A - 10PM PREP"
            },
            {
              "jeId": "12136452",
              "startTime": 1563656400,
              "endTime": 1563663600,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786311",
              "jobId": "5083522",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12137107",
              "startTime": 1563652800,
              "endTime": 1563656400,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137182",
              "startTime": 1563667200,
              "endTime": 1563674400,
              "service": "PR 2K MD",
              "activityType": "148E",
              "requestNumber": "3786398",
              "jobId": "5083609",
              "costObject": "MADDOW SHOW MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MAXX1001.J077",
              "description": null,
              "comment": "MADDOW 9P LIVE - CR 2K / SDO 3A - CR/SDO PREP @ 8PM"
            }
          ]
        }
      },
      {
        "rdtId": "16248009",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861021",
          "startTime": 1563732000,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "PROMPTER  3A STUDIO",
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563732000,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137526",
              "startTime": 1563732000,
              "endTime": 1563775200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786435",
              "jobId": "5083646",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25677",
    "class": "Resource",
    "name": "Flanagan Tristan",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": null
  },
  {
    "rId": "25682",
    "class": "Resource",
    "name": "Sene Lisa",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16247890",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563163200,
          "endTime": 1563249540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16247891",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16247892",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16247893",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563595200,
          "endTime": 1563681540,
          "comment": null
        },
        "tour": null
      },
      {
        "rdtId": "16247894",
        "title": "Not Available (DH/FL Only)",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Not Available (DH/FL Only)",
          "startTime": 1563681600,
          "endTime": 1563767940,
          "comment": null
        },
        "tour": null
      }
    ]
  },
  {
    "rId": "25739",
    "class": "Resource",
    "name": "Hansford Marquise",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248706",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861652",
          "startTime": 1563206400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf AP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852536",
            "mealTime": 1563220800,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136305",
              "startTime": 1563224400,
              "endTime": 1563235200,
              "service": "UT",
              "activityType": "6214",
              "requestNumber": "3786296",
              "jobId": "5083507",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 74 / 4E TOWN SQUARE"
            },
            {
              "jeId": "12136652",
              "startTime": 1563206400,
              "endTime": 1563220800,
              "service": "UT",
              "activityType": "6214",
              "requestNumber": "3786333",
              "jobId": "5083544",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Elections Production Team Rehearsal - 3A Control / 3A Studio"
            }
          ]
        }
      },
      {
        "rdtId": "16248707",
        "title": "Jury Duty",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Jury Duty",
          "startTime": 1563249600,
          "endTime": 1563335940,
          "comment": null
        }
      },
      {
        "rdtId": "16248708",
        "title": "Jury Duty",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "Jury Duty",
          "startTime": 1563336000,
          "endTime": 1563422340,
          "comment": null
        }
      },
      {
        "rdtId": "16248709",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "tour": {
          "tourId": "10861653",
          "startTime": 1563530400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135720",
              "startTime": 1563534900,
              "endTime": 1563541200,
              "service": "PR",
              "activityType": "6214",
              "requestNumber": "3786221",
              "jobId": "5083432",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - LIVE - 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136353",
              "startTime": 1563541200,
              "endTime": 1563544800,
              "service": "PR",
              "activityType": "6214",
              "requestNumber": "3786303",
              "jobId": "5083514",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "UP - CONTROL 2K CONTROL / 3A WEST STUDIO"
            },
            {
              "jeId": "12136369",
              "startTime": 1563544800,
              "endTime": 1563545700,
              "service": "PR",
              "activityType": "6214",
              "requestNumber": "3786304",
              "jobId": "5083515",
              "costObject": "AM JOY ENG OPS INTERNAL",
              "costObjectNumber": "T-JYXX1001.J077",
              "description": null,
              "comment": "REMOTE (Florida) / 2K CONTROL / 3A WEST STUDIO FOR GUESTS  - AM JOY - LIVE 10A & 11A"
            },
            {
              "jeId": "12137834",
              "startTime": 1563551100,
              "endTime": 1563555600,
              "service": "PR",
              "activityType": "6214",
              "requestNumber": "3786478",
              "jobId": "5083689",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "12pm LIVE 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            },
            {
              "jeId": "12137844",
              "startTime": 1563555600,
              "endTime": 1563559200,
              "service": "PR",
              "activityType": "6214",
              "requestNumber": "3786479",
              "jobId": "5083690",
              "costObject": "DAYSIDE WEEKEND END OPS INTERNAL",
              "costObjectNumber": "T-DWXX1001.J077",
              "description": null,
              "comment": "1pm - 2K CONTROL / 3A WEST STUDIO / 3E Flash For Guests"
            }
          ]
        }
      },
      {
        "rdtId": "16248710",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861654",
          "startTime": 1563629400,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONFKP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563629400,
            "endTime": 1563660000
          },
          "assignments": [
            {
              "jeId": "12136403",
              "startTime": 1563641100,
              "endTime": 1563645600,
              "service": "UT",
              "activityType": "6214",
              "requestNumber": "3786307",
              "jobId": "5083518",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136440",
              "startTime": 1563649200,
              "endTime": 1563660000,
              "service": "UT",
              "activityType": "6214",
              "requestNumber": "3786310",
              "jobId": "5083521",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K/ 4E Flash"
            },
            {
              "jeId": "12136701",
              "startTime": 1563645600,
              "endTime": 1563649200,
              "service": "PR",
              "activityType": "6214",
              "requestNumber": "3786343",
              "jobId": "5083554",
              "costObject": "HARDBALL MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-HBXX1001.J077",
              "description": null,
              "comment": "Cancelled - Hardball Pretape - 3A West / CR 2K"
            },
            {
              "jeId": "12137866",
              "startTime": 1563630300,
              "endTime": 1563636600,
              "service": "UT",
              "activityType": "6214",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248711",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861655",
          "startTime": 1563724800,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563724800,
            "endTime": 1563760800
          },
          "assignments": [
            {
              "jeId": "12136605",
              "startTime": 1563739200,
              "endTime": 1563760800,
              "service": "UT",
              "activityType": "6214",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137904",
              "startTime": 1563724800,
              "endTime": 1563735600,
              "service": "UT",
              "activityType": "6214",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25741",
    "class": "Resource",
    "name": "Candrilli Matthew",
    "empCat": "Staff",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248219",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861206",
          "startTime": 1563210000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "meal": {
            "mealId": "9852097",
            "mealTime": 1563210000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136214",
              "startTime": 1563213600,
              "endTime": 1563217200,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA149N",
              "requestNumber": "3786281",
              "jobId": "5083492",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12136639",
              "startTime": 1563231600,
              "endTime": 1563238800,
              "service": "Training MSNBC",
              "activityType": "TR6214",
              "requestNumber": "3786330",
              "jobId": "5083541",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "TRAIN: HAYES A1",
              "comment": null
            },
            {
              "jeId": "12136936",
              "startTime": 1563224400,
              "endTime": 1563231600,
              "service": "Audio A1 6 PM",
              "activityType": "6214",
              "requestNumber": "3786372",
              "jobId": "5083583",
              "costObject": "MSNBC 6PM END OPS INTERNAL",
              "costObjectNumber": "T-6PXX1001.J077",
              "description": null,
              "comment": "6p Live - CR 3A & 4E FLASH (5p PREP)"
            },
            {
              "jeId": "12137734",
              "startTime": 1563217200,
              "endTime": 1563224400,
              "service": "Audio A1 4 PM",
              "activityType": "6214",
              "requestNumber": "3786466",
              "jobId": "5083677",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / 3A STUDIO"
            }
          ]
        }
      },
      {
        "rdtId": "16248220",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861207",
          "startTime": 1563303600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12135971",
              "startTime": 1563307200,
              "endTime": 1563325200,
              "service": "Training MSNBC",
              "activityType": "TR6214",
              "requestNumber": "3786251",
              "jobId": "5083462",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "TRAIN: 74 A1 with Rob May",
              "comment": null
            },
            {
              "jeId": "12135972",
              "startTime": 1563325200,
              "endTime": 1563332400,
              "service": "Training MSNBC",
              "activityType": "TR6214",
              "requestNumber": "3786251",
              "jobId": "5083462",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "TRAIN: LOD",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248221",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861208",
          "startTime": 1563343200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "DO NOT ASSIGN AFTER 8a",
          "tourComment": "CNF 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS"
          ]
        }
      },
      {
        "rdtId": "16248222",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861209",
          "startTime": 1563454800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563487200
          }
        }
      },
      {
        "rdtId": "16248223",
        "title": "OFF",
        "myDayComment": null,
        "dayOff": {
          "dorId": "0",
          "title": "OFF",
          "startTime": 1563508800,
          "endTime": 1563595140,
          "comment": null
        }
      },
      {
        "rdtId": "16248224",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861210",
          "startTime": 1563649200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": null,
          "assignments": [
            {
              "jeId": "12137491",
              "startTime": 1563663600,
              "endTime": 1563670800,
              "service": "Training MSNBC",
              "activityType": "TR6214",
              "requestNumber": "3786434",
              "jobId": "5083645",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "TRAIN: Hayes A1",
              "comment": null
            },
            {
              "jeId": "12137492",
              "startTime": 1563670800,
              "endTime": 1563678000,
              "service": "Training MSNBC",
              "activityType": "TR6214",
              "requestNumber": "3786434",
              "jobId": "5083645",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "TRAIN: LOD",
              "comment": null
            },
            {
              "jeId": "12137493",
              "startTime": 1563652800,
              "endTime": 1563663600,
              "service": "Training MSNBC",
              "activityType": "TR6214",
              "requestNumber": "3786434",
              "jobId": "5083645",
              "costObject": "MSNBC Training",
              "costObjectNumber": "WT-10050",
              "description": "TRAIN: CR 74 with Rob May",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248225",
        "title": "Regular Work Day",
        "myDayComment": null,
        "tour": {
          "tourId": "10861211",
          "startTime": 1563739200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": "2E WALL A1",
          "tourComment": "CNF 11/1 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563739200,
            "endTime": 1563775200
          },
          "assignments": [
            {
              "jeId": "12137541",
              "startTime": 1563739200,
              "endTime": 1563775200,
              "service": "Audio A1",
              "activityType": "6214",
              "requestNumber": "3786437",
              "jobId": "5083648",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "2E WALL CONTROL - CR 2E / SDO 3A   (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25744",
    "class": "Resource",
    "name": "Burns Molly",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248228",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861214",
          "startTime": 1563199200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852105",
            "mealTime": 1563210000,
            "red": false
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248229",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861215",
          "startTime": 1563285600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248230",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861216",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248231",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861217",
          "startTime": 1563454800,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563454800,
            "endTime": 1563498000
          },
          "assignments": null
        }
      },
      {
        "rdtId": "16248232",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861218",
          "startTime": 1563541200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248233",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861219",
          "startTime": 1563631200,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": null
        }
      },
      {
        "rdtId": "16248234",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861220",
          "startTime": 1563735600,
          "duration": 11,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563735600,
            "endTime": 1563775200
          },
          "assignments": null
        }
      }
    ]
  },
  {
    "rId": "25763",
    "class": "Resource",
    "name": "Francois Jesse",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248237",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861223",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/25 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852114",
            "mealTime": 1563217200,
            "red": false
          },
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136220",
              "startTime": 1563202800,
              "endTime": 1563210000,
              "service": "Audio A1 MITCHELL",
              "activityType": "149M",
              "requestNumber": "3786282",
              "jobId": "5083493",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K /4E FLASH FOR GUESTS - NO PREP"
            },
            {
              "jeId": "12136235",
              "startTime": 1563210000,
              "endTime": 1563212700,
              "service": "Audio A1 STANDBY",
              "activityType": "149M",
              "requestNumber": "3786283",
              "jobId": "5083494",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "2K STANDBY",
              "comment": null
            },
            {
              "jeId": "12136971",
              "startTime": 1563192000,
              "endTime": 1563195600,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786376",
              "jobId": "5083587",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "CR 3A MJ relief/Standby",
              "comment": null
            },
            {
              "jeId": "12137691",
              "startTime": 1563195600,
              "endTime": 1563202800,
              "service": "Audio A1 10 AM",
              "activityType": "149M",
              "requestNumber": "3786463",
              "jobId": "5083674",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 2K /DCNC-N5/4E FLASH FOR GUESTS  (NO PREP)"
            },
            {
              "jeId": "12137713",
              "startTime": 1563212700,
              "endTime": 1563217200,
              "service": "Audio A1 2 PM",
              "activityType": "149M",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248238",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861224",
          "startTime": 1563282000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/19 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135862",
              "startTime": 1563289200,
              "endTime": 1563296400,
              "service": "Audio A1 MITCHELL",
              "activityType": "149M",
              "requestNumber": "3786234",
              "jobId": "5083445",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS - 11AM PREP"
            },
            {
              "jeId": "12136491",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "Audio A1 10 AM",
              "activityType": "149M",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12137255",
              "startTime": 1563304500,
              "endTime": 1563310800,
              "service": "Audio A1 4 PM",
              "activityType": "149M",
              "requestNumber": "3786405",
              "jobId": "5083616",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 3A / STUDIO 3A"
            },
            {
              "jeId": "12137332",
              "startTime": 1563296400,
              "endTime": 1563300000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA149M",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137970",
              "startTime": 1563303600,
              "endTime": 1563304500,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786493",
              "jobId": "5083704",
              "costObject": "NEWSFORCE/DAYSIDE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-NFXX1001.J077",
              "description": "3p - CR 3A - Path Update",
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248239",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861225",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 10/19 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12135674",
              "startTime": 1563372000,
              "endTime": 1563400800,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248240",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861226",
          "startTime": 1563624000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CNF 11/2 - MN",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12137769",
              "startTime": 1563624000,
              "endTime": 1563649200,
              "service": "Audio A1",
              "activityType": "149M",
              "requestNumber": "3786473",
              "jobId": "5083684",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248241",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861227",
          "startTime": 1563717600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "overtime": null,
          "assignments": [
            {
              "jeId": "12136466",
              "startTime": 1563735600,
              "endTime": 1563746400,
              "service": "Audio A1 4 PM",
              "activityType": "149M",
              "requestNumber": "3786312",
              "jobId": "5083523",
              "costObject": "MSNBC 4PM END OPS INTERNAL",
              "costObjectNumber": "T-4PXX1001.J077",
              "description": null,
              "comment": "4PM Live - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137236",
              "startTime": 1563717600,
              "endTime": 1563732000,
              "service": "Audio A1 10 AM",
              "activityType": "149M",
              "requestNumber": "3786402",
              "jobId": "5083613",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 2K / 3A WEST - prep at 11AM"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25764",
    "class": "Resource",
    "name": "Scialabba Michael",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248244",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861230",
          "startTime": 1563199200,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852121",
            "mealTime": 1563213600,
            "red": false
          },
          "overtime": {
            "startTime": 1563199200,
            "endTime": 1563235200
          },
          "assignments": [
            {
              "jeId": "12136993",
              "startTime": 1563199200,
              "endTime": 1563213600,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            },
            {
              "jeId": "12137398",
              "startTime": 1563213600,
              "endTime": 1563235200,
              "service": "Graphics PB Op - Elections",
              "activityType": "149P",
              "requestNumber": "3786418",
              "jobId": "5083629",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248245",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861231",
          "startTime": 1563285600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563285600,
            "endTime": 1563321600
          },
          "assignments": [
            {
              "jeId": "12135964",
              "startTime": 1563285600,
              "endTime": 1563321600,
              "service": "Graphics PB Op - Elections",
              "activityType": "149P",
              "requestNumber": "3786249",
              "jobId": "5083460",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "3A Wall Testing - CR 2E / SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248246",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861232",
          "startTime": 1563372000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563372000,
            "endTime": 1563408000
          },
          "assignments": [
            {
              "jeId": "12135675",
              "startTime": 1563372000,
              "endTime": 1563386400,
              "service": "Graphics PB Op L3 - FRO",
              "activityType": "149P",
              "requestNumber": "3786216",
              "jobId": "5083427",
              "costObject": "Specials",
              "costObjectNumber": "J0A304003",
              "description": null,
              "comment": "KORNACKI Digital Show - 2K CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248247",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861233",
          "startTime": 1563451200,
          "duration": 12,
          "remainDuration": null,
          "notificationComment": "wall",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563451200,
            "endTime": 1563494400
          }
        }
      },
      {
        "rdtId": "16248248",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861234",
          "startTime": 1563537600,
          "duration": 15,
          "remainDuration": null,
          "notificationComment": "ELEX",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563537600,
            "endTime": 1563591600
          }
        }
      },
      {
        "rdtId": "16248249",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861235",
          "startTime": 1563609600,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563609600,
            "endTime": 1563645600
          }
        }
      },
      {
        "rdtId": "16248250",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861236",
          "startTime": 1563696000,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563696000,
            "endTime": 1563732000
          }
        }
      }
    ]
  },
  {
    "rId": "25809",
    "class": "Resource",
    "name": "Caraballo Juan",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248633",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861592",
          "startTime": 1563382800,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852476",
            "mealTime": 1563408000,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136013",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "ST",
              "activityType": "148E",
              "requestNumber": "3786258",
              "jobId": "5083469",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2E / 3A SDO"
            },
            {
              "jeId": "12136632",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248634",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861593",
          "startTime": 1563724800,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "Ped/Jib",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563724800,
            "endTime": 1563757200
          },
          "assignments": [
            {
              "jeId": "12136720",
              "startTime": 1563746400,
              "endTime": 1563757200,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786345",
              "jobId": "5083556",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "MSNBC Election Night - CR 3A / SDO 3A WEST (MEAL PERIOD TBD - CHECK WITH TM)"
            },
            {
              "jeId": "12137905",
              "startTime": 1563724800,
              "endTime": 1563735600,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137940",
              "startTime": 1563739200,
              "endTime": 1563746400,
              "service": "PD",
              "activityType": "148E",
              "requestNumber": "3786489",
              "jobId": "5083700",
              "costObject": "MSNBC 5PM END OPS INTERNAL",
              "costObjectNumber": "T-5PXX1001.J077",
              "description": null,
              "comment": "MTP Daily - 5p Live - CR 2K / 3A WEST"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25821",
    "class": "Resource",
    "name": "Saphyr Vladimyr",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248253",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861239",
          "startTime": 1563183000,
          "duration": 8.5,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "meal": {
            "mealId": "9852130",
            "mealTime": 1563195600,
            "red": false
          },
          "overtime": {
            "startTime": 1563183000,
            "endTime": 1563213600
          },
          "assignments": [
            {
              "jeId": "12136927",
              "startTime": 1563183000,
              "endTime": 1563195600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786371",
              "jobId": "5083582",
              "costObject": "MORNING JOE MSNBC ENG OPS INTERNAL",
              "costObjectNumber": "T-MJXX1001.J077",
              "description": null,
              "comment": "9AM MJ CR READ THROUGH"
            },
            {
              "jeId": "12137001",
              "startTime": 1563199200,
              "endTime": 1563213600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786380",
              "jobId": "5083591",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "Digital Show - 2E CR/ 4E Town Square"
            }
          ]
        }
      },
      {
        "rdtId": "16248254",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861240",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONFK P",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136500",
              "startTime": 1563282000,
              "endTime": 1563289200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786314",
              "jobId": "5083525",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A/ REMOTE (Florida) /4E FLASH FOR GUESTS   3E for backup anchor - prep 9a"
            },
            {
              "jeId": "12136623",
              "startTime": 1563292800,
              "endTime": 1563303600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786328",
              "jobId": "5083539",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            },
            {
              "jeId": "12137333",
              "startTime": 1563278400,
              "endTime": 1563282000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137334",
              "startTime": 1563289200,
              "endTime": 1563292800,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248255",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861241",
          "startTime": 1563372000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135929",
              "startTime": 1563382800,
              "endTime": 1563390000,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786242",
              "jobId": "5083453",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / 4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12136014",
              "startTime": 1563390000,
              "endTime": 1563397200,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786258",
              "jobId": "5083469",
              "costObject": "MSNBC Pol Cvg 2018",
              "costObjectNumber": "NM-S18.008",
              "description": null,
              "comment": "Elections - CR 2E / 3A SDO"
            },
            {
              "jeId": "12136631",
              "startTime": 1563372000,
              "endTime": 1563382800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786329",
              "jobId": "5083540",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "Viz Multiplay rehearsal for Election walls - 3A SDO / CR 2E"
            }
          ]
        }
      },
      {
        "rdtId": "16248256",
        "title": "Overtime Day(6d, 7d)",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861242",
          "startTime": 1563539400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137449",
              "startTime": 1563539400,
              "endTime": 1563564600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786426",
              "jobId": "5083637",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW REHEARSAL - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      },
      {
        "rdtId": "16248257",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861243",
          "startTime": 1563638400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12137108",
              "startTime": 1563638400,
              "endTime": 1563642000,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786393",
              "jobId": "5083604",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            },
            {
              "jeId": "12137409",
              "startTime": 1563642000,
              "endTime": 1563652800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786421",
              "jobId": "5083632",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Rehearsal - CR 8H / 4E TOWN SQUARE"
            },
            {
              "jeId": "12137551",
              "startTime": 1563652800,
              "endTime": 1563663600,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786439",
              "jobId": "5083650",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELEX BLOCKING 3A STUDIO / 3A CONTROL"
            }
          ]
        }
      },
      {
        "rdtId": "16248258",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861244",
          "startTime": 1563710400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": "emd",
          "tourComment": null,
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135836",
              "startTime": 1563710400,
              "endTime": 1563717600,
              "service": "PR 2K MS",
              "activityType": "148E",
              "requestNumber": "3786231",
              "jobId": "5083442",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 3A/ 3A SDO"
            },
            {
              "jeId": "12137899",
              "startTime": 1563724800,
              "endTime": 1563735600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786486",
              "jobId": "5083697",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 3A WEST"
            },
            {
              "jeId": "12137923",
              "startTime": 1563717600,
              "endTime": 1563724800,
              "service": "UT",
              "activityType": "148E",
              "requestNumber": "3786488",
              "jobId": "5083699",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /STUDIO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248886",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861794",
          "startTime": 1563771600,
          "duration": 9,
          "remainDuration": null,
          "notificationComment": "prompter/ re-emd till 10am",
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "NS",
            "OT"
          ],
          "overtime": {
            "startTime": 1563771600,
            "endTime": 1563804000
          },
          "assignments": [
            {
              "jeId": "12136713",
              "startTime": 1563771600,
              "endTime": 1563775200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786344",
              "jobId": "5083555",
              "costObject": "MSNBC Inside Election Night 2018",
              "costObjectNumber": "NM-S18.035",
              "description": null,
              "comment": "ELECTIONS OVERNIGHT CREW - 3A CONTROL / 3A STUDIO  (MEAL PERIOD TBD - CHECK WITH TM)"
            }
          ]
        }
      }
    ]
  },
  {
    "rId": "25862",
    "class": "Resource",
    "name": "D'Agosto Daniel",
    "empCat": "Daily Hire",
    "rType": "4",
    "dayTypes": [
      {
        "rdtId": "16248268",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861254",
          "startTime": 1563192000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "meal": {
            "mealId": "9852145",
            "mealTime": 1563217200,
            "red": false
          },
          "assignments": [
            {
              "jeId": "12136952",
              "startTime": 1563192000,
              "endTime": 1563199200,
              "service": "PR 2K MS",
              "activityType": "148E",
              "requestNumber": "3786374",
              "jobId": "5083585",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137706",
              "startTime": 1563206400,
              "endTime": 1563213600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786464",
              "jobId": "5083675",
              "costObject": "MSNBC 1PM END OPS INTERNAL",
              "costObjectNumber": "T-1PXX1001.J077",
              "description": null,
              "comment": "1PM LIVE - CR 2K / 4E FLASH"
            },
            {
              "jeId": "12137717",
              "startTime": 1563213600,
              "endTime": 1563217200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786465",
              "jobId": "5083676",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 2K / 4E FLASH"
            }
          ]
        }
      },
      {
        "rdtId": "16248269",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861255",
          "startTime": 1563278400,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "CONF KP",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135871",
              "startTime": 1563296400,
              "endTime": 1563303600,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786235",
              "jobId": "5083446",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / 4E FLASH"
            },
            {
              "jeId": "12135893",
              "startTime": 1563278400,
              "endTime": 1563285600,
              "service": "PR 2K MS",
              "activityType": "148E",
              "requestNumber": "3786237",
              "jobId": "5083448",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12136512",
              "startTime": 1563285600,
              "endTime": 1563292800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786315",
              "jobId": "5083526",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137335",
              "startTime": 1563292800,
              "endTime": 1563296400,
              "service": "AVAILABLE MSNBC",
              "activityType": "UA148E",
              "requestNumber": "3786409",
              "jobId": "5083620",
              "costObject": "Available- MSNBC",
              "costObjectNumber": "WT-67854",
              "description": null,
              "comment": null
            }
          ]
        }
      },
      {
        "rdtId": "16248270",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861256",
          "startTime": 1563364800,
          "duration": 10,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX",
            "OT"
          ],
          "overtime": {
            "startTime": 1563364800,
            "endTime": 1563400800
          },
          "assignments": [
            {
              "jeId": "12136557",
              "startTime": 1563379200,
              "endTime": 1563382800,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786320",
              "jobId": "5083531",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A /4E FLASH FOR GUESTS"
            },
            {
              "jeId": "12137361",
              "startTime": 1563364800,
              "endTime": 1563372000,
              "service": "PR 2K MS",
              "activityType": "148E",
              "requestNumber": "3786412",
              "jobId": "5083623",
              "costObject": "MSNBC 9AM END OPS INTERNAL",
              "costObjectNumber": "T-9AXX1001.J077",
              "description": null,
              "comment": "9AM LIVE - CR 2K /4E FLASH - 8AM PREP"
            },
            {
              "jeId": "12137376",
              "startTime": 1563372000,
              "endTime": 1563379200,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786413",
              "jobId": "5083624",
              "costObject": "MSNBC 11AM END OPS INTERNAL",
              "costObjectNumber": "T-11AX1001.J077",
              "description": null,
              "comment": "11AM LIVE - CR 3A /4E FLASH"
            },
            {
              "jeId": "12137474",
              "startTime": 1563393600,
              "endTime": 1563395400,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786430",
              "jobId": "5083641",
              "costObject": "CHRIS HAYES ALL IN- ENG OPS INTERNAL",
              "costObjectNumber": "T-OMXX1001.J077",
              "description": null,
              "comment": "Hayes Pretape - 4E Town Square / CR 2K"
            }
          ]
        }
      },
      {
        "rdtId": "16248271",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861257",
          "startTime": 1563627600,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "conf kp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12135768",
              "startTime": 1563634800,
              "endTime": 1563642000,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786225",
              "jobId": "5083436",
              "costObject": "ANDREA MITCHELL END OPS INTERNAL",
              "costObjectNumber": "T-AMXX1001.J077",
              "description": null,
              "comment": "12PM LIVE - CR 3A / SDO 3A"
            },
            {
              "jeId": "12136411",
              "startTime": 1563642000,
              "endTime": 1563649200,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786308",
              "jobId": "5083519",
              "costObject": "MSNBC 2PM END OPS INTERNAL",
              "costObjectNumber": "T-2PXX1001.J077",
              "description": null,
              "comment": "2PM LIVE - CR 3A / REMOTE (Georgia) / SDO 3A FOR GUESTS"
            },
            {
              "jeId": "12137145",
              "startTime": 1563649200,
              "endTime": 1563652800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786395",
              "jobId": "5083606",
              "costObject": "MSNBC 3PM END OPS INTERNAL",
              "costObjectNumber": "T-3PXX1001.J077",
              "description": null,
              "comment": "3PM Live - CR 3A / SDO 3A"
            },
            {
              "jeId": "12137861",
              "startTime": 1563627600,
              "endTime": 1563634800,
              "service": "PR 3A MS",
              "activityType": "148E",
              "requestNumber": "3786481",
              "jobId": "5083692",
              "costObject": "MSNBC 10AM END OPS INTERNAL",
              "costObjectNumber": "T-10AX1001.J077",
              "description": null,
              "comment": "10A Live - CR 3A / REMOTE (Cleveland) / BACK UP IN SDO 3A"
            }
          ]
        }
      },
      {
        "rdtId": "16248272",
        "title": "Regular Work Day",
        "myDayComment": null,
        "dayOff": null,
        "tour": {
          "tourId": "10861258",
          "startTime": 1563732000,
          "duration": 8,
          "remainDuration": null,
          "notificationComment": null,
          "tourComment": "confkp",
          "myTourComment": null,
          "tourIndicator": null,
          "tourPayTransactions": [
            "FB",
            "FX"
          ],
          "assignments": [
            {
              "jeId": "12136600",
              "startTime": 1563735600,
              "endTime": 1563760800,
              "service": "PR",
              "activityType": "148E",
              "requestNumber": "3786326",
              "jobId": "5083537",
              "costObject": "Signal General",
              "costObjectNumber": "J0A304001",
              "description": null,
              "comment": "OTT Live Show - CR 8H / 4E TOWN SQUARE"
            }
          ]
        }
      }
    ]
  },
  {
    "class": "Resource",
    "name": null,
    "empCat": null,
    "rType": null,
    "dayTypes": null
  }
]

export default testSched_9Day_num1;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/test-data/test-data-nine.js